(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode("._message-c2c-container_14m8l_1{display:flex;flex-direction:row;align-items:center;word-break:break-all}._message-c2c-container_14m8l_1 ._call-content_14m8l_7{padding-left:8px}._message-c2c-container_14m8l_1._c2c_14m8l_10{cursor:pointer}._message-c2c-container_14m8l_1 ._icon_14m8l_13{width:20px;height:20px}._message-group-container_hjjzg_1._group_hjjzg_1{cursor:default}.tk-time{font-family:PingFang SC;font-size:16px;font-weight:500;line-height:20px;letter-spacing:0px;text-align:center;color:#fff}.tk-row-container{width:100%;box-sizing:border-box;margin:0;padding:0;list-style:none;display:flex;flex-flow:row wrap;flex-direction:row;flex-wrap:nowrap}.tk-row-container.tk-row-justify-left{justify-content:flex-start}.tk-row-container.tk-row-justify-center{justify-content:center}.tk-row-container.tk-row-justify-right{justify-content:flex-end}.tk-col-container{display:flex;box-sizing:border-box;overflow:hidden;align-items:center}.tk-col-container.tk-col-justify-content-start{justify-content:flex-start}.tk-col-container.tk-col-justify-content-center{justify-content:center}.tk-col-container.tk-col-justify-content-end{justify-content:flex-end}.tk-col-container.tk-col-align-items-start{align-items:flex-start}.tk-col-container.tk-col-align-items-center{align-items:center}.tk-col-container.tk-col-align-items-end{align-items:flex-end}.tk-col-12{flex:0 0 100%;max-width:100%}.tk-col-push-12{left:100%}.tk-col-pull-12{right:100%}.tk-col-offset-12{margin-left:100%}.tk-col-order-12{order:12}.tk-col-11{flex:0 0 91.6666666667%;max-width:91.6666666667%}.tk-col-push-11{left:91.6666666667%}.tk-col-pull-11{right:91.6666666667%}.tk-col-offset-11{margin-left:91.6666666667%}.tk-col-order-11{order:11}.tk-col-10{flex:0 0 83.3333333333%;max-width:83.3333333333%}.tk-col-push-10{left:83.3333333333%}.tk-col-pull-10{right:83.3333333333%}.tk-col-offset-10{margin-left:83.3333333333%}.tk-col-order-10{order:10}.tk-col-9{flex:0 0 75%;max-width:75%}.tk-col-push-9{left:75%}.tk-col-pull-9{right:75%}.tk-col-offset-9{margin-left:75%}.tk-col-order-9{order:9}.tk-col-8{flex:0 0 66.6666666667%;max-width:66.6666666667%}.tk-col-push-8{left:66.6666666667%}.tk-col-pull-8{right:66.6666666667%}.tk-col-offset-8{margin-left:66.6666666667%}.tk-col-order-8{order:8}.tk-col-7{flex:0 0 58.3333333333%;max-width:58.3333333333%}.tk-col-push-7{left:58.3333333333%}.tk-col-pull-7{right:58.3333333333%}.tk-col-offset-7{margin-left:58.3333333333%}.tk-col-order-7{order:7}.tk-col-6{flex:0 0 50%;max-width:50%}.tk-col-push-6{left:50%}.tk-col-pull-6{right:50%}.tk-col-offset-6{margin-left:50%}.tk-col-order-6{order:6}.tk-col-5{flex:0 0 41.6666666667%;max-width:41.6666666667%}.tk-col-push-5{left:41.6666666667%}.tk-col-pull-5{right:41.6666666667%}.tk-col-offset-5{margin-left:41.6666666667%}.tk-col-order-5{order:5}.tk-col-4{flex:0 0 33.3333333333%;max-width:33.3333333333%}.tk-col-push-4{left:33.3333333333%}.tk-col-pull-4{right:33.3333333333%}.tk-col-offset-4{margin-left:33.3333333333%}.tk-col-order-4{order:4}.tk-col-3{flex:0 0 25%;max-width:25%}.tk-col-push-3{left:25%}.tk-col-pull-3{right:25%}.tk-col-offset-3{margin-left:25%}.tk-col-order-3{order:3}.tk-col-2{flex:0 0 16.6666666667%;max-width:16.6666666667%}.tk-col-push-2{left:16.6666666667%}.tk-col-pull-2{right:16.6666666667%}.tk-col-offset-2{margin-left:16.6666666667%}.tk-col-order-2{order:2}.tk-col-1{flex:0 0 8.3333333333%;max-width:8.3333333333%}.tk-col-push-1{left:8.3333333333%}.tk-col-pull-1{right:8.3333333333%}.tk-col-offset-1{margin-left:8.3333333333%}.tk-col-order-1{order:1}.tk-col-0{display:none}.tk-col-push-0{left:auto}.tk-col-pull-0{right:auto}.tk-col-offset-0{margin-left:0}.tk-col-order-0{order:0}.tk-circle-container{width:30px;height:30px;margin:0 auto;position:absolute;z-index:1}.tk-circle-container .tk-circle-loading{animation:spin 1s linear infinite}@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.tk-circle-container svg{height:100%;width:100%}.tk-dot-container{position:absolute;display:flex;justify-content:space-between;align-items:center;width:50px;height:50px;margin:0 auto;z-index:1}.tk-dot-container .dot:nth-child(1){opacity:0;animation-duration:.8s;animation-delay:0s;animation-play-state:running}.tk-dot-container .dot:nth-child(2){opacity:.083;animation-duration:.8s;animation-delay:.2666666667s;animation-play-state:running}.tk-dot-container .dot:nth-child(3){opacity:.1667;animation-duration:.8s;animation-delay:.5333333333s;animation-play-state:running}.tk-dot-container .dot{width:20%;height:20%;border-radius:50%;background-color:currentColor;animation-duration:1.8s;animation-name:dotting;animation-timing-function:linear;animation-iteration-count:infinite;animation-fill-mode:both;color:#fff}@keyframes dotting{0%{opacity:.15}1%{opacity:.8}33%{opacity:.8}34%{opacity:.15}to{opacity:.15}}.tk-overlayer-container{position:absolute;width:100%;height:100%}.tk-overlayer-container .overlay{position:absolute;width:100%;height:100%;background-color:#22262e99}.tk-loading-container{display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;width:100%;height:100%;background:none}.tk-loading-container.tk-loading-overlayer{position:absolute;width:100%;height:100%;background-color:#22262e99}.tk-btn-container{display:flex;color:#fff;transition-property:width,height,left,top;transition-duration:.3s;transition-timing-function:ease-in}.tk-btn-container.pc{cursor:pointer}.tk-btn-container.tk-flex-vertical{flex-direction:column;align-items:center}.tk-btn-container.tk-flex-vertical.tk-size-s.pc{height:auto;width:20px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-vertical.tk-size-s.pc .tk-icon{width:20px;height:20px}.tk-btn-container.tk-flex-vertical.tk-size-s.pc .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-vertical.tk-size-s.pc .tk-loading{font-size:20px}.tk-btn-container.tk-flex-vertical.tk-size-s.mobile{height:auto;width:40px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-vertical.tk-size-s.mobile .tk-icon{width:40px;height:40px}.tk-btn-container.tk-flex-vertical.tk-size-s.mobile .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-vertical.tk-size-s.mobile .tk-loading{font-size:40px}.tk-btn-container.tk-flex-vertical.tk-size-m.pc{height:auto;width:60px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-vertical.tk-size-m.pc .tk-icon{width:60px;height:60px}.tk-btn-container.tk-flex-vertical.tk-size-m.pc .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-vertical.tk-size-m.pc .tk-loading{font-size:60px}.tk-btn-container.tk-flex-vertical.tk-size-m.pc .tk-icon{width:40px;height:40px}.tk-btn-container.tk-flex-vertical.tk-size-m.mobile{height:auto;width:60px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-vertical.tk-size-m.mobile .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-vertical.tk-size-m.mobile .tk-loading{font-size:60px}.tk-btn-container.tk-flex-vertical.tk-size-m.mobile .tk-icon{width:60px;height:60px}.tk-btn-container.tk-flex-vertical.tk-size-l.pc{height:auto;width:60px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-vertical.tk-size-l.pc .tk-icon{width:60px;height:60px}.tk-btn-container.tk-flex-vertical.tk-size-l.pc .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-vertical.tk-size-l.pc .tk-loading{font-size:60px}.tk-btn-container.tk-flex-vertical.tk-size-l.mobile{height:auto;width:80px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-vertical.tk-size-l.mobile .tk-icon{width:80px;height:80px}.tk-btn-container.tk-flex-vertical.tk-size-l.mobile .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-vertical.tk-size-l.mobile .tk-loading{font-size:80px}.tk-btn-container.tk-flex-horizontal{flex-direction:row;align-items:center}.tk-btn-container.tk-flex-horizontal.tk-size-s{height:36px;width:12px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-horizontal.tk-size-s .tk-icon{width:12px;height:12px}.tk-btn-container.tk-flex-horizontal.tk-size-s .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-horizontal.tk-size-s .tk-loading{font-size:12px}.tk-btn-container.tk-flex-horizontal.tk-size-m{height:40px;width:16px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-horizontal.tk-size-m .tk-icon{width:16px;height:16px}.tk-btn-container.tk-flex-horizontal.tk-size-m .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-horizontal.tk-size-m .tk-loading{font-size:16px}.tk-btn-container.tk-flex-horizontal.tk-size-l{height:60px;width:18px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container.tk-flex-horizontal.tk-size-l .tk-icon{width:18px;height:18px}.tk-btn-container.tk-flex-horizontal.tk-size-l .tk-icon .img{width:100%;height:100%}.tk-btn-container.tk-flex-horizontal.tk-size-l .tk-loading{font-size:18px}.tk-btn-container.tk-ghost{background:none}.tk-btn-container .tk-content{margin-top:8px;text-align:center;line-height:15px;font-style:normal;font-weight:400;max-height:30px;overflow:hidden;-webkit-user-select:none;user-select:none}.tk-btn-container .tk-icon{transition-property:width,height,left,top;transition-duration:.3s;transition-timing-function:ease-in}.tk-btn-container .tk-icon.tk-size-s{height:36px;width:12px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container .tk-icon.tk-size-s .tk-icon{width:12px;height:12px}.tk-btn-container .tk-icon.tk-size-s .tk-icon .img{width:100%;height:100%}.tk-btn-container .tk-icon.tk-size-s .tk-loading{font-size:12px}.tk-btn-container .tk-icon.tk-size-m{height:40px;width:16px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container .tk-icon.tk-size-m .tk-icon{width:16px;height:16px}.tk-btn-container .tk-icon.tk-size-m .tk-icon .img{width:100%;height:100%}.tk-btn-container .tk-icon.tk-size-m .tk-loading{font-size:16px}.tk-btn-container .tk-icon.tk-size-l{height:60px;width:18px;font-size:12px;padding-left:0;padding-right:0}.tk-btn-container .tk-icon.tk-size-l .tk-icon{width:18px;height:18px}.tk-btn-container .tk-icon.tk-size-l .tk-icon .img{width:100%;height:100%}.tk-btn-container .tk-icon.tk-size-l .tk-loading{font-size:18px}._minimize-desk-container_gxy8f_1{margin-right:10px;width:20px!important;height:20px!important}._minimize-desk-container_gxy8f_1 .tk-icon{width:20px!important;height:20px!important}._minimize-mobile-container_gxy8f_11{margin-left:10px;width:24px!important;height:24px!important}._minimize-mobile-container_gxy8f_11 .tk-icon{width:24px!important;height:24px!important}.tk-message-container{display:flex;flex-direction:row;align-items:center;width:fit-content;margin-bottom:10px;border-radius:6px;box-shadow:0 6px 16px #00000014,0 3px 6px -4px #0000001f,0 9px 28px 8px #0000000d;padding:10px}[data-uikit-theme=light] .tk-message-container{background-color:var(--uikit-theme-light-toast-color-default);color:var(--uikit-theme-light-text-color-primary);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] .tk-message-container{background-color:var(--uikit-theme-dark-toast-color-default);color:var(--uikit-theme-dark-text-color-primary);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=light] .tk-message-container svg{margin-right:4px;fill:var(--uikit-theme-light-text-color-primary);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] .tk-message-container svg{margin-right:4px;fill:var(--uikit-theme-dark-text-color-primary);transition:background-color .3s ease-out,border-color .3s ease-out}.tk-message-container.tk-message-plaintext{background:none;border:0;box-shadow:none;margin:0;padding:0;color:#f7f8fa}.tk-message-container .tk-message-icon{width:1em!important;height:1em!important}.tk-message-container .tk-message-icon.tip-icon{margin-right:8px}.tk-message-container .tk-message-icon.close-icon{margin-left:24px}.message-list-container{top:0;position:fixed;left:0;width:100%;display:flex;justify-content:center}._top-bar-container_1m8fv_1{width:100%;height:5.8%;position:absolute;display:flex;align-items:center;z-index:5}._top-bar-container_1m8fv_1 ._top-bar_1m8fv_1{height:24px}._full-screen-container_16bjq_1{width:20px!important;height:20px!important;margin-right:10px}._full-screen-container_16bjq_1 .tk-icon{line-height:20px;width:20px!important;height:20px!important}._single-top-bar_15cxx_1{position:absolute;width:100%;height:20px;line-height:20px;margin-top:20px;z-index:2}._btn-icon_zmhpj_1{width:50%!important;height:50%!important}._btn-icon-container_zmhpj_6{display:flex;align-items:center;justify-content:center;border-radius:50%;border:0px;background-color:#fff}._btn-icon-container_zmhpj_6.close,._btn-icon-container_zmhpj_6.disabled{background-color:#6b758a4d}._arrow-btn_zmhpj_21{padding:4px;width:12px!important;height:12px!important;margin:20px 0 0;transform:translateY(-50%)}._arrow-btn_zmhpj_21 .tk-icon{width:12px!important;height:12px!important}._tk-btn_zmhpj_33{transition-property:width,height,left,top;transition-duration:.3s;transition-timing-function:ease-in;width:70px!important}._accept-icon-container_2gkee_1{background-color:#51c271}._reject-icon-container_15q4l_1{background-color:#ed4651}.tk-popup__arrow{left:50%;width:10px;height:10px;z-index:-1;margin-top:-3px;position:absolute;background-color:#6b758a80;box-shadow:0 0 4px #ffffff40 inset;backdrop-filter:blur(15px);-webkit-backdrop-filter:blur(15px);transform:rotate(45deg) translate(-50%);border-top-left-radius:100%}.tk-popup__content{background-color:#6b758a80;box-shadow:0 0 4px #ffffff40 inset;backdrop-filter:blur(15px);-webkit-backdrop-filter:blur(15px);border-radius:6px;padding:3px;font-size:14px;color:#fff}._device-selector-container_caues_1{width:180px;display:flex;flex-direction:column;align-items:center;padding:6px;font-weight:500}._device-selector-container_caues_1 ._device-item_caues_9{width:100%;overflow:hidden;padding:5px 3px;text-overflow:ellipsis;white-space:nowrap;font-size:14px;text-align:left;line-height:20px;cursor:pointer}._device-selector-container_caues_1 ._device-item_caues_9._control-item_caues_20{border-top:1px solid rgba(255,255,255,.2);padding-left:6px}._device-selector-container_caues_1 ._device-item_caues_9._btn_caues_24{border-top:1px solid rgba(255,255,255,.2)}._device-selector-container_caues_1 ._device-item_caues_9:hover{border-radius:5px;background:rgba(255,255,255,.3215686275)}._device-selector-container_caues_1 ._device-item_caues_9._select_caues_31{background-color:#0f101433;border-radius:3px}._scroll-container_caues_36{width:100%;overflow:hidden;border-radius:3px}._scroll-container_caues_36 ._scroll-content_caues_41{max-height:60px;margin-right:-20px;overflow:hidden auto;padding-right:20px}._hangup-icon-container_1o1xr_1{background-color:#ed4651}._background-blur-icon-container_12dh2_1{background-color:#fff}._background-blur-icon-container_12dh2_1._close_12dh2_4{background-color:#6b758a4d}._button-panel-h5-container_1a79k_1{display:flex;flex-direction:column;align-items:center;position:absolute;box-sizing:border-box;bottom:0;width:100%;height:14%;border-radius:10px 10px 0 0;z-index:5;transition-property:width,height,left,top;transition-duration:.3s;transition-timing-function:ease-in}._button-panel-h5-container_1a79k_1._groupcall_1a79k_16{background:none}._button-panel-h5-container_1a79k_1._groupcall_1a79k_16._show-panel-background_1a79k_19{background-color:#4f586b8a}._button-panel-h5-container_1a79k_1._open_1a79k_22{height:27%}._button-panel-h5-container_1a79k_1 ._singlecall-panel_1a79k_25{width:72%;max-width:400px;position:absolute;bottom:6vh}._button-panel-h5-container_1a79k_1 ._groupcall-panel_1a79k_31{width:72%;position:absolute;top:6%}._button-panel-h5-container_1a79k_1 ._groupcall-panel_1a79k_31._close_1a79k_36{top:27%;margin-left:9.3vw}._button-panel-h5-container_1a79k_1 ._toggle-panel-btn_1a79k_40{position:absolute;left:8.2vw;bottom:6vh;z-index:1}._button-panel-h5-container_1a79k_1 ._toggle-panel-btn_1a79k_40._close_1a79k_36{width:8vw!important;height:8vw!important;top:32%}._button-panel-h5-container_1a79k_1 ._toggle-panel-btn_1a79k_40._close_1a79k_36 .prefix-icon{width:8vw!important;height:8vw!important}._button-panel-pc-container_x4npp_1{position:absolute;width:55%;margin:0 auto;bottom:6%;left:50%;z-index:2;transform:translate(-50%)}.tk-avatar-container{display:flex;align-items:center;justify-content:center;border:0px;padding:0;overflow:hidden;background-color:#fff}.tk-avatar-container.tk-avatar-shape-round{border-radius:6px}.tk-avatar-container.tk-avatar-shape-circle{border-radius:50%}.tk-avatar-container img{width:100%;height:100%;object-fit:fill}._microphone-container_nczz7_1{height:20px;width:20px;flex-shrink:0}._microphone-container_nczz7_1 svg{width:100%;height:100%}._overlay-stream-container_eicsw_1{width:100%;height:100%;position:absolute;top:0}._overlay-stream-container_eicsw_1 ._blur_eicsw_7{width:100%;height:100%;left:0;top:0;position:absolute}._overlay-stream-container_eicsw_1 ._blur_eicsw_7 .overlay{background-color:#22262ed9;backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px)}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19{position:absolute;display:flex;flex-direction:column;align-content:center;align-items:center;justify-content:center;width:100%;height:100%;z-index:1;color:#fff}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._avatar_eicsw_31{width:100px;height:100px}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._avatar_eicsw_31._float_eicsw_35,._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._avatar_eicsw_31._small_eicsw_39{width:40px;height:40px}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._avatar_eicsw_31._small_eicsw_39._float_eicsw_35{width:20px;height:20px}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._username_eicsw_47{display:flex;flex-direction:row;align-items:center;justify-content:center;width:100%}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._username_eicsw_47 ._nick_eicsw_54{text-align:center;font-family:PingFang SC;font-size:40px;font-style:normal;font-weight:500;line-height:normal;max-width:50%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._username_eicsw_47 ._nick_eicsw_54._float_eicsw_35,._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._username_eicsw_47 ._nick_eicsw_54._small_eicsw_39{font-size:20px}._overlay-stream-container_eicsw_1._pc_eicsw_19 ._user-info-container_eicsw_19 ._username_eicsw_47 ._nick_eicsw_54._small_eicsw_39._float_eicsw_35{font-size:12px}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19{position:absolute;display:flex;flex-direction:column;align-content:center;align-items:center;top:26%;width:100%;z-index:1;color:#fff}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._avatar_eicsw_31{width:100px;height:100px}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._avatar_eicsw_31._float_eicsw_35,._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._avatar_eicsw_31._small_eicsw_39{width:40px;height:40px}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._avatar_eicsw_31._small_eicsw_39._float_eicsw_35{width:20px;height:20px}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._username_eicsw_47{display:flex;flex-direction:row;align-items:center;justify-content:center;width:100%}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._username_eicsw_47 ._nick_eicsw_54{text-align:center;text-shadow:0px 2px 4px rgba(15,16,20,.5);margin-top:12px;font-family:PingFang SC;font-size:18px;font-style:normal;font-weight:500;line-height:normal;max-width:50%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._username_eicsw_47 ._nick_eicsw_54._small_eicsw_39{font-size:15px}._overlay-stream-container_eicsw_1._mobile_eicsw_78 ._user-info-container_eicsw_19 ._tip_eicsw_129{margin-top:12px}._singlecall-waiting-container_pmvxi_1{z-index:1}.tk-togglewindow-container{position:relative;width:100%;height:100%;border-radius:6px}.tk-togglewindowitem-container{position:absolute;border-radius:12px;overflow:hidden}.tk-togglewindowitem-container.mobile{border-radius:0}.tk-togglewindowitem-container.tk-togglewindowitem-big{top:0;left:0;right:0;bottom:0;width:100%;height:100%;background-color:#22262e}.tk-togglewindowitem-container.tk-togglewindowitem-small{top:2%;left:2%;width:22%;height:21%;z-index:2;border-radius:12px;background-color:#22262e}.tk-togglewindowitem-container.tk-togglewindowitem-small.mobile{width:24.3%;height:19.7%;border-radius:5px;left:98%;position:absolute;top:8%;transform:translate(-100%)}.tk-text{display:inline-block;overflow:hidden;text-align:center;line-height:normal;white-space:nowrap}.tk-text.tk-text--line-clamp{display:-webkit-inline-box;-webkit-box-orient:vertical;white-space:normal}._stream-info-container-h5_lq9pw_1{width:calc(100% - 16px);display:flex;z-index:1;position:absolute;left:0;bottom:0;color:#fff;text-wrap:nowrap;background-color:#000;margin:8px;background:none}._stream-info-container-h5_lq9pw_1._single_lq9pw_14{height:20px}._stream-info-container-pc_1wp66_1{width:100%;height:25px;display:flex;z-index:1;position:absolute;left:0;bottom:0;color:#fff;text-wrap:nowrap;background:none;justify-content:space-between}._stream-info-container-pc_1wp66_1 ._stream-info-content_1wp66_14{display:flex;max-width:40%;flex-direction:row;align-content:center;align-items:center;background-color:#000000a6;padding:2px 10px}._stream-info-container-pc_1wp66_1 ._stream-info-content_1wp66_14 ._nick_1wp66_23{overflow:hidden;text-overflow:ellipsis}._stream-info-container-pc_1wp66_1 ._stream-info-netWork_1wp66_27{width:20px;height:20px}._player-container_dbx2c_1,._pusher-container_di26f_1{width:100%;height:100%;position:relative;background-color:#4c515a}._single-stream-container_1bung_1{width:100%;height:100%;position:absolute;z-index:0}._single-stream-container_1bung_1._pc_1bung_7{border-radius:12px;background-color:#00183c;overflow:hidden}._single-stream-container_1bung_1._pc_1bung_7 ._single-call-audio-stream_1bung_12 .overlay{border-radius:12px;overflow:hidden}._single-stream-container_1bung_1._float_1bung_16{position:absolute;visibility:hidden}._single-container_1l7n2_1{width:100%;height:100%}._single-container_1l7n2_1 ._singlecall-tip_1l7n2_5{position:absolute;top:56%;left:50%;transform:translate(-50%);z-index:5}._single-container_1l7n2_1._mobile_1l7n2_12{animation:_pulldown_1l7n2_1 .5s linear}._single-container_1l7n2_1._mobile_1l7n2_12 ._singlecall-tip_1l7n2_5{position:absolute;max-width:80%;top:53.6vh;left:50%;transform:translate(-50%);z-index:5}@keyframes _pulldown_1l7n2_1{0%{transform:translateY(-100%)}to{transform:translateY(0)}}._groupcall-waiting-container_10pm9_1{z-index:1}._waiting-mobile_10pm9_5 ._tip_10pm9_5{color:#fff;z-index:1}._waiting-mobile_10pm9_5 ._groupcall-info_10pm9_9{display:flex;flex-direction:column;align-items:center;margin-top:24px;z-index:1;color:#fff;width:100%}._waiting-mobile_10pm9_5 ._groupcall-info_10pm9_9 ._tip_10pm9_5{text-align:center}._waiting-mobile_10pm9_5 ._groupcall-info_10pm9_9 ._avatar-group_10pm9_21{display:flex;flex-wrap:wrap;margin-top:12px;align-items:center;justify-content:center;max-width:70%}._waiting-mobile_10pm9_5 ._groupcall-info_10pm9_9 ._avatar-group_10pm9_21 ._avatar-item_10pm9_29{width:10vw;height:10vw;margin-left:10px;margin-top:10px}.tk-gridplus-item-container{transition-property:width,height,left,top;transition-duration:.3s;transition-timing-function:ease-in}.tk-gridplus-item-container.center{transform:translate(50%)}._stream-container_14fkp_1{width:100%;height:100%;position:absolute;z-index:1}._stream-container_14fkp_1._mobile_14fkp_7{top:5.5vh}._stream-container_14fkp_1._pc_14fkp_10{border-radius:12px;overflow:hidden}._stream-container_14fkp_1._float_14fkp_14{position:absolute;visibility:hidden}._groupcall-gridplus-container_14fkp_19{width:100%;height:100%}._groupcall-gridplus-container_14fkp_19._mobile_14fkp_7._center_14fkp_23{margin-top:24vh}._groupcall-gridplus-container_14fkp_19._mobile_14fkp_7._two-layout_14fkp_26{margin-top:15vh}._groupcall-gridplus-container_14fkp_19._pc_14fkp_10._two-layout_14fkp_26{margin-top:20%}._groupcall-gridplus-container_14fkp_19._float_14fkp_14{margin:0;position:absolute;top:0;right:0;left:0;bottom:0;border:0}._groupcall-gridplus-container_14fkp_19._float_14fkp_14 .tk-gridplus-item-container{width:100%!important;height:100%!important}._groupcall-gridplus-container_14fkp_19._float_14fkp_14 .tk-gridplus-item-container ._hidden_14fkp_45{visibility:hidden}._groupcall-gridplus-container_14fkp_19 ._userinfo_14fkp_48{z-index:1;color:#fff;text-align:right;font-family:PingFang SC;font-size:20px;font-style:normal;font-weight:500;line-height:normal}._group-container_bky89_1{width:100%;height:100%}._group-container_bky89_1._mobile_bky89_5{animation:_pulldown_bky89_1 .3s linear}@keyframes _pulldown_bky89_1{0%{transform:translateY(-100%)}to{transform:translateY(0)}}._floating-window-pc-groupcall-container_1es4b_1{width:80px;height:100px;top:100px;right:10px;display:flex;z-index:99;flex-direction:column;align-items:center;border-radius:12px;box-shadow:0 0 10px #35394166;box-sizing:border-box;overflow:hidden}[data-uikit-theme=light] ._floating-window-pc-groupcall-container_1es4b_1{background-color:var(--uikit-theme-light-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-pc-groupcall-container_1es4b_1{background-color:var(--uikit-theme-dark-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-pc-groupcall-container_1es4b_1 ._click-overlay_1es4b_1{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;z-index:11}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1{display:flex;flex-direction:column;align-content:center;align-items:center;width:100%;height:100%}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._video-stream_1es4b_1{position:absolute;width:100%;height:100%;top:0;left:0;box-sizing:border-box}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._video-stream_1es4b_1._hidden_1es4b_1{visibility:hidden!important;opacity:0}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._audio-stream_1es4b_1{display:flex;align-items:center;flex-direction:column;position:absolute;width:100%;height:100%;top:0;left:0}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1{height:80px;width:100%;position:relative;padding:8px 18px;box-sizing:border-box}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1._video_1es4b_1{padding:8px}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._earphone_1es4b_1{height:36px;width:36px;top:8px;position:absolute}._floating-window-pc-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._info_1es4b_1{color:#12b969;text-align:center;font-family:PingFang SC;font-size:12px;font-style:normal;font-weight:500;line-height:16px;position:absolute;bottom:8px}._floating-window-pc-groupcall-container_1es4b_1 ._device-status_1es4b_1{display:flex;flex-direction:row;align-items:center;height:20px;width:100%;position:relative;justify-content:space-evenly}[data-uikit-theme=light] ._floating-window-pc-groupcall-container_1es4b_1 ._device-status_1es4b_1{background-color:var(--uikit-theme-light-floating-color-operate);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-pc-groupcall-container_1es4b_1 ._device-status_1es4b_1{background-color:var(--uikit-theme-dark-floating-color-operate);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-pc-groupcall-container_1es4b_1 ._device-status_1es4b_1 ._icon_1es4b_1{display:flex;width:16px;height:16px;position:absolute}._floating-window-pc-groupcall-container_1es4b_1 ._device-status_1es4b_1 ._camera_1es4b_1{left:14px}._floating-window-pc-groupcall-container_1es4b_1 ._device-status_1es4b_1 ._micphone_1es4b_1{right:14px}._floating-window-h5-groupcall-container_1es4b_1{width:72px;height:90px;top:100px;right:0;display:flex;z-index:99;flex-direction:column;align-items:center;border-radius:12px;box-shadow:0 0 10px #35394166;box-sizing:border-box;overflow:hidden}[data-uikit-theme=light] ._floating-window-h5-groupcall-container_1es4b_1{background-color:var(--uikit-theme-light-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-h5-groupcall-container_1es4b_1{background-color:var(--uikit-theme-dark-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-h5-groupcall-container_1es4b_1 ._click-overlay_1es4b_1{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;z-index:11}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1{display:flex;flex-direction:column;align-content:center;align-items:center;width:100%;height:100%}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._video-stream_1es4b_1{position:absolute;width:100%;height:100%;top:0;left:0;box-sizing:border-box}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._video-stream_1es4b_1._hidden_1es4b_1{visibility:hidden!important;opacity:0}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._audio-stream_1es4b_1{display:flex;align-items:center;flex-direction:column;position:absolute;width:100%;height:100%;top:0;left:0}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1{height:70px;width:100%;position:relative;padding:8px 18px;box-sizing:border-box}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1._video_1es4b_1{padding:8px}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._earphone_1es4b_1{height:36px;width:36px;top:8px;position:absolute}._floating-window-h5-groupcall-container_1es4b_1 ._call-status_1es4b_1 ._info_1es4b_1{color:#12b969;text-align:center;font-family:PingFang SC;font-size:12px;font-style:normal;font-weight:500;line-height:16px;position:absolute;bottom:8px}._floating-window-h5-groupcall-container_1es4b_1 ._device-status_1es4b_1{display:flex;flex-direction:row;align-items:center;height:20px;width:100%;position:relative;justify-content:space-evenly}[data-uikit-theme=light] ._floating-window-h5-groupcall-container_1es4b_1 ._device-status_1es4b_1{background-color:var(--uikit-theme-light-floating-color-operate);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-h5-groupcall-container_1es4b_1 ._device-status_1es4b_1{background-color:var(--uikit-theme-dark-floating-color-operate);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-h5-groupcall-container_1es4b_1 ._device-status_1es4b_1 ._icon_1es4b_1{display:flex;width:16px;height:16px;position:absolute}._floating-window-h5-groupcall-container_1es4b_1 ._device-status_1es4b_1 ._camera_1es4b_1{left:14px}._floating-window-h5-groupcall-container_1es4b_1 ._device-status_1es4b_1 ._micphone_1es4b_1{right:14px}._floating-window-h5-singlecall-container_1wchz_1{width:110px;height:196px;top:100px;right:0;display:flex;z-index:99;flex-direction:column;align-items:center;border-radius:12px;box-shadow:0 0 10px #35394166;overflow:hidden}[data-uikit-theme=light] ._floating-window-h5-singlecall-container_1wchz_1{background-color:var(--uikit-theme-light-floating-color-default);border:1px solid var(--uikit-theme-light-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-h5-singlecall-container_1wchz_1{background-color:var(--uikit-theme-dark-floating-color-default);border:1px solid var(--uikit-theme-dark-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-h5-singlecall-container_1wchz_1._audio-call_1wchz_1{width:72px;height:72px;border-radius:12px;box-shadow:0 0 10px #35394166;box-sizing:border-box}[data-uikit-theme=light] ._floating-window-h5-singlecall-container_1wchz_1._audio-call_1wchz_1{background-color:var(--uikit-theme-light-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-h5-singlecall-container_1wchz_1._audio-call_1wchz_1{background-color:var(--uikit-theme-dark-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-h5-singlecall-container_1wchz_1 ._click-overlay_1wchz_1{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;z-index:11}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1{display:flex;flex-direction:column;align-content:center;align-items:center;padding:8px 18px;width:100%;height:100%;z-index:0;position:relative;box-sizing:border-box}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1._video_1wchz_1{padding:8px}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._info_1wchz_1{color:#fff;text-align:center;font-family:PingFang SC;font-size:12px;font-style:normal;font-weight:500;line-height:16px;position:absolute;bottom:8px}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._video-stream_1wchz_1{position:absolute;width:100%;height:100%;top:0;left:0;box-sizing:border-box;z-index:0}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._video-stream_1wchz_1._hidden_1wchz_1{visibility:hidden}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._audio-stream_1wchz_1{display:flex;align-items:center;flex-direction:column;position:absolute;width:100%;height:100%;left:0;top:0}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._audio-stream_1wchz_1 ._info_1wchz_1{color:#12b969}._floating-window-h5-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._earphone_1wchz_1{height:36px;width:36px;position:absolute;top:8px}._floating-window-h5-singlecall-container_1wchz_1 ._device-status_1wchz_1{display:flex;flex-direction:row;align-items:center;height:20px;background-color:#f9f6f4;width:100%;position:relative;justify-content:space-evenly}._floating-window-h5-singlecall-container_1wchz_1 ._device-status_1wchz_1 ._icon_1wchz_1{display:flex;width:16px;height:16px;position:absolute}._floating-window-h5-singlecall-container_1wchz_1 ._device-status_1wchz_1 ._camera_1wchz_1{left:14px}._floating-window-h5-singlecall-container_1wchz_1 ._device-status_1wchz_1 ._micphone_1wchz_1{right:14px}._floating-window-h5-singlecall-container_1wchz_1 ._tip_1wchz_1{position:absolute;bottom:0}._floating-window-pc-singlecall-container_1wchz_1{width:196px;height:110px;top:100px;right:10px;display:flex;z-index:99;flex-direction:column;align-items:center;border-radius:12px;box-shadow:0 0 10px #35394166;overflow:hidden}[data-uikit-theme=light] ._floating-window-pc-singlecall-container_1wchz_1{background-color:var(--uikit-theme-light-floating-color-default);border:1px solid var(--uikit-theme-light-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-pc-singlecall-container_1wchz_1{background-color:var(--uikit-theme-dark-floating-color-default);border:1px solid var(--uikit-theme-dark-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-pc-singlecall-container_1wchz_1._audio-call_1wchz_1{width:72px;height:72px;border-radius:12px;box-shadow:0 0 10px #35394166;box-sizing:border-box}[data-uikit-theme=light] ._floating-window-pc-singlecall-container_1wchz_1._audio-call_1wchz_1{background-color:var(--uikit-theme-light-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}[data-uikit-theme=dark] ._floating-window-pc-singlecall-container_1wchz_1._audio-call_1wchz_1{background-color:var(--uikit-theme-dark-floating-color-default);transition:background-color .3s ease-out,border-color .3s ease-out}._floating-window-pc-singlecall-container_1wchz_1 ._click-overlay_1wchz_1{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;z-index:11}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1{display:flex;flex-direction:column;align-content:center;align-items:center;padding:8px 18px;width:100%;height:100%;z-index:0;position:relative;box-sizing:border-box}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1._video_1wchz_1{padding:8px}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._info_1wchz_1{color:#fff;text-align:center;font-family:PingFang SC;font-size:12px;font-style:normal;font-weight:500;line-height:16px;position:absolute;bottom:8px}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._video-stream_1wchz_1{position:absolute;width:100%;height:100%;top:0;left:0;box-sizing:border-box;z-index:0}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._video-stream_1wchz_1._hidden_1wchz_1{visibility:hidden}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._video-stream_1wchz_1 .tk-togglewindowitem-small{border-radius:3px;width:32%;height:31%}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._audio-stream_1wchz_1{display:flex;align-items:center;flex-direction:column;position:absolute;width:100%;height:100%;left:0;top:0}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._audio-stream_1wchz_1 ._info_1wchz_1{color:#12b969}._floating-window-pc-singlecall-container_1wchz_1 ._call-status_1wchz_1 ._earphone_1wchz_1{height:36px;width:36px;position:absolute;top:8px}._floating-window-pc-singlecall-container_1wchz_1 ._device-status_1wchz_1{display:flex;flex-direction:row;align-items:center;height:20px;background-color:#f9f6f4;width:100%;position:relative;justify-content:space-evenly}._floating-window-pc-singlecall-container_1wchz_1 ._device-status_1wchz_1 ._icon_1wchz_1{display:flex;width:16px;height:16px;position:absolute}._floating-window-pc-singlecall-container_1wchz_1 ._device-status_1wchz_1 ._camera_1wchz_1{left:14px}._floating-window-pc-singlecall-container_1wchz_1 ._device-status_1wchz_1 ._micphone_1wchz_1{right:14px}._floating-window-pc-singlecall-container_1wchz_1 ._tip_1wchz_1{position:absolute;bottom:0}:root{--uikit-theme-light-bg-color-topbar: #f9fafc;--uikit-theme-light-bg-color-operate: #fff;--uikit-theme-light-bg-color-input: #f0f2f7;--uikit-theme-light-bg-color-bubble-reciprocal: #f0f2f7;--uikit-theme-light-bg-color-bubble-own: #cce2ff;--uikit-theme-light-bg-color-default: #f0f2f7;--uikit-theme-light-bg-color-tag-mask: rgba(255, 255, 255, .55);--uikit-theme-light-bg-color-mask: rgba(0, 0, 0, .55);--uikit-theme-light-text-color-primary: rgba(0, 0, 0, .93);--uikit-theme-light-text-color-secondary: rgba(0, 0, 0, .66);--uikit-theme-light-text-color-tertiary: rgba(0, 0, 0, .4);--uikit-theme-light-text-color-disable: rgba(0, 0, 0, .28);--uikit-theme-light-text-color-link: #1c66e5;--uikit-theme-light-text-color-link-hover: #4588f5;--uikit-theme-light-text-color-link-disabled: #cce2ff;--uikit-theme-light-text-color-anti-primary: rgba(0, 0, 0, .9);--uikit-theme-light-text-color-anti-secondary: rgba(0, 0, 0, .55);--uikit-theme-light-text-color-warning: #ff7200;--uikit-theme-light-text-color-success: #0abf77;--uikit-theme-light-text-color-error: #e54545;--uikit-theme-light-dropdown-color-default: #fff;--uikit-theme-light-dropdown-color-hover: #f9fafc;--uikit-theme-light-dropdown-color-active: #ebf3ff;--uikit-theme-light-list-color-default: #fff;--uikit-theme-light-list-color-hover: #f9fafc;--uikit-theme-light-list-color-active: #ebf3ff;--uikit-theme-light-stroke-color-primary: #f9fafc;--uikit-theme-light-stroke-color-secondary: rgba(0, 0, 0, .55);--uikit-theme-light-shadow-color: rgba(0, 0, 0, .06);--uikit-theme-light-floating-color-default: #ffffff;--uikit-theme-light-floating-color-operate: #F0F2F7;--uikit-theme-light-toast-color-default: #EBF3FF;--uikit-theme-light-toast-color-success: #DCFAE9;--uikit-theme-light-toast-color-warning: #FFEEDB;--uikit-theme-light-toast-color-error: #FFE7E5;color-scheme:light dark}:root{--uikit-theme-dark-bg-color-topbar: #16171a;--uikit-theme-dark-bg-color-operate: #1f2024;--uikit-theme-dark-bg-color-input: #2b2c30;--uikit-theme-dark-bg-color-bubble-reciprocal: #2b2c30;--uikit-theme-dark-bg-color-bubble-own: #5c9dff;--uikit-theme-dark-bg-color-default: #16171a;--uikit-theme-dark-bg-color-tag-mask: rgba(0, 0, 0, .55);--uikit-theme-dark-bg-color-mask: rgba(0, 0, 0, .55);--uikit-theme-dark-text-color-primary: rgba(255, 255, 255, .93);--uikit-theme-dark-text-color-secondary: rgba(255, 255, 255, .66);--uikit-theme-dark-text-color-tertiary: rgba(255, 255, 255, .4);--uikit-theme-dark-text-color-disable: rgba(255, 255, 255, .28);--uikit-theme-dark-text-color-link: #4086ff;--uikit-theme-dark-text-color-link-hover: #2b6ad6;--uikit-theme-dark-text-color-link-disabled: #243047;--uikit-theme-dark-text-color-anti-primary: rgba(0, 0, 0, .9);--uikit-theme-dark-text-color-anti-secondary: rgba(0, 0, 0, .55);--uikit-theme-dark-text-color-warning: #e37f32;--uikit-theme-dark-text-color-success: #38a673;--uikit-theme-dark-text-color-error: #e6594c;--uikit-theme-dark-dropdown-color-default: #2b2c30;--uikit-theme-dark-dropdown-color-hover: #3a3c42;--uikit-theme-dark-dropdown-color-active: #1f2024;--uikit-theme-dark-list-color-default: #1f2024;--uikit-theme-dark-list-color-hover: #2b2c30;--uikit-theme-dark-list-color-active: #243047;--uikit-theme-dark-stroke-color-primary: #3a3c42;--uikit-theme-dark-stroke-color-secondary: #2b2c30;--uikit-theme-dark-shadow-color: rgba(0, 0, 0, .06);--uikit-theme-dark-floating-color-default: #2B2C30;--uikit-theme-dark-floating-color-operate: #3A3C42;--uikit-theme-dark-toast-color-default: #243047;--uikit-theme-dark-toast-color-success: #22352C;--uikit-theme-dark-toast-color-warning: #35231A;--uikit-theme-dark-toast-color-error: #422324;color-scheme:light dark}._tuicallkit-container_pyzih_79{position:relative;width:960px;height:630px;border-radius:12px;overflow:hidden}._tuicallkit-container_pyzih_79._float_pyzih_86{position:absolute;visibility:hidden}._tuicallkit-container_pyzih_79._mobile_pyzih_90{background:none;border-radius:0;width:100%;height:100%}")),document.head.appendChild(t)}}catch(i){console.error("vite-plugin-css-injected-by-js",i)}})();
var Po = Object.defineProperty;
var Ho = (t, e, n) => e in t ? Po(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var v = (t, e, n) => (Ho(t, typeof e != "symbol" ? e + "" : e, n), n);
import { TUICallEvent as R, TUICallEngine as Jo } from "tuicall-engine-webrtc";
import { TUICore as pn, TUIConstants as de, TUILogin as Xo } from "@tencentcloud/tui-core";
import Si from "@tencentcloud/chat";
import * as Gt from "react";
import Le, { useState as U, useEffect as H, createContext as Ut, useMemo as Ie, useContext as Q, forwardRef as ai, useRef as at, useImperativeHandle as Ko, isValidElement as $o, useCallback as Qn, useLayoutEffect as qo } from "react";
import * as es from "react-dom";
import { createPortal as ts, render as jr, unmountComponentAtNode as ns } from "react-dom";
var d = /* @__PURE__ */ ((t) => (t.CALL = "call", t.CUSTOM = "custom", t))(d || {}), $ = /* @__PURE__ */ ((t) => (t[t.UNKNOWN = 0] = "UNKNOWN", t[t.AUDIO = 1] = "AUDIO", t[t.VIDEO = 2] = "VIDEO", t))($ || {}), De = /* @__PURE__ */ ((t) => (t.UNKNOWN = "unknown", t.CALLEE = "callee", t.CALLER = "caller", t))(De || {}), _ = /* @__PURE__ */ ((t) => (t.IDLE = "idle", t.CALLING = "calling", t.CONNECTED = "connected", t))(_ || {}), sn = /* @__PURE__ */ ((t) => (t.CONTAIN = "contain", t.COVER = "cover", t.FILL = "fill", t))(sn || {}), ln = /* @__PURE__ */ ((t) => (t.RESOLUTION_480P = "480p", t.RESOLUTION_720P = "720p", t.RESOLUTION_1080P = "1080p", t))(ln || {}), hr = /* @__PURE__ */ ((t) => (t.EN = "en", t["ZH-CN"] = "zh-cn", t.JA_JP = "ja_JP", t))(hr || {});
const fe = {
  IDLE: "idle",
  BE_INVITED: "be-invited",
  DIALING_C2C: "dialing-c2c",
  DIALING_GROUP: "dialing-group",
  CALLING_C2C_AUDIO: "calling-c2c-audio",
  CALLING_C2C_VIDEO: "calling-c2c-video",
  CALLING_GROUP_AUDIO: "calling-group-audio",
  CALLING_GROUP_VIDEO: "calling-group-video"
}, as = {
  unknown: 0,
  audio: 1,
  video: 2
  /* VIDEO */
};
var pe = /* @__PURE__ */ ((t) => (t.MICROPHONE = "microphone", t.CAMERA = "camera", t.SPEAKER = "speaker", t))(pe || {}), On = /* @__PURE__ */ ((t) => (t[t.FRONT = 0] = "FRONT", t[t.BACK = 1] = "BACK", t))(On || {}), Wt = /* @__PURE__ */ ((t) => (t.Camera = "camera", t.Microphone = "microphone", t.SwitchCamera = "switchCamera", t.InviteUser = "inviteUser", t))(Wt || {}), cn = /* @__PURE__ */ ((t) => (t.Open = "open", t.Close = "close", t))(cn || {}), Mt = /* @__PURE__ */ ((t) => (t.LOCAL = "local", t.REMOTE = "remote", t))(Mt || {}), ra = /* @__PURE__ */ ((t) => (t.LocalInLargeView = "local", t.RemoteInLargeView = "remote", t))(ra || {}), rn = /* @__PURE__ */ ((t) => (t[t.INVITE = 1] = "INVITE", t[t.CANCEL_INVITE = 2] = "CANCEL_INVITE", t[t.ACCEPT_INVITE = 3] = "ACCEPT_INVITE", t[t.REJECT_INVITE = 4] = "REJECT_INVITE", t[t.INVITE_TIMEOUT = 5] = "INVITE_TIMEOUT", t))(rn || {});
const Oi = {
  SWITCH_TO_AUDIO_CALL_FAILED: 60001,
  SWITCH_TO_VIDEO_CALL_FAILED: 60002,
  MICROPHONE_UNAVAILABLE: 60003,
  CAMERA_UNAVAILABLE: 60004,
  BAN_DEVICE: 60005,
  NOT_SUPPORTED_WEBRTC: 60006,
  ERROR_BLACKLIST: 20007
}, is = {
  SWITCH_TO_AUDIO_CALL_FAILED: "switchToAudioCall-call-failed",
  SWITCH_TO_VIDEO_CALL_FAILED: "switchToVideoCall-call-failed",
  MICROPHONE_UNAVAILABLE: "microphone-unavailable",
  CAMERA_UNAVAILABLE: "camera-unavailable",
  BAN_DEVICE: "ban-device",
  NOT_SUPPORTED_WEBRTC: "not-supported-webrtc",
  ERROR_BLACKLIST: "blacklist-user-tips"
};
var Cr = /* @__PURE__ */ ((t) => (t[t.NORMAL = 0] = "NORMAL", t[t.RELEASE = 1] = "RELEASE", t[t.WARNING = 2] = "WARNING", t[t.ERROR = 3] = "ERROR", t[t.NONE = 4] = "NONE", t))(Cr || {});
const ea = {
  CALL_STATUS: "callStatus",
  CALL_ROLE: "callRole",
  CALL_MEDIA_TYPE: "callMediaType",
  LOCAL_USER_INFO: "localUserInfo",
  LOCAL_USER_INFO_EXCLUDE_VOLUMN: "localUserInfoExcludeVolume",
  REMOTE_USER_INFO_LIST: "remoteUserInfoList",
  REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST: "remoteUserInfoExcludeVolumeList",
  CALLER_USER_INFO: "callerUserInfo",
  IS_GROUP: "isGroup",
  CALL_DURATION: "callDuration",
  CALL_TIPS: "callTips",
  TOAST_INFO: "toastInfo",
  IS_MINIMIZED: "isMinimized",
  ENABLE_FLOAT_WINDOW: "enableFloatWindow",
  BIG_SCREEN_USER_ID: "bigScreenUserId",
  LANGUAGE: "language",
  IS_CLICKABLE: "isClickable",
  DISPLAY_MODE: "displayMode",
  VIDEO_RESOLUTION: "videoResolution",
  PUSHER: "pusher",
  PLAYER: "player",
  IS_EAR_PHONE: "isEarPhone",
  IS_MUTE_SPEAKER: "isMuteSpeaker",
  SHOW_PERMISSION_TIP: "SHOW_PERMISSION_TIP",
  NETWORK_STATUS: "NetWorkStatus",
  GROUP_ID: "groupID",
  ROOM_ID: "roomID",
  ROOM_ID_TYPE: "roomIdType",
  SHOW_SELECT_USER: "showSelectUser",
  IS_SHOW_ENABLE_VIRTUAL_BACKGROUND: "isShowEnableVirtualBackground",
  ENABLE_VIRTUAL_BACKGROUND: "enableVirtualBackground",
  GROUP_CALL_MEMBERS: "groupCallMembers",
  PUSHER_ID: "pusherId"
}, rs = {
  INNER_ATTR_KIT_INFO: "inner_attr_kit_info"
}, os = {
  INITIAL_PUSHER: "initialPusher",
  NEW_PUSHER: "newPusher"
}, o = {
  PREFIX: "【CallService】",
  AUDIO: "audio",
  VIDEO: "video",
  LOCAL_VIDEO: "localVideo",
  ERROR: "error",
  TIMEOUT: "timeout",
  RAF: "raf",
  INTERVAL: "interval",
  DEFAULT: "default",
  BOOLEAN: "boolean",
  STRING: "string",
  NUMBER: "number",
  OBJECT: "object",
  ARRAY: "array",
  FUNCTION: "function",
  UNDEFINED: "undefined",
  UNKNOWN: "unknown",
  ALL: "all",
  MYSELF: "myself",
  DEVICE_LIST: "deviceList",
  CAMERA_POSITION: "cameraPosition",
  CUSTOM_UI_CONFIG: "customUIConfig",
  ...os,
  ...ea,
  ...rs
}, ss = "https://web.sdk.qcloud.com/component/TUIKit/assets/call.png", ls = "https://web.sdk.qcloud.com/component/TUIKit/assets/call-video-reverse.svg", wi = 2147483647, cs = 3, us = 4;
var ii = /* @__PURE__ */ ((t) => (t[t.TUI_CALL_KIT = 14] = "TUI_CALL_KIT", t[t.TIM_CALL_KIT = 15] = "TIM_CALL_KIT", t))(ii || {}), Ba = /* @__PURE__ */ ((t) => (t[t.NUMBER_ROOM_ID = 1] = "NUMBER_ROOM_ID", t[t.STRING_ROOM_ID = 2] = "STRING_ROOM_ID", t))(Ba || {});
async function Ms(t) {
  if (!t)
    return !1;
  try {
    const e = await new Promise((n, a) => {
      const i = new XMLHttpRequest();
      i.open("HEAD", t, !0), i.onload = () => n(i), i.onerror = () => a(i), i.send();
    });
    return e.status === 200 && e.getResponseHeader("Content-Type") === "audio/mpeg";
  } catch (e) {
    return console.warn(e), !1;
  }
}
function oa(t) {
  if (typeof t != "object" || t === null)
    return t;
  let e = Array.isArray(t) ? [] : {};
  for (let n in t)
    t.hasOwnProperty(n) && (e[n] = oa(t[n]));
  return e;
}
const Is = {
  // 按钮文案
  hangup: "Hang up",
  reject: "Decline",
  accept: "Accept",
  camera: "Camera",
  microphone: "Microphone",
  speaker: "speaker",
  "open camera": "Open Camera",
  "close camera": "Close Camera",
  "open microphone": "Open Microphone",
  "close microphone": "Close Microphone",
  "video-to-audio": "Switch to audio",
  "virtual-background": "Blur Background",
  // 通话结果
  "other side reject call": "other side reject call",
  "reject call": "Reject Call",
  cancel: "Cancel Call",
  "other side line busy": "other side line busy",
  "in busy": "in busy",
  "call timeout": "call timeout",
  "no response from the other side": "no response from the other side",
  "end call": "end call",
  // 通话提示语
  "caller calling message": "Awaiting response",
  "callee calling video message": "invites you to a video call",
  "callee calling audio message": "invites you to a voice call",
  "no microphone access": "no microphone access",
  "no camera access": "no camera access",
  "invite member": "Invite Member",
  "Invited group call": "invites you to a group call",
  waiting: "Calling...",
  me: "(me)",
  // 弹出层文案
  "browser-authorization": "Browser authorization",
  "mac-privacy": "System Preferences -> Security and Privacy -> Privacy",
  "win-privacy": "Setting -> Privacy and Security -> App permissions",
  "mac-preferences": "Open System Preferences",
  "win-preferences": "Open Setting",
  "Please enter userID": "Please enter userID",
  "View more": "View more",
  "people selected": "people selected",
  "Select all": "Select all",
  Cancel: "Cancel",
  Done: "Done",
  "exist group call": "A group call already exists in the current group",
  // UI3.0 新增
  "camera enabled": "Camera On",
  "camera disabled": "Camera Off",
  "microphone enabled": "Unmuted",
  "microphone disabled": "Muted",
  "speaker enabled": "Speaker On",
  "speaker disabled": "Speaker Off",
  "open speaker": "Turn on speaker",
  "close speaker": "Turn off speaker",
  "wait to be called": "Waiting",
  answered: "Connected",
  "people in the call": " other(s) in the call",
  "failed to obtain speakers": "failed to obtain speakers",
  "you have a new call": "You have a new call",
  "switch camera": "Switch",
  join: "Join",
  "people on the call": "people on the call",
  "Supports a maximum of 9 people for simultaneous calls": "Supports a maximum of 9 people for simultaneous calls",
  you: "(you)",
  "The network is poor during your current call": "The network is poor during your current call",
  "The other user network is poor during the current call": "The other party's network is poor during the current call",
  "TUICallKit init is not complete": "TUICallKit init is not complete. You need to use this API after the init API is finished.",
  // combine chat
  "Video call": "Video call",
  "Voice call": "Voice call",
  "Call End": "Call End",
  "Switch voice call": "Switch voice call",
  "Switch video call": "Switch video call",
  "Call duration": "Duration",
  "Call Cancel": "Canceled",
  "Other Side Cancel": "Call canceled by caller",
  Decline: "Declined",
  "Other Side Decline": "Call declined by user",
  "No answer": "Call not answered",
  "Other Side No Answer": "Call wasn't answered",
  Answered: "Answered",
  "Other Side Line Busy": "Line busy",
  "Line Busy": "Line busy. Call not received.",
  // 待废弃文案
  "Those involved": "Those involved in the call are",
  call: "call",
  "video-call": "video call",
  "audio-call": "audio call",
  search: "search",
  "search-result": "search result",
  "no-user": "user not found",
  "member-not-added": "member not added",
  "input-phone-userID": "phone number or userID",
  "not-login": "not logged in",
  "login-status-expire": "login status is invalid, please refresh the page and try again",
  "experience-multi-call": "experience multi-person calls, please download the full-featured demo: ",
  "not-support-multi-call": "multi-person call interface is not open",
  userID: "userID",
  "already-enter": "entered the call",
  "camera-opened": "Camera on",
  "camera-closed": "Camera off",
  "microphone-opened": "Mic on",
  "microphone-closed": "Mic off",
  timeout: "timeout",
  "kick out": "kick out",
  "image-resolution": "Resolution",
  "default-image-resolution": "Default",
  "invited-person": "Invite",
  "be-rejected": "Call declined, ",
  "be-no-response": "No response, ",
  "be-line-busy": "Line busy, ",
  "be-canceled": "The call is canceled, ",
  "voice-call-end": "Voice call ended",
  "video-call-end": "Video call ended",
  "method-call-failed": "Failed to sync the operation",
  "failed-to-obtain-permission": "Failed to obtain permissions",
  "environment-detection-failed": "Failed to check the environment",
  "switchToAudioCall-call-failed": "switch to audio call method failed",
  "switchToVideoCall-call-failed": "switch to video call method failed",
  "microphone-unavailable": "No mic found",
  "camera-unavailable": "No camera found",
  "ban-device": "Device access denied",
  "not-supported-webrtc": "Your current environment does not support WebRTC",
  "blacklist-user-tips": "The identifier is in blacklist. Failed to send this message!",
  "is-already-calling": "TUICallKit is already on a call",
  "need-init": "Before initiating a call with TUICallKit, ensure that the TUICallKitServer.init() method has executed successfully. ",
  "can't call yourself": "Can't call yourself",
  // eslint-disable-line
  "Use-phone-and-computer": "Use your mobile phone and computer to experience video calls",
  "Wechat scan right QR code": "Wechat scan right QR code",
  "Scan the QR code above": "Scan the QR code above",
  "accept-error": "Accept failed",
  "accept-device-error": "Accept failed, unable to auth calling device",
  "call-error": "Start call failed"
}, As = {
  // 按钮文案
  hangup: "挂断",
  reject: "拒绝",
  accept: "接受",
  camera: "摄像头",
  microphone: "麦克风",
  speaker: "扬声器",
  "open camera": "打开摄像头",
  "close camera": "关闭摄像头",
  "open microphone": "打开麦克风",
  "close microphone": "关闭麦克风",
  "video-to-audio": "转语音通话",
  "virtual-background": "模糊背景",
  // 通话结果
  "other side reject call": "对方已拒绝",
  "reject call": "拒绝通话",
  cancel: "取消通话",
  "other side line busy": "对方忙线",
  "in busy": "正在忙",
  "call timeout": "呼叫超时",
  "end call": "结束通话",
  // 通话提示语
  "caller calling message": "等待对方接受邀请",
  "callee calling video message": "邀请你视频通话",
  "callee calling audio message": "邀请你语音通话",
  "no microphone access": "没有麦克风权限",
  "no camera access": "没有摄像头权限",
  "invite member": "邀请成员",
  "Invited group call": "邀请你加入多人通话",
  "Those involved": "参与通话的有：",
  waiting: "等待接听...",
  me: "(我)",
  // 弹出层文案
  "browser-authorization": "浏览器授权",
  "mac-privacy": "系统偏好设置 -> 安全与隐私 -> 隐私",
  "win-privacy": "设置 -> 隐私和安全性 -> 应用权限",
  "mac-preferences": "打开系统偏好设置",
  "win-preferences": "打开系统设置",
  "Please enter userID": "请输入 userID",
  "View more": "查看更多",
  "people selected": "人已选中",
  "Select all": "全选",
  Cancel: "取消",
  Done: "完成",
  "exist group call": "当前群组中已经存在群组通话",
  // UI3.0 新增
  "camera enabled": "摄像头已开",
  "camera disabled": "摄像头已关",
  "microphone enabled": "麦克风已开",
  "microphone disabled": "麦克风已关",
  "speaker enabled": "扬声器已开",
  "speaker disabled": "扬声器已关",
  "open speaker": "开启扬声器",
  "close speaker": "关闭扬声器",
  "wait to be called": "等待接听",
  answered: "已接通",
  "people in the call": "人参与通话",
  "failed to obtain speakers": "无法获取扬声器",
  "you have a new call": "您有一个新的通话",
  "switch camera": "翻转",
  join: "加入",
  "people on the call": "人正在通话",
  "Supports a maximum of 9 people for simultaneous calls": "最多支持9人同时通话",
  you: "(你)",
  "The network is poor during your current call": "当前通话你的网络不佳",
  "The other user network is poor during the current call": "当前通话对方网络不佳",
  "TUICallKit init is not complete": "TUICallKit 初始化登录未完成，需要在 init 完成后使用此 API",
  // combine chat
  "Video call": "发起视频通话",
  "Voice call": "发起语音通话",
  "Call End": "通话结束",
  "Switch voice call": "切换语音通话",
  "Switch video call": "切换视频通话",
  "Call duration": "通话时长",
  "Call Cancel": "已取消",
  "Other Side Cancel": "对方已取消",
  Decline: "已拒绝",
  "Other Side Decline": "对方已拒绝",
  "No answer": "超时无应答",
  "Other Side No Answer": "对方无应答",
  Answered: "已接听",
  "Other Side Line Busy": "对方忙线中",
  "Line Busy": "忙线无应答",
  // 待废弃文案
  timeout: "超时",
  "kick out": "被踢",
  call: "通话",
  "video-call": "视频通话",
  "audio-call": "音频通话",
  search: "搜索",
  "search-result": "搜索结果",
  "Wechat scan right QR code": "微信扫右二维码",
  "Use-phone-and-computer": "用手机与电脑互打体验视频通话",
  "Scan the QR code above": "扫描上方二维码",
  "no-user": "未搜索到用户",
  "member-not-added": "未添加成员",
  "not-login": "未登录",
  "login-status-expire": "登录状态已失效，请刷新网页重试",
  "experience-multi-call": "体验多人通话请下载全功能demo:",
  "not-support-multi-call": "多人通话接口未开放",
  "input-phone-userID": "请输入手机号/用户ID",
  userID: "用户ID",
  "already-enter": "已经进入当前通话",
  "image-resolution": "分辨率",
  "default-image-resolution": "默认分辨率",
  "invited-person": "添加成员",
  "be-rejected": "对方已拒绝，",
  "be-no-response": "对方无应答，",
  "be-line-busy": "对方忙线中，",
  "be-canceled": "对方已取消",
  "voice-call-end": "语音通话结束",
  "video-call-end": "视频通话结束",
  "method-call-failed": "同步操作失败",
  "failed-to-obtain-permission": "权限获取失败",
  "environment-detection-failed": "环境检测失败",
  "switchToAudioCall-call-failed": "切语音调用失败",
  "switchToVideoCall-call-failed": "切视频调用失败",
  "microphone-unavailable": "没有可用的麦克风设备",
  "camera-unavailable": "没有可用的摄像头设备",
  "ban-device": "用户禁止使用设备",
  "not-supported-webrtc": "当前环境不支持 WebRTC",
  "blacklist-user-tips": "发起通话失败，被对方拉入黑名单，禁止发起！",
  "is-already-calling": "TUICallKit 已在通话状态",
  "need-init": "TUICallKit 发起通话前需保证 TUICallKitServer.init() 方法执行成功",
  "can't call yourself": "不能呼叫自己",
  // eslint-disable-line
  "accept-error": "接通失败",
  "accept-device-error": "接通失败，通话设备获取失败",
  "call-error": "发起通话失败"
}, ds = {
  // 按钮文案 
  hangup: "通話終了",
  reject: "拒否",
  accept: "応答",
  camera: "カメラ",
  microphone: "マイク",
  speaker: "スピーカー",
  "virtual-background": "ボケ背景",
  // 通话结果
  "other side reject call": "通話が拒否されました",
  "reject call": "通話拒否",
  cancel: "通話をキャンセル",
  "other side line busy": "相手が通話中です",
  "in busy": "通話中",
  "call timeout": "呼び出しタイムアウト",
  "end call": "通話終了",
  // 通话提示语
  "caller calling message": "応答を待っています",
  "callee calling video message": "ビデオ通話に招待されました",
  "callee calling audio message": "音声通話に招待されました",
  "no microphone access": "マイクにアクセスできません",
  "no camera access": "カメラにアクセスできません",
  "invite member": "メンバーを招待する",
  // 弹出层文案
  "browser-authorization": "ブラウザ認証",
  "mac-privacy": "システム環境設定 -> セキュリティとプライバシー ->プライバシー",
  "win-privacy": "設定 -> セキュリティとプライバシー ->アプリのアクセス許可",
  "mac-preferences": "システム環境設定を開く",
  "win-preferences": "システム設定を開く",
  "Please enter userID": "ユーザーIDを入力してください",
  "View more": "もっと見る",
  "people selected": "人が選択されました",
  "Select all": "すべて選択",
  Cancel: "キャンセル",
  Done: "完了",
  "exist group call": "現在のグループには既にグループ通話が存在しています",
  // combine chat
  "Video call": "ビデオ通話を開始",
  "Voice call": "音声通話を開始",
  "Call End": "通話終了",
  "Switch audio call": "音声通話に切り替える",
  "Switch video call": "ビデオ通話に切り替える",
  "Call duration": "通話時間",
  "Call Cancel": "通話をキャンセルする",
  "Other Side Cancel": "相手がキャンセルしました",
  Decline: "通話を拒否する",
  "Other Side Decline": "相手が拒否しました",
  "No answer": "無応答",
  "Other Side No Answer": "相手からの返答はありません",
  Answered: "応答しました",
  "Other Side Line Busy": "相手は現在忙しくて対応できません",
  "Line Busy": "忙しいので応答できません",
  // UI3.0文案
  "open camera": "オープンカメラ",
  "close camera": "カメラを閉じる",
  "open microphone": "オープンマイク",
  "close microphone": "マイクを閉じる",
  "camera enabled": "カメラオン",
  "camera disabled": "カメラオフ",
  "microphone enabled": "マイクオン",
  "microphone disabled": "マイクオフ",
  "speaker enabled": "スピーカーオン",
  "speaker disabled": "スピーカーオフ",
  "open speaker": "スピーカーをオンにする",
  "close speaker": "スピーカーの電源を切ります",
  "wait to be called": "待機中",
  answered: "接続済み",
  "people in the call": "通話に参加している人たち",
  "failed to obtain speakers": "スピーカーが見つかりません",
  "you have a new call": "新しい通話があります",
  "switch camera": "切り替え",
  join: "参加する",
  "people on the call": "人が通話中です",
  "Supports a maximum of 9 people for simultaneous calls": "最大で9人まで同時通話が可能です",
  you: "(あなた)",
  "The network is poor during your current call": "現在の通話で、あなたのネットワークは不良です",
  "The other user network is poor during the current call": "現在の通話で、相手側のネットワークが不良です",
  "TUICallKit init is not complete": "TUICallKitの初期化ログインが完了していません。init が完了した後にこのAPIを使用する必要があります。",
  // 待废弃文案
  timeout: "タイムアウト",
  "kick out": "キックアウトされました",
  "Invited group call": "グループ通話に招待されました。",
  "Those involved": "参加者：",
  call: "通話",
  "video-call": "ビデオ通話",
  "audio-call": "音声通話",
  search: "検索",
  "search-result": "検索結果",
  "Wechat scan right QR code": "WeChatで右側にあるQRコードを読み取ります。",
  "Use-phone-and-computer": "携帯電話とコンピュータを使用してビデオ通話を体験してください",
  "Scan the QR code above": "上のQRコードを読み取ります。",
  "no-user": "ユーザーが見つかりませんでした",
  "member-not-added": "メンバーが追加されていません",
  "not-login": "ログインしていません",
  "login-status-expire": "ログインの有効期限が過ぎています。ページを更新してもう一度お試しください",
  "experience-multi-call": "複数人で同時に音声通話できるグループ通話機能を体験するには、全機能のデモをダウンロードしてください",
  "not-support-multi-call": "グループ通話インターフェイスが開いていません",
  "input-phone-userID": "携帯電話番号/ユーザーIDを入力してください",
  userID: "ユーザーID",
  "already-enter": "すでに通話に参加しています",
  waiting: "応答を待っています...",
  "camera-opened": "カメラがオンになっています",
  "camera-closed": "カメラがオフになっています",
  "microphone-opened": "マイクがオンになっています",
  "microphone-closed": "マイクがオフになっています",
  "image-resolution": "解像度",
  "default-image-resolution": "デフォルト解像度",
  "invited-person": "メンバーを招待",
  "video-to-audio": "音声通話に切り替えます",
  me: "(自分)",
  "be-rejected": "通話が拒否されました, ",
  "be-no-response": "応答なし, ",
  "be-line-busy": "相手が通話中です, ",
  "be-canceled": "相手が通話をキャンセルしました",
  "voice-call-end": "音声通話が終了しました",
  "video-call-end": "ビデオ通話が終了しました",
  "method-call-failed": "操作の同期に失敗しました",
  "failed-to-obtain-permission": "権限の取得に失敗しました",
  "environment-detection-failed": "環境の検出に失敗しました",
  "switchToAudioCall-call-failed": "音声通話に切り替えることはできません",
  "switchToVideoCall-call-failed": "ビデオ通話に切り替えることはできません",
  "microphone-unavailable": "使用できるマイクがありません",
  "camera-unavailable": "使用できるカメラがありません",
  "ban-device": "デバイスへのアクセスが拒否されました",
  "not-supported-webrtc": "現在の環境はWebRTCをサポートしていません",
  "blacklist-user-tips": "ユーザーはブラックリストに登録され、通話が開始できませんでした",
  "is-already-calling": "TUICallKit はすでに通話中です",
  "need-init": "TUICallKitで通話を開始する前に、TUICallKitServer.init() メソッドが正常に実行されたことを確認してください。",
  "can't call yourself": "自分に電話をかけることができません",
  "accept-error": "接続できませんでした",
  "accept-device-error": "接続できませんでした。発信側デバイスを認証できません",
  "call-error": "通話が開始できませんでした"
}, Ce = {
  OTHER_SIDE: "other side",
  CANCEL: "cancel",
  OTHER_SIDE_REJECT_CALL: "other side reject call",
  REJECT_CALL: "reject call",
  OTHER_SIDE_LINE_BUSY: "other side line busy",
  IN_BUSY: "in busy",
  CALL_TIMEOUT: "call timeout",
  END_CALL: "end call",
  TIMEOUT: "timeout",
  KICK_OUT: "kick out",
  CALLER_CALLING_MSG: "caller calling message",
  CALLER_GROUP_CALLING_MSG: "wait to be called",
  CALLEE_CALLING_VIDEO_MSG: "callee calling video message",
  CALLEE_CALLING_AUDIO_MSG: "callee calling audio message",
  NO_MICROPHONE_DEVICE_PERMISSION: "no microphone access",
  NO_CAMERA_DEVICE_PERMISSION: "no camera access",
  EXIST_GROUP_CALL: "exist group call",
  LOCAL_NETWORK_IS_POOR: "The network is poor during your current call",
  REMOTE_NETWORK_IS_POOR: "The other user network is poor during the current call"
}, Ui = {
  en: Is,
  "zh-cn": As,
  ja_JP: ds
};
function k(t) {
  var a;
  const e = f.getData(d.CALL, o.LANGUAGE);
  for (const i in Ui)
    if (i === e) {
      const r = Ui[i];
      for (const s in r)
        if (s === t)
          return r[s];
    }
  const n = (a = t.en) == null ? void 0 : a.key;
  return console.error(`${o.PREFIX}translation is not found: ${t}.`), n;
}
const sa = typeof wx < "u" && typeof wx.getSystemInfoSync == "function" && !!wx.getSystemInfoSync().fontSizeSetting, Lr = typeof uni < "u" && typeof uni > "u", zi = sa || Lr, yr = typeof uni < "u", mr = function() {
  return (typeof uni < "u" || typeof window < "u") && !zi;
}(), Ns = function() {
  return sa ? wx : yr ? uni : window;
}(), Ot = mr && window && window.navigator && window.navigator.userAgent || "", gs = /Android/i.test(Ot), Ds = /(?:Windows Phone)/.test(Ot), Ts = /(?:SymbianOS)/.test(Ot), Es = /iPad/i.test(Ot) || /iPhone/i.test(Ot) || /iPod/i.test(Ot), Sr = gs || Ds || Ts || Es, ri = mr && !Sr, fs = ri && Ot.includes("Windows NT"), ps = ri && Ot.includes("Mac");
var It;
let Or = (It = class {
  constructor() {
    v(this, "global", Ns);
    v(this, "isPC", !1);
    v(this, "isH5", !1);
    v(this, "isWeChat", !1);
    v(this, "isApp", !1);
    v(this, "isUniPlatform", !1);
    v(this, "isOfficial", !1);
    v(this, "isWIN", !1);
    v(this, "isMAC", !1);
    this.initEnv();
  }
  /**
   * 获取 TUIGlobal 实例
   * @returns {TUIGlobal}
  */
  static getInstance() {
    return It.instance || (It.instance = new It()), It.instance;
  }
  initEnv() {
    this.isPC = ri, this.isH5 = Sr, this.isWeChat = sa, this.isApp = Lr && !sa, this.isUniPlatform = yr, this.isWIN = fs, this.isMAC = ps;
  }
  initOfficial(e) {
    this.isOfficial = e === 1400187352 || e === 1400188366;
  }
}, v(It, "instance"), It);
const Aa = function(t) {
  return typeof t === o.UNDEFINED;
}, wr = function(t) {
  if (typeof t !== o.OBJECT || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  if (e === null)
    return !0;
  let n = e;
  for (; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return e === n;
}, Ur = function(t) {
  return typeof Array.isArray === o.FUNCTION ? Array.isArray(t) : Object.prototype.toString.call(t).match(/^\[object (.*)\]$/)[1].toLowerCase() === o.ARRAY;
}, Ya = function(t) {
  return typeof t === o.STRING;
}, js = function(t) {
  return typeof t === o.BOOLEAN;
}, zr = function(t) {
  return (
    // eslint-disable-next-line
    t !== null && (typeof t === o.NUMBER && !isNaN(t - 0) || typeof t === o.OBJECT && t.constructor === Number)
  );
};
function xr(t) {
  const e = Math.floor(t / 3600), n = Math.floor(t % 3600 / 60), a = Math.floor(t % 60);
  let i = e > 9 ? `${e}` : `0${e}`;
  return i += n > 9 ? `:${n}` : `:0${n}`, i += a > 9 ? `:${a}` : `:0${a}`, i;
}
function hs(t) {
  if (typeof t === o.STRING)
    try {
      return !!JSON.parse(t);
    } catch (e) {
      return console.debug(e), !1;
    }
  return !1;
}
const Jn = function(t) {
  return !t || !hs(t) ? t : JSON.parse(t);
};
function xi(t) {
  return (t == null ? void 0 : t.message.indexOf("is ongoing, please avoid repeated calls")) !== -1;
}
function Cs(t) {
  const { message: e } = t;
  return e.indexOf("NotAllowedError: Permission denied") !== -1;
}
function ma() {
  return Date.now();
}
const ta = function(t) {
  return typeof t === o.FUNCTION;
}, Ls = () => {
  if (Or.getInstance().isWeChat)
    return "zh-cn";
  const t = ((navigator == null ? void 0 : navigator.language) || (navigator == null ? void 0 : navigator.userLanguage) || "").substr(0, 2);
  let e = "en";
  switch (t) {
    case "zh":
      e = "zh-cn";
      break;
    case "ja":
      e = "ja_JP";
      break;
    default:
      e = "en";
  }
  return e;
};
function ys(t) {
}
const ms = function(t) {
  return Object.prototype.toString.call(t).match(/^\[object (.*)\]$/)[1].toLowerCase();
};
function Ss(t, e, n) {
  if (!t.hasOwnProperty(e))
    return t;
  const a = {};
  return Object.keys(t).forEach((i) => {
    i === e ? a[n] = t[i] : a[i] = t[i];
  }), a;
}
const Os = "data:audio/mpeg;base64,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", vi = "data:audio/mpeg;base64,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";
class ws {
  constructor() {
    v(this, "_bellContext", null);
    v(this, "_isMuteBell", !1);
    v(this, "_calleeBellFilePath", vi);
    v(this, "_callRole", De.UNKNOWN);
    v(this, "_callStatus", _.IDLE);
    this._bellContext = new Audio(), this._bellContext.loop = !0;
  }
  setBellSrc() {
    try {
      let e = Os;
      this._callRole === De.CALLEE && (e = this._calleeBellFilePath || vi), this._bellContext.src = e;
    } catch (e) {
      console.warn(`${o.PREFIX}Failed to setBellSrc, ${e}`);
    }
  }
  setBellProperties(e) {
    this._callRole = e.callRole || this._callRole, this._callStatus = e.callStatus || this._callStatus, this._calleeBellFilePath = e.calleeBellFilePath || this._calleeBellFilePath, this._isMuteBell = Aa(e.isMuteBell) ? this._isMuteBell : e.isMuteBell;
  }
  async play() {
    try {
      if (this._callStatus !== _.CALLING)
        return;
      this.setBellSrc(), this._callRole === De.CALLEE && !this._isMuteBell && await this._bellContext.play(), this._callRole === De.CALLER && await this._bellContext.play();
    } catch (e) {
      console.warn(`${o.PREFIX}Failed to play audio file, ${e}`);
    }
  }
  async stop() {
    try {
      await this._bellContext.pause();
    } catch (e) {
      console.warn(`${o.PREFIX}Failed to stop audio file, ${e}`);
    }
  }
  async setBellMute(e) {
    this._callStatus !== _.CALLING && this._callRole !== De.CALLEE || (e ? await this.stop() : await this.play());
  }
  destroy() {
    try {
      this._isMuteBell = !1, this._calleeBellFilePath = "", this._callRole = De.UNKNOWN, this._callStatus = _.IDLE, this._bellContext.pause(), this._bellContext = null;
    } catch (e) {
      console.warn(`${o.PREFIX}Failed to destroy, ${e}`);
    }
  }
}
function Ne() {
  return function(t, e, n) {
    const a = n.value, i = /* @__PURE__ */ new Set();
    return n.value = async function(...r) {
      var s, c;
      if (i.has(this)) {
        console.warn(`${o.PREFIX}previous ${e}() is ongoing, please avoid repeated calls`), (c = (s = this == null ? void 0 : this.getTUICallEngineInstance()) == null ? void 0 : s.reportLog) == null || c.call(s, {
          name: "TUICallKit.avoidRepeatedCall.fail",
          data: { name: e },
          error: `previous ${e}() is ongoing`
        });
        return;
      }
      try {
        i.add(this);
        const l = await a.apply(this, r);
        return i.delete(this), l;
      } catch (l) {
        throw i.delete(this), l;
      }
    }, n;
  };
}
const jn = o.PREFIX + "API";
function be(t) {
  return function(e, n, a) {
    let i = a.value;
    return a.value = function(...r) {
      return Us.call(this, t, r, n), i.apply(this, r);
    }, a;
  };
}
function Us(t, e, n) {
  try {
    if (e[0].SDKAppID || (t = Ss(t, "SDKAppID", "sdkAppID")), Ur(t))
      for (let a = 0; a < t.length; a++)
        Ri.call(this, {
          ...t[a],
          value: e[a],
          name: n
        });
    else
      for (const a in t)
        t.hasOwnProperty(a) && Ri.call(this, {
          ...t[a],
          value: e[0][a],
          name: n,
          key: a
        });
  } catch (a) {
    throw console.error(a), a;
  }
}
function Ri({ required: t, rules: e, range: n, value: a, allowEmpty: i, name: r, key: s }) {
  if (Aa(a)) {
    if (t)
      throw new Error(`${jn}<${r}>: ${s} is required.`);
    return;
  }
  const c = e.some((u) => u === ms(a));
  let l = "";
  if (!c) {
    for (let u = 0; u < e.length; u++) {
      let M = e[u];
      M = M.replace(M[0], M[0].toUpperCase()), l += `${M}/`;
    }
    throw l = l.substring(0, l.length - 1), new Error(`${jn}<${r}>: ${s} must be ${l}, current ${s} is ${typeof a}.`);
  }
  if (i === !1 && Ya(a) && a.trim() === "")
    throw new Error(`${jn}<${r}>: ${s} is blank.`);
  if (Ur(n) && n && n.indexOf(a) === -1)
    throw new Error(`${jn}<${r}>: ${s} error, only be ${n}, current ${s} is ${a}.`);
  if (Ya(n) && n.indexOf("~") !== -1) {
    const u = n.split("~");
    if (a < +u[0] || a > +u[1] || zr(a) && Number.isNaN(a))
      throw new Error(`${jn}<${r}>: ${s} error, only be ${n}, current ${s} is ${a}.`);
  }
}
const _e = {
  init: {
    SDKAppID: {
      required: !0,
      rules: [o.NUMBER],
      allowEmpty: !1
    },
    userID: {
      required: !0,
      rules: [o.STRING],
      allowEmpty: !1
    },
    userSig: {
      required: !0,
      rules: [o.STRING],
      allowEmpty: !1
    },
    tim: {
      required: !1,
      rules: [o.OBJECT]
    }
  },
  call: {
    userID: {
      required: !0,
      rules: [o.STRING],
      allowEmpty: !1
    },
    type: {
      required: !0,
      rules: [o.NUMBER],
      range: [1, 2],
      allowEmpty: !1
    },
    roomID: {
      required: !1,
      rules: [o.NUMBER],
      // 仅支持数字房间号, 后续会支持字符串房间号
      range: `0~${wi}`,
      allowEmpty: !1
    },
    strRoomID: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !0
    },
    userData: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !1
    },
    timeout: {
      required: !1,
      rules: [o.NUMBER],
      allowEmpty: !1
    }
  },
  groupCall: {
    userIDList: {
      required: !0,
      rules: [o.ARRAY],
      allowEmpty: !1
    },
    type: {
      required: !0,
      rules: [o.NUMBER],
      range: [1, 2],
      allowEmpty: !1
    },
    groupID: {
      required: !0,
      rules: [o.STRING],
      allowEmpty: !1
    },
    roomID: {
      required: !1,
      rules: [o.NUMBER],
      // 仅支持数字房间号, 后续会支持字符串房间号
      range: `0~${wi}`,
      allowEmpty: !1
    },
    strRoomID: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !0
    },
    timeout: {
      required: !1,
      rules: [o.NUMBER],
      allowEmpty: !1
    },
    userData: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !1
    },
    offlinePushInfo: {
      required: !1,
      rules: [o.OBJECT],
      allowEmpty: !1
    }
  },
  joinInGroupCall: {
    type: {
      required: !0,
      rules: [o.NUMBER],
      range: [1, 2],
      allowEmpty: !1
    },
    groupID: {
      required: !0,
      rules: [o.STRING],
      allowEmpty: !1
    },
    roomID: {
      required: !0,
      rules: [o.NUMBER],
      allowEmpty: !1
    },
    strRoomID: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !0
    }
  },
  inviteUser: {
    userIDList: {
      required: !0,
      rules: [o.ARRAY],
      allowEmpty: !1
    }
  },
  setSelfInfo: {
    nickName: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !1
    },
    avatar: {
      required: !1,
      rules: [o.STRING],
      allowEmpty: !1
    }
  },
  enableFloatWindow: [
    {
      key: "enable",
      required: !1,
      rules: [o.BOOLEAN],
      allowEmpty: !1
    }
  ],
  enableAIVoice: [
    {
      key: "enable",
      required: !0,
      rules: [o.BOOLEAN],
      allowEmpty: !1
    }
  ],
  enableMuteMode: [
    {
      key: "enable",
      required: !0,
      rules: [o.BOOLEAN],
      allowEmpty: !1
    }
  ],
  setCallingBell: [
    {
      key: "filePath",
      required: !1,
      rules: [o.STRING],
      allowEmpty: !0
    }
  ],
  setLanguage: [
    {
      key: "language",
      required: !0,
      rules: [o.STRING],
      allowEmpty: !1
    }
  ],
  setVideoDisplayMode: [
    {
      key: "displayMode",
      required: !0,
      rules: [o.STRING],
      range: [sn.CONTAIN, sn.COVER, sn.FILL],
      allowEmpty: !1
    }
  ],
  setVideoResolution: [
    {
      key: "resolution",
      required: !0,
      rules: [o.STRING],
      range: [ln.RESOLUTION_1080P, ln.RESOLUTION_480P, ln.RESOLUTION_720P],
      allowEmpty: !1
    }
  ]
};
function da(t) {
  return function(e, n, a) {
    let i = a.value;
    return a.value = function(...r) {
      return zs.call(this, t, r, n), i.apply(this, r);
    }, a;
  };
}
function zs(t) {
  if (t != null && t.engineInstance && !this._tuiCallEngine) {
    const e = `${o.PREFIX} ${k("TUICallKit init is not complete")}`;
    throw console.error(e), e;
  }
}
class xs {
  constructor() {
    v(this, "defaultStore", {
      callStatus: _.IDLE,
      callRole: De.UNKNOWN,
      callMediaType: $.UNKNOWN,
      localUserInfo: { userId: "" },
      localUserInfoExcludeVolume: { userId: "" },
      remoteUserInfoList: [],
      remoteUserInfoExcludeVolumeList: [],
      callerUserInfo: { userId: "" },
      isGroup: !1,
      callDuration: "00:00:00",
      // 通话时长
      callTips: "",
      // 通话提示的信息. 例如: '等待谁接听', 'xxx 拒绝通话', 'xxx 挂断通话'
      toastInfo: { text: "" },
      // 远端用户挂断、拒绝、超时、忙线等的 toast 提示信息
      isMinimized: !1,
      // 用来记录当前是否悬浮窗模式
      enableFloatWindow: !1,
      // 开启/关闭悬浮窗功能，设置为false，通话界面左上角的悬浮窗按钮会隐藏
      bigScreenUserId: "",
      // 当前大屏幕显示的 userID 用户
      language: Ls(),
      // en, zh-cn
      isClickable: !1,
      // 是否可点击, 用于按钮增加 loading 效果，不可点击
      deviceList: { cameraList: [], microphoneList: [], currentCamera: {}, currentMicrophone: {} },
      showPermissionTip: !1,
      netWorkQualityList: [],
      // 显示网络状态差的提示
      isMuteSpeaker: !1,
      groupID: "",
      roomID: 0,
      roomIdType: 0,
      cameraPosition: On.FRONT,
      // 前置或后置，值为front, back
      groupCallMembers: [],
      // chat 群会话在的通话中的成员
      // TUICallKit 组件上的属性
      displayMode: sn.COVER,
      // 设置预览远端的画面显示模式
      videoResolution: ln.RESOLUTION_480P,
      showSelectUser: !1,
      // 小程序相关属性
      pusher: {},
      player: [],
      isEarPhone: !1,
      // 是否是听筒, 默认: false
      pusherId: o.INITIAL_PUSHER,
      // 重新渲染 live-Pusher 的标识位
      // 是否开启虚拟背景, 目前仅 web 支持
      isShowEnableVirtualBackground: !1,
      // 是否显示虚拟背景图标, 默认: false
      enableVirtualBackground: !1,
      // 是否开启虚拟背景， 默认: false
      // customUIConfig
      customUIConfig: {
        button: {},
        viewBackground: {},
        layoutMode: ra.RemoteInLargeView
      }
    });
    v(this, "store", oa(this.defaultStore));
    v(this, "prevStore", oa(this.defaultStore));
  }
  update(e, n) {
    switch (e) {
      case o.CALL_TIPS:
        const a = this.getData(e);
        this.prevStore[e] = a;
      default:
        this.store[e] = n;
    }
  }
  getPrevData(e) {
    return e ? this.prevStore[e] : this.prevStore;
  }
  getData(e) {
    return e ? this.store[e] : this.store;
  }
  // reset call store
  reset(e = []) {
    e.length === 0 && (e = Object.keys(this.store));
    const n = e.reduce((a, i) => ({ ...a, [i]: this.defaultStore[i] }), {});
    this.store = {
      ...this.defaultStore,
      ...this.store,
      ...n
    };
  }
}
var At;
let Na = (At = class {
  constructor() {
    v(this, "task");
    v(this, "storeMap");
    v(this, "timerId", -1);
    this.storeMap = {
      [d.CALL]: new xs()
    }, this.task = {};
  }
  /**
   * 获取 TUIStore 实例
   * @returns {TUIStore}
  */
  static getInstance() {
    return At.instance || (At.instance = new At()), At.instance;
  }
  /**
   * UI 组件注册监听回调
   * @param {StoreName} storeName store 名称
   * @param {IOptions} options 监听信息
   * @param {Object} params 扩展参数
   * @param {String} params.notifyRangeWhenWatch 注册时监听时的通知范围, 'all' - 通知所有注册该 key 的监听; 'myself' - 通知本次注册该 key 的监听; 默认不通知
  */
  watch(e, n, a) {
    this.task[e] || (this.task[e] = {});
    const i = this.task[e];
    Object.keys(n).forEach((r) => {
      const s = n[r];
      i[r] || (i[r] = /* @__PURE__ */ new Map()), i[r].set(s, 1);
      const { notifyRangeWhenWatch: c } = a || {};
      if (c === o.ALL && this.notify(e, r), c === o.MYSELF) {
        const l = this.getData(e, r);
        s.call(this, l);
      }
    });
  }
  /**
   * UI 取消组件监听回调
   * @param {StoreName} storeName store 名称
   * @param {IOptions} options 监听信息,包含需要取消的回掉等
   */
  unwatch(e, n) {
    if (!this.task[e])
      return;
    const a = this.task[e];
    Object.keys(n).forEach((i) => {
      a[i].delete(n[i]);
    });
  }
  /**
   * 通用 store 数据更新，messageList 的变更需要单独处理
   * @param {StoreName} storeName store 名称
   * @param {string} key 变更的 key
   * @param {unknown} data 变更的数据
  */
  update(e, n, a) {
    var i;
    (Ya(a) || zr(a) || js(a)) && this.storeMap[e].store[n] === a || ((i = this.storeMap[e]) == null || i.update(n, a), this.notify(e, n));
  }
  /**
   * 获取 Store 的上一个状态值
   * @param {StoreName} storeName store 名称
   * @param {string} key 待获取的 key
   * @returns {Any}
  */
  getPrevData(e, n) {
    var a;
    return (a = this.storeMap[e]) == null ? void 0 : a.getPrevData(n);
  }
  /**
   * 获取 Store 数据
   * @param {StoreName} storeName store 名称
   * @param {string} key 待获取的 key
   * @returns {Any}
  */
  getData(e, n) {
    var a;
    return (a = this.storeMap[e]) == null ? void 0 : a.getData(n);
  }
  /**
   * UI 组件注册监听回调
   * @param {StoreName} storeName store 名称
   * @param {string} key 变更的 key
  */
  notify(e, n) {
    if (!this.task[e])
      return;
    const a = this.task[e];
    if (a[n]) {
      const i = a[n], r = this.getData(e, n);
      for (const [s] of i.entries())
        s.call(this, r);
    }
  }
  reset(e, n = [], a = !1) {
    if (e in this.storeMap) {
      const i = this.storeMap[e];
      n.length === 0 && (n = Object.keys(i == null ? void 0 : i.store)), i.reset(n), a && n.forEach((r) => {
        this.notify(e, r);
      });
    }
  }
  // 批量修改多个 key-value
  updateStore(e, n) {
    const a = n || d.CALL;
    Object.keys(e).forEach((i) => {
      this.update(a, i, e[i]);
    });
  }
}, v(At, "instance"), At);
const q = Na.getInstance();
function Ga(t, e) {
  const n = {
    userId: t,
    nick: "",
    avatar: "",
    remark: "",
    displayUserInfo: "",
    isAudioAvailable: !1,
    isVideoAvailable: !1,
    isEnter: !1,
    domId: e || t
  };
  return e ? n : { ...n, isEnter: !1 };
}
async function vs(t, e) {
  var a, i, r, s, c;
  let n = Ga(t, o.LOCAL_VIDEO);
  try {
    if (!e)
      return n;
    const l = await e.getMyProfile(), u = q == null ? void 0 : q.getData(d.CALL, o.LOCAL_USER_INFO);
    return (l == null ? void 0 : l.code) === 0 && (n = {
      ...n,
      ...u,
      userId: (a = l == null ? void 0 : l.data) == null ? void 0 : a.userID,
      nick: (i = l == null ? void 0 : l.data) == null ? void 0 : i.nick,
      avatar: (r = l == null ? void 0 : l.data) == null ? void 0 : r.avatar,
      displayUserInfo: ((s = l == null ? void 0 : l.data) == null ? void 0 : s.nick) || ((c = l == null ? void 0 : l.data) == null ? void 0 : c.userID)
    }), n;
  } catch (l) {
    return console.error(`${o.PREFIX}getMyProfile failed, error: ${l}.`), n;
  }
}
async function vn(t, e) {
  let n = t.map((a) => Ga(a));
  try {
    if (!e)
      return n;
    const a = await e.getFriendProfile({ userIDList: t });
    if (a.code === 0) {
      const { friendList: i = [], failureUserIDList: r = [] } = a.data;
      let s = r.map((M) => M.userID);
      if (r.length > 0) {
        const M = await e.getUserProfile({ userIDList: r.map((N) => N.userID) });
        (M == null ? void 0 : M.code) === 0 && (s = (M == null ? void 0 : M.data) || []);
      }
      const c = q == null ? void 0 : q.getData(d.CALL, o.REMOTE_USER_INFO_LIST), l = i.map((M) => M.userID), u = s.map((M) => M.userID);
      n = t.map((M) => {
        var m, L, S, y, w, b, B;
        const N = Ga(M), g = l.indexOf(M), D = u.indexOf(M);
        let T = "", E = "", j = "", p = "";
        g !== -1 && (T = ((m = i[g]) == null ? void 0 : m.remark) || "", E = ((S = (L = i[g]) == null ? void 0 : L.profile) == null ? void 0 : S.nick) || "", j = T || E || N.userId || "", p = ((w = (y = i[g]) == null ? void 0 : y.profile) == null ? void 0 : w.avatar) || ""), D !== -1 && (E = ((b = s[D]) == null ? void 0 : b.nick) || "", j = E || N.userId || "", p = ((B = s[D]) == null ? void 0 : B.avatar) || "");
        const C = c.find((F) => F.userId === M) || {};
        return { ...N, ...C, remark: T, nick: E, displayUserInfo: j, avatar: p };
      });
    }
    return n;
  } catch (a) {
    return console.error(`${o.PREFIX}getRemoteUserProfile failed, error: ${a}.`), n;
  }
}
function Lt(t, e, n) {
  const a = q.getData(d.CALL, o.IS_GROUP);
  let i = `${k(t)}`;
  return a && (i = e ? `${e} ${i}` : i, i = n ? `${i} ${n}` : i), i;
}
function Xn() {
  const t = q.getData(d.CALL, o.CALL_STATUS);
  if (t === _.IDLE)
    return fe.IDLE;
  const e = q.getData(d.CALL, o.IS_GROUP);
  if (t === _.CALLING)
    return e ? fe.DIALING_GROUP : fe.DIALING_C2C;
  const n = q.getData(d.CALL, o.CALL_MEDIA_TYPE);
  return e ? n === $.AUDIO ? fe.CALLING_GROUP_AUDIO : fe.CALLING_GROUP_VIDEO : n === $.AUDIO ? fe.CALLING_C2C_AUDIO : fe.CALLING_C2C_VIDEO;
}
async function Rs(t, e, n, a) {
  let i = [];
  try {
    const r = await e.getGroupMemberList({ groupID: t, count: n, offset: a });
    if (r.code === 0)
      return r.data.memberList || i;
  } catch (r) {
    return console.error(`${o.PREFIX}getGroupMember failed, error: ${r}.`), i;
  }
}
async function bs(t, e) {
  let n = {};
  try {
    return (await e.getGroupProfile({ groupID: t })).data.group || n;
  } catch (a) {
    return console.warn(`${o.PREFIX}getGroupProfile failed, error: ${a}.`), n;
  }
}
function vr(t, e) {
  t === 0 && e ? (q.update(d.CALL, o.ROOM_ID, e), q.update(d.CALL, o.ROOM_ID_TYPE, Ba.STRING_ROOM_ID)) : (q.update(d.CALL, o.ROOM_ID, t), q.update(d.CALL, o.ROOM_ID_TYPE, Ba.NUMBER_ROOM_ID));
}
function Je(t) {
  return t || {};
}
function Sa(t) {
  if (t.length === 0)
    return;
  let e = q.getData(d.CALL, o.REMOTE_USER_INFO_LIST);
  t.forEach((n) => {
    e = e.filter((a) => a.userId !== n);
  }), q.update(d.CALL, o.REMOTE_USER_INFO_LIST, e), q.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, e);
}
function Oa(t) {
  t == null || t.getDeviceList("speaker").then((n) => {
    const a = q.getData(d.CALL, o.DEVICE_LIST), i = (n == null ? void 0 : n[0]) || {};
    q.update(
      d.CALL,
      o.DEVICE_LIST,
      { ...a, speakerList: n, currentSpeaker: i }
    );
  }).catch((n) => {
    console.error(`${o.PREFIX}updateSpeakerList failed, error: ${JSON.stringify(n)}.`);
  }), q.getData(d.CALL, o.CALL_MEDIA_TYPE) === $.VIDEO && (t == null || t.getDeviceList("camera").then((n) => {
    const a = q.getData(d.CALL, o.DEVICE_LIST), i = (n == null ? void 0 : n[0]) || {};
    q.update(
      d.CALL,
      o.DEVICE_LIST,
      { ...a, cameraList: n, currentCamera: i }
    );
  }).catch((n) => {
    console.error(`${o.PREFIX}updateCameraList failed, error: ${n}.`);
  })), t == null || t.getDeviceList("microphones").then((n) => {
    const a = q.getData(d.CALL, o.DEVICE_LIST), i = (n == null ? void 0 : n[0]) || {};
    q.update(
      d.CALL,
      o.DEVICE_LIST,
      { ...a, microphoneList: n, currentMicrophone: i }
    );
  }).catch((n) => {
    console.error(`${o.PREFIX}updateMicrophoneList failed, error: ${n}.`);
  });
}
function wa(t, e, n) {
  if (Cs(t)) {
    let a = "";
    e === $.AUDIO && (a = Lt(Ce.NO_MICROPHONE_DEVICE_PERMISSION)), e === $.VIDEO && (a = Lt(Ce.NO_CAMERA_DEVICE_PERMISSION));
    const i = n == null ? void 0 : n.getDevicePermission();
    i != null && i.audio || q.update(d.CALL, o.SHOW_PERMISSION_TIP, !0), a && q.update(d.CALL, o.TOAST_INFO, { text: a, type: o.ERROR }), console.error(`${o.PREFIX}call failed, error: ${t.message}.`);
  }
}
function kt(t, e) {
  let n = q.getData(d.CALL, o.LOCAL_USER_INFO);
  e === o.AUDIO && (n = { ...n, isAudioAvailable: t }), e === o.VIDEO && (n = { ...n, isVideoAvailable: t }), q.update(d.CALL, o.LOCAL_USER_INFO, n), q.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, n);
}
class la {
  static generateTaskID() {
    return this.currentTaskID++;
  }
  /**
   *
   * @param {string} taskName 'interval' 'timeout'
   * @param {function} callback
   * @param {object} options include:
   * @param {number} options.delay millisecond
   * @param {number} options.count 定时器回调执行次数，0 无限次 or n次
   * @param {boolean} options.backgroundTask 在页面静默后是否继续执行定时器
   */
  static run(e = o.TIMEOUT, n, a) {
    e === o.INTERVAL ? a = { delay: 2e3, count: 0, backgroundTask: !0, ...a } : a = { delay: 2e3, count: 0, backgroundTask: !0, ...a }, wr(n) && (a = { ...a, ...n }), ta(e) && (n = e, e = o.TIMEOUT);
    const i = {
      taskID: this.generateTaskID(),
      loopCount: 0,
      intervalID: null,
      timeoutID: null,
      taskName: e,
      callback: n,
      ...a
    };
    return this.taskMap.set(i.taskID, i), e === o.INTERNAL ? this.interval(i) : this.timeout(i), i.taskID;
  }
  /**
   * 定时循环执行回调函数
   * 可以指定循环的时间间隔
   * 可以指定循环次数
   * @param {object} taskItem
   * @param {function} callback
   * @param {*} delay
   * @param {*} count
   * @returns ID
   */
  static interval(e) {
    const n = () => {
      e.callback(), e.loopCount += 1, this.isBreakLoop(e);
    };
    return e.intervalID = setInterval(n, e.delay);
  }
  /**
   * 延迟执行回调
   * count = 0,循环
   * count = n, 执行n次
   * @param {object} taskItem
   *
   */
  static timeout(e) {
    const n = () => {
      if (e.callback(), e.loopCount += 1, !this.isBreakLoop(e))
        return e.timeoutID = setTimeout(n, e.delay);
    };
    return e.timeoutID = setTimeout(n, e.delay);
  }
  static hasTask(e) {
    return this.taskMap.has(e);
  }
  static clearTask(e) {
    if (!this.taskMap.has(e))
      return !0;
    const { intervalID: n, timeoutID: a, onVisibilitychange: i } = this.taskMap.get(e);
    return n && clearInterval(n), a && clearTimeout(a), i && document.removeEventListener("visibilitychange", i), this.taskMap.delete(e), !0;
  }
  /**
   * 1. 如果已移除出定时队列，退出当前任务
   * 2. 如果当前任务已满足次数限制，则退出当前任务
   * @param {object} taskItem
   * @returns
   */
  static isBreakLoop(e) {
    return this.taskMap.has(e.taskID) ? e.count !== 0 && e.loopCount >= e.count ? (this.clearTask(e.taskID), !0) : !1 : !0;
  }
}
v(la, "taskMap", /* @__PURE__ */ new Map()), v(la, "currentTaskID", 1);
const _s = function(t) {
  if (t === null || typeof t > "u")
    return !0;
  if (typeof t == "boolean")
    return !1;
  if (typeof t == "number")
    return t === 0;
  if (typeof t == "string" || typeof t == "function" || Array.isArray(t))
    return t.length === 0;
  if (t instanceof Error)
    return t.message === "";
  if (wr(t)) {
    for (const e in t)
      if (Object.prototype.hasOwnProperty.call(t, e))
        return !1;
    return !0;
  }
  return !1;
}, Ua = "_local_user_id", Ft = class Ft {
  constructor() {
    v(this, "_viewConfig", {
      viewBackground: {
        local: {},
        remote: {}
      }
    });
    v(this, "_isSetViewBackgroundConfig", { remote: !1, local: !1 });
    v(this, "_tuiCallEngine", null);
    v(this, "_tuiStore", null);
  }
  static getInstance() {
    return Ft.instance || (Ft.instance = new Ft()), Ft.instance;
  }
  _updateViewBackground() {
    var a, i, r;
    const e = (a = this._tuiStore) == null ? void 0 : a.getData(d.CALL, o.CUSTOM_UI_CONFIG), { userId: n } = (i = this._tuiStore) == null ? void 0 : i.getData(d.CALL, o.LOCAL_USER_INFO);
    Object.keys(this._viewConfig.viewBackground.remote).includes(n) && delete this._viewConfig.viewBackground.remote[n], (r = this._tuiStore) == null || r.update(
      d.CALL,
      o.CUSTOM_UI_CONFIG,
      {
        ...e,
        viewBackground: {
          ...this._viewConfig.viewBackground.remote,
          ...this._viewConfig.viewBackground.local
        }
      }
    );
  }
  setEngineInstance(e) {
    this._tuiCallEngine = e;
  }
  setTUIStore(e) {
    this._tuiStore = e;
  }
  updateViewBackgroundUserId(e) {
    var n, a;
    if (e === "local") {
      const { userId: i } = (n = this._tuiStore) == null ? void 0 : n.getData(d.CALL, o.LOCAL_USER_INFO);
      if (Object.keys(this._viewConfig.viewBackground.remote).includes(i) && (delete this._viewConfig.viewBackground.remote[i], this._updateViewBackground()), !this._isSetViewBackgroundConfig.local)
        return;
      const r = this._viewConfig.viewBackground.local, s = r[i] || r[Ua];
      r[i] = r[Ua], this._viewConfig.viewBackground.local = { [i]: s }, this._updateViewBackground();
    } else {
      let i = this._viewConfig.viewBackground.remote;
      this._isSetViewBackgroundConfig.remote && Object.keys(i).includes("*") && (((a = this._tuiStore) == null ? void 0 : a.getData(d.CALL, o.REMOTE_USER_INFO_LIST)).map((c) => c.userId).forEach((c) => {
        Object.keys(i).includes(c) || (i[c] = i["*"]);
      }), this._viewConfig.viewBackground.remote = i, this._updateViewBackground());
    }
  }
  hideFeatureButton(e) {
    var a, i, r, s, c;
    (i = (a = this._tuiCallEngine) == null ? void 0 : a.reportLog) == null || i.call(a, {
      name: "TUICallKit.hideFeatureButton.start",
      data: { buttonName: e }
    });
    const n = (r = this._tuiStore) == null ? void 0 : r.getData(d.CALL, o.CUSTOM_UI_CONFIG);
    (c = this._tuiStore) == null || c.update(
      d.CALL,
      o.CUSTOM_UI_CONFIG,
      {
        ...n,
        button: {
          ...n.button,
          [e]: { ...((s = n.button) == null ? void 0 : s[e]) || {}, show: !1 }
        }
      }
    );
  }
  setLocalViewBackgroundImage(e) {
    var a, i, r;
    (i = (a = this._tuiCallEngine) == null ? void 0 : a.reportLog) == null || i.call(a, {
      name: "TUICallKit.setLocalViewBackgroundImage.start",
      data: { url: e }
    }), this._isSetViewBackgroundConfig.local = !0;
    let { userId: n } = (r = this._tuiStore) == null ? void 0 : r.getData(d.CALL, o.LOCAL_USER_INFO);
    _s(n) && (n = Ua), this._viewConfig.viewBackground.local = { [n]: e }, this._updateViewBackground();
  }
  setRemoteViewBackgroundImage(e, n) {
    var a, i;
    (i = (a = this._tuiCallEngine) == null ? void 0 : a.reportLog) == null || i.call(a, {
      name: "TUICallKit.setRemoteViewBackgroundImage.start",
      data: { userId: e, url: n }
    }), this._isSetViewBackgroundConfig.remote = !0, e === "*" && (this._viewConfig.viewBackground.remote = {}), this._viewConfig.viewBackground.remote[e] = n, this._updateViewBackground();
  }
  setLayoutMode(e) {
    var a, i;
    (i = (a = this._tuiCallEngine) == null ? void 0 : a.reportLog) == null || i.call(a, {
      name: "TUICallKit.setLayoutMode.start",
      data: { layoutMode: e }
    });
    const n = this._tuiStore.getData(d.CALL, o.CUSTOM_UI_CONFIG);
    this._tuiStore.update(
      d.CALL,
      o.CUSTOM_UI_CONFIG,
      {
        ...n,
        layoutMode: e
      }
    );
  }
  setCameraDefaultState(e) {
    var a, i;
    (i = (a = this._tuiCallEngine) == null ? void 0 : a.reportLog) == null || i.call(a, {
      name: "TUICallKit.setCameraDefaultState.start",
      data: { isOpen: e }
    });
    const n = oa(this._tuiStore.getData(d.CALL, o.CUSTOM_UI_CONFIG));
    Object.keys(n.button).includes(Wt.Camera) || (n.button[Wt.Camera] = {}), n.button[Wt.Camera].state = e ? cn.Open : cn.Close, this._tuiStore.update(d.CALL, o.CUSTOM_UI_CONFIG, n);
  }
};
v(Ft, "instance");
let ca = Ft;
const Kn = Na.getInstance(), Xe = {
  audioCall: () => k("Voice call"),
  videoCall: () => k("Video call"),
  switchToAudio: () => k("Switch audio call"),
  switchToVideo: () => k("Switch video call"),
  hangup: ({ callDuration: t }) => `${k("Call duration")}：${t}`
}, Zt = class Zt {
  constructor(e) {
    v(this, "_callService");
    var n, a, i;
    this._callService = e.callService, pn.registerEvent(de.TUILogin.EVENT.LOGIN_STATE_CHANGED, de.TUILogin.EVENT_SUB_KEY.USER_LOGIN_SUCCESS, this), (n = de.TUIChat) != null && n.EVENT && pn.registerEvent((a = de.TUIChat.EVENT) == null ? void 0 : a.CHAT_STATE_CHANGED, (i = de.TUIChat.EVENT_SUB_KEY) == null ? void 0 : i.CHAT_OPENED, this), pn.registerService(de.TUICalling.SERVICE.NAME, this), pn.registerExtension(de.TUIChat.EXTENSION.INPUT_MORE.EXT_ID, this);
  }
  static getInstance(e) {
    return Zt.instance || (Zt.instance = new Zt(e)), Zt.instance;
  }
  // ================ 【】 ================
  /**
   * message on screen
   * @param {Any} params Parameters for message up-screening
   */
  callTUIService(e) {
    const { message: n } = e || {};
    pn.callService({
      serviceName: de.TUIChat.SERVICE.NAME,
      method: de.TUIChat.SERVICE.METHOD.UPDATE_MESSAGE_LIST,
      params: { message: n }
    });
  }
  /**
   * tuicore getExtension
   * @param {String} extensionID extension id
   * @param {Any} params tuicore pass parameters
   * @returns {Any[]} return extension
   */
  onGetExtension(e, n) {
    var a, i;
    if (e === de.TUIChat.EXTENSION.INPUT_MORE.EXT_ID) {
      if ((i = (a = this._callService.getTUICallEngineInstance()) == null ? void 0 : a.reportLog) == null || i.call(a, { name: "TUICallKit.onGetExtension", data: { extensionID: e, params: n } }), Aa(n))
        return [];
      if ([de.TUIChat.TYPE.ROOM, de.TUIChat.TYPE.CUSTOMER_SERVICE].includes(n.chatType))
        return [];
      let r = [];
      const s = {
        weight: 1e3,
        text: "语音通话",
        icon: ss,
        data: {
          name: "voiceCall"
        },
        listener: {
          onClicked: async (l) => await this._handleTUICoreOnClick(l, l.type || $.AUDIO)
        }
      }, c = {
        weight: 900,
        text: "视频通话",
        icon: ls,
        data: {
          name: "videoCall"
        },
        listener: {
          onClicked: async (l) => await this._handleTUICoreOnClick(l, l.type || $.VIDEO)
        }
      };
      return n != null && n.chatType ? r = [s, c] : (!(n != null && n.filterVoice) && r.push(s), !(n != null && n.filterVideo) && r.push(c)), r;
    }
  }
  async onCall(e, n) {
    e === de.TUICalling.SERVICE.METHOD.START_CALL && await this._handleTUICoreOnClick(n, n.type);
  }
  /**
   * tuicore notify event manager
   * @param {String} eventName event name
   * @param {String} subKey sub key
   * @param {Any} options tuicore event parameters
   */
  async onNotifyEvent(e, n, a) {
    var i, r, s, c, l, u, M, N;
    try {
      if (e === de.TUILogin.EVENT.LOGIN_STATE_CHANGED)
        if (n === de.TUILogin.EVENT_SUB_KEY.USER_LOGIN_SUCCESS) {
          const { chat: g, userID: D, userSig: T, SDKAppID: E } = Xo.getContext();
          await ((i = this._callService) == null ? void 0 : i.init({ tim: g, userID: D, userSig: T, sdkAppID: E, isFromChat: !0, component: ii.TIM_CALL_KIT })), (r = this._callService) == null || r.setIsFromChat(!0), (s = this._callService) == null || s.setLogLevel(Cr.NORMAL), this._addListenChatEvent();
        } else
          n === de.TUILogin.EVENT_SUB_KEY.USER_LOGOUT_SUCCESS && (this._removeListenChatEvent(), await ((c = this._callService) == null ? void 0 : c.destroyed()));
      if ((l = de.TUIChat) != null && l.EVENT && e === de.TUIChat.EVENT.CHAT_STATE_CHANGED && n === de.TUIChat.EVENT_SUB_KEY.CHAT_OPENED) {
        if ((u = this._callService) == null || u.setCurrentGroupId((a == null ? void 0 : a.groupID) || ""), Kn.getData(d.CALL, o.CALL_STATUS) !== _.IDLE)
          return;
        const g = (M = this._callService) == null ? void 0 : M.getCurrentGroupId(), D = g ? await this.getGroupAttributes((N = this._callService) == null ? void 0 : N.getTim(), g) : {};
        await this.updateStoreBasedOnGroupAttributes(D);
      }
    } catch (g) {
      console.error(`${o.PREFIX}TUICore onNotifyEvent failed, error: ${g}.`);
    }
  }
  // Handling the chat+call scenario, data required for the joinInGroupCall API: update store / clear relevant store data
  async updateStoreBasedOnGroupAttributes(e) {
    var n, a, i, r;
    (i = (a = (n = this._callService) == null ? void 0 : n.getTUICallEngineInstance()) == null ? void 0 : a.reportLog) == null || i.call(a, {
      name: "TUICallKit.getJoinGroupCallInfo.success",
      data: { groupAttributes: e }
    });
    try {
      const {
        group_id: s = "",
        room_id: c = 0,
        room_id_type: l = 0,
        call_media_type: u = o.UNKNOWN,
        // @ts-ignore
        user_list: M
        // The default value of the user list returned by the background is null
      } = e[o.INNER_ATTR_KIT_INFO] ? JSON.parse(e[o.INNER_ATTR_KIT_INFO]) : {};
      let N = (M || []).map((D) => D.userid);
      N = N.length && await vn(N, (r = this._callService) == null ? void 0 : r.getTim());
      const g = {
        [o.GROUP_ID]: s,
        [o.GROUP_CALL_MEMBERS]: N,
        [o.ROOM_ID]: c,
        [o.CALL_MEDIA_TYPE]: as[u],
        [o.ROOM_ID_TYPE]: l
      };
      Kn.updateStore(g, d.CALL);
    } catch (s) {
      console.warn(`${o.PREFIX}updateStoreBasedOnGroupAttributes fail, error: ${s}`);
    }
  }
  // Get group attribute
  async getGroupAttributes(e, n) {
    if (!n)
      return {};
    try {
      const { data: a } = await e.getGroupAttributes({
        groupID: n,
        keyList: []
      });
      return (a == null ? void 0 : a.groupAttributes) || {};
    } catch (a) {
      return console.warn(`${o.PREFIX}getGroupAttributes fail: ${a}`), {};
    }
  }
  isLineBusy(e) {
    var i;
    const n = Jn(e.payload.data), a = Jn(n == null ? void 0 : n.data);
    return (a == null ? void 0 : a.line_busy) === "line_busy" || (a == null ? void 0 : a.line_busy) === "" || ((i = a == null ? void 0 : a.data) == null ? void 0 : i.message) === "lineBusy";
  }
  async getCallKitMessage(e, n) {
    var g, D, T, E;
    const a = Jn(e.payload.data);
    if ((a == null ? void 0 : a.businessID) !== 1)
      return {};
    let i = "";
    const r = Jn(a == null ? void 0 : a.data), s = r.call_type, c = a.inviteeList, l = (g = r == null ? void 0 : r.data) == null ? void 0 : g.inviter, u = Kn.getData(d.CALL, o.LOCAL_USER_INFO).userId, M = l === u, N = (D = r == null ? void 0 : r.data) == null ? void 0 : D.cmd;
    switch (a == null ? void 0 : a.actionType) {
      case rn.INVITE: {
        i = Xe[N]({ callDuration: xr(r == null ? void 0 : r.call_end) });
        break;
      }
      case rn.CANCEL_INVITE:
        i = k(M ? "Call Cancel" : "Other Side Cancel");
        break;
      case rn.ACCEPT_INVITE:
        ["switchToAudio", "switchToVideo"].includes(N) ? i = (T = Xe == null ? void 0 : Xe[N]) == null ? void 0 : T.call(Xe) : i = k("Answered");
        break;
      case rn.REJECT_INVITE:
        this.isLineBusy(e) ? i = k(M ? "Line Busy" : "Other Side Line Busy") : i = k(M ? "Other Side Decline" : "Decline");
        break;
      case rn.INVITE_TIMEOUT:
        ["switchToAudio", "switchToVideo"].includes(N) ? i = (E = Xe == null ? void 0 : Xe[N]) == null ? void 0 : E.call(Xe) : i = k(M ? "Other Side No Answer" : "No answer");
        break;
    }
    return { messageCardContent: i, callMediaType: s, inviteeList: c };
  }
  // =========================【chat: event listening】=========================
  _addListenChatEvent() {
    var e, n;
    if (!((e = this._callService) != null && e.getTim())) {
      console.warn(`${o.PREFIX}add tim event listener failed, tim is empty.`);
      return;
    }
    (n = this._callService) == null || n.getTim().on(Si.EVENT.GROUP_ATTRIBUTES_UPDATED, this._handleGroupAttributesUpdated, this);
  }
  _removeListenChatEvent() {
    var e, n;
    if (!((e = this._callService) != null && e.getTim())) {
      console.warn(`${o.PREFIX}remove tim event listener failed, tim is empty.`);
      return;
    }
    (n = this._callService) == null || n.getTim().off(Si.EVENT.GROUP_ATTRIBUTES_UPDATED, this._handleGroupAttributesUpdated, this);
  }
  /**
   * chat start audio/video call via click
   * @param {Any} options Parameters passed in when clicking on an audio/video call from chat
   * @param {CallMediaType} type call media type. 0 - audio; 1 - video.
   */
  async _handleTUICoreOnClick(e, n) {
    var a, i;
    try {
      const { groupID: r, userIDList: s = [], ...c } = e;
      r ? await ((a = this._callService) == null ? void 0 : a.groupCall({ groupID: r, userIDList: s, type: n, ...c })) : s.length === 1 && await ((i = this._callService) == null ? void 0 : i.call({ userID: s[0], type: n, ...c }));
    } catch (r) {
      console.debug(r);
    }
  }
  async _handleGroupAttributesUpdated(e) {
    var r;
    if (Kn.getData(d.CALL, o.CALL_STATUS) !== _.IDLE)
      return;
    const n = (e == null ? void 0 : e.data) || {}, { groupID: a = "", groupAttributes: i = {} } = n;
    a === ((r = this._callService) == null ? void 0 : r.getCurrentGroupId()) && await this.updateStoreBasedOnGroupAttributes(i);
  }
};
v(Zt, "instance");
let Fa = Zt;
const ks = 0, Vs = 1, bi = 2;
function Qs({ retryFunction: t, settings: e, onError: n, onRetrying: a, onRetryFailed: i, context: r }) {
  return function(...s) {
    const c = e.retries || 5;
    let l = 0, u = -1, M = ks;
    const N = async (g, D) => {
      const T = r || this;
      try {
        const E = await t.apply(T, s);
        l = 0, g(E);
      } catch (E) {
        const j = () => {
          clearTimeout(u), l = 0, M = bi, D(E);
        }, p = () => {
          M !== bi && l < c ? (l++, M = Vs, ta(a) && a.call(T, l, j), u = setTimeout(
            () => {
              u = -1, N(g, D);
            },
            Aa(e.timeout) ? 1e3 : e.timeout
          )) : (j(), ta(i) && i.call(T, E));
        };
        ta(n) ? n.call(T, E, p, D, s) : p();
      }
    };
    return new Promise(N);
  };
}
function Bs(t) {
  return function(e, n, a) {
    const { retries: i = 5, timeout: r = 2e3, onError: s, onRetrying: c, onRetryFailed: l } = t, u = Qs({
      retryFunction: a.value,
      settings: { retries: i, timeout: r },
      onError: s,
      onRetrying: c,
      onRetryFailed: l,
      context: null
    });
    return a.value = function(...M) {
      return u.apply(this, M);
    }, a;
  };
}
var Ys = Object.defineProperty, Gs = Object.getOwnPropertyDescriptor, Fs = (t, e, n, a) => {
  for (var i = a > 1 ? void 0 : a ? Gs(e, n) : e, r = t.length - 1, s; r >= 0; r--)
    (s = t[r]) && (i = (a ? s(e, n, i) : s(i)) || i);
  return a && i && Ys(e, n, i), i;
};
const Y = Na.getInstance(), Zs = ca.getInstance();
var dt;
const Rr = (dt = class {
  constructor(e) {
    v(this, "_callService");
    this._callService = e.callService;
  }
  static getInstance(e) {
    return dt.instance || (dt.instance = new dt(e)), dt.instance;
  }
  addListenTuiCallEngineEvent() {
    var n;
    const e = (n = this._callService) == null ? void 0 : n.getTUICallEngineInstance();
    if (!e) {
      console.warn(`${o.PREFIX}add engine event listener failed, engine is empty.`);
      return;
    }
    e.on(R.ERROR, this._handleError, this), e.on(R.INVITED, this._handleNewInvitationReceived, this), e.on(R.USER_ACCEPT, this._handleUserAccept, this), e.on(R.USER_ENTER, this._handleUserEnter, this), e.on(R.USER_LEAVE, this._handleUserLeave, this), e.on(R.REJECT, this._handleInviteeReject, this), e.on(R.NO_RESP, this._handleNoResponse, this), e.on(R.LINE_BUSY, this._handleLineBusy, this), e.on(R.CALLING_CANCEL, this._handleCallingCancel, this), e.on(R.SDK_READY, this._handleSDKReady, this), e.on(R.KICKED_OUT, this._handleKickedOut, this), e.on(R.MESSAGE_SENT_BY_ME, this._messageSentByMe, this), R.CALL_MESSAGE && e.on(R.CALL_MESSAGE, this._handleCallMessage, this), R.ON_USER_NETWORK_QUALITY_CHANGED && e.on(R.ON_USER_NETWORK_QUALITY_CHANGED, this._handleNetworkQuality, this), e.on(R.CALLING_END, this._handleCallingEnd, this), e.on(R.CALL_TYPE_CHANGED, this._handleCallTypeChange, this), e.on(R.USER_VIDEO_AVAILABLE, this._handleUserVideoAvailable, this), e.on(R.USER_AUDIO_AVAILABLE, this._handleUserAudioAvailable, this), e.on(R.USER_VOICE_VOLUME, this._handleUserVoiceVolume, this), e.on(R.DEVICED_UPDATED, this._handleDeviceUpdate, this);
  }
  removeListenTuiCallEngineEvent() {
    var n;
    const e = (n = this._callService) == null ? void 0 : n.getTUICallEngineInstance();
    e.off(R.ERROR, this._handleError, this), e.off(R.INVITED, this._handleNewInvitationReceived, this), e.off(R.USER_ACCEPT, this._handleUserAccept, this), e.off(R.USER_ENTER, this._handleUserEnter, this), e.off(R.USER_LEAVE, this._handleUserLeave, this), e.off(R.REJECT, this._handleInviteeReject, this), e.off(R.NO_RESP, this._handleNoResponse, this), e.off(R.LINE_BUSY, this._handleLineBusy, this), e.off(R.CALLING_CANCEL, this._handleCallingCancel, this), e.off(R.SDK_READY, this._handleSDKReady, this), e.off(R.KICKED_OUT, this._handleKickedOut, this), e.off(R.MESSAGE_SENT_BY_ME, this._messageSentByMe, this), R.ON_USER_NETWORK_QUALITY_CHANGED && e.off(R.ON_USER_NETWORK_QUALITY_CHANGED, this._handleNetworkQuality, this), e.off(R.CALLING_END, this._handleCallingEnd, this), e.off(R.CALL_TYPE_CHANGED, this._handleCallTypeChange, this), e.off(R.USER_VIDEO_AVAILABLE, this._handleUserVideoAvailable, this), e.off(R.USER_AUDIO_AVAILABLE, this._handleUserAudioAvailable, this), e.off(R.USER_VOICE_VOLUME, this._handleUserVoiceVolume, this), e.off(R.DEVICED_UPDATED, this._handleDeviceUpdate, this);
  }
  _callerChangeToConnected() {
    var a;
    const e = Y.getData(d.CALL, o.CALL_ROLE);
    Y.getData(d.CALL, o.CALL_STATUS) === _.CALLING && e === De.CALLER && (Y.update(d.CALL, o.CALL_STATUS, _.CONNECTED), (a = this._callService) == null || a.startTimer());
  }
  _unNormalEventsManager(e, n) {
    var r;
    console.log(`${o.PREFIX}${n} event data: ${JSON.stringify(e)}.`);
    const a = Y.getData(d.CALL, o.IS_GROUP), i = Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST);
    switch (n) {
      case R.REJECT:
      case R.LINE_BUSY: {
        const { userID: s } = Je(e);
        let c = n === R.REJECT ? Ce.OTHER_SIDE_REJECT_CALL : Ce.OTHER_SIDE_LINE_BUSY, l = Lt(c);
        if (a) {
          const u = (i.find((M) => M.userId === s) || {}).displayUserInfo || s;
          c = n === R.REJECT ? Ce.REJECT_CALL : Ce.IN_BUSY, l = Lt(c, u);
        }
        Y.update(d.CALL, o.TOAST_INFO, { text: l }), s && Sa([s]);
        break;
      }
      case R.NO_RESP: {
        const { userIDList: s = [] } = Je(e), c = a ? Ce.TIMEOUT : Ce.CALL_TIMEOUT, l = s.map((M) => (i.find((g) => g.userId === M) || {}).displayUserInfo || M), u = a ? Lt(c, l.join()) : Lt(c);
        Y.update(d.CALL, o.TOAST_INFO, { text: u }), s.length > 0 && Sa(s);
        break;
      }
      case R.CALLING_CANCEL: {
        (r = this._callService) == null || r._resetCallStore();
        break;
      }
    }
  }
  _handleError(e) {
    var s;
    const { code: n, message: a } = e || {}, i = Object.values(Oi).indexOf(n);
    let r = "";
    if (i !== -1) {
      const c = Object.keys(Oi)[i];
      r = k(is[c]), r && Y.update(d.CALL, o.TOAST_INFO, { text: r, type: o.ERROR });
    }
    (s = this._callService) == null || s.executeExternalAfterCalling(), console.error(`${o.PREFIX}_handleError, errorCode: ${n}; errorMessage: ${r || a}.`);
  }
  async _handleNewInvitationReceived(e) {
    var p, C, m, L;
    console.log(`${o.PREFIX}onCallReceived event data: ${JSON.stringify(e)}.`);
    const { sponsor: n = "", isFromGroup: a, callMediaType: i, inviteData: r = {}, calleeIdList: s = [], groupID: c = "", roomID: l, strRoomID: u } = Je(e), M = Y.getData(d.CALL, o.LOCAL_USER_INFO), N = [n, ...s.filter((S) => S !== M.userId)], g = i || r.callType, D = g === $.AUDIO ? Ce.CALLEE_CALLING_AUDIO_MSG : Ce.CALLEE_CALLING_VIDEO_MSG;
    let T = {
      [o.CALL_ROLE]: De.CALLEE,
      [o.IS_GROUP]: a,
      [o.CALL_STATUS]: _.CALLING,
      [o.CALL_MEDIA_TYPE]: g,
      [o.CALL_TIPS]: k(D),
      [o.CALLER_USER_INFO]: { userId: n },
      [o.GROUP_ID]: c
    };
    vr(l, u), Y.updateStore(T, d.CALL), (p = this._callService) == null || p.executeExternalBeforeCalling(), (C = this._callService) != null && C.statusChanged && ((m = this._callService) == null || m.statusChanged({ oldStatus: fe.IDLE, newStatus: fe.BE_INVITED }));
    const E = await vn(N, (L = this._callService) == null ? void 0 : L.getTim()), [j] = E.filter((S) => S.userId === n);
    E.length > 0 && Y.updateStore({
      [o.REMOTE_USER_INFO_LIST]: E,
      [o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST]: E,
      [o.CALLER_USER_INFO]: {
        userId: n,
        nick: (j == null ? void 0 : j.nick) || "",
        avatar: (j == null ? void 0 : j.avatar) || "",
        displayUserInfo: (j == null ? void 0 : j.remark) || (j == null ? void 0 : j.nick) || n
      }
    }, d.CALL);
  }
  _handleUserAccept(e) {
    this._callerChangeToConnected(), Y.update(d.CALL, o.TOAST_INFO, k("answered")), console.log(`${o.PREFIX}accept event data: ${JSON.stringify(e)}.`);
  }
  async _handleUserEnter(e) {
    var s;
    this._callerChangeToConnected();
    const { userID: n, data: a } = Je(e);
    let i = Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST);
    if (!i.find((c) => (c == null ? void 0 : c.userId) === n)) {
      i.push({ userId: n }), i.length > 0 && (Y.update(d.CALL, o.REMOTE_USER_INFO_LIST, i), Y.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, i));
      const [c] = await vn([n], (s = this._callService) == null ? void 0 : s.getTim());
      i = Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST), i.forEach((l) => {
        (l == null ? void 0 : l.userId) === n && (l = Object.assign(l, c));
      });
    }
    i = i.map((c) => (c.userId === n && (c.isEnter = !0), c)), i.length > 0 && (Y.update(d.CALL, o.REMOTE_USER_INFO_LIST, i), Y.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, i), Zs.updateViewBackgroundUserId("remote")), console.log(`${o.PREFIX}userEnter event data: ${JSON.stringify(e)}.`);
  }
  _handleUserLeave(e) {
    console.log(`${o.PREFIX}userLeave event data: ${JSON.stringify(e)}.`);
    const { data: n, userID: a } = Je(e);
    if (Y.getData(d.CALL, o.IS_GROUP)) {
      const r = (Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST).find((c) => c.userId === a) || {}).displayUserInfo || a, s = Lt(Ce.END_CALL, r);
      Y.update(d.CALL, o.TOAST_INFO, { text: s });
    }
    a && Sa([a]);
  }
  _handleInviteeReject(e) {
    this._unNormalEventsManager(e, R.REJECT);
  }
  _handleNoResponse(e) {
    this._unNormalEventsManager(e, R.NO_RESP);
  }
  _handleLineBusy(e) {
    this._unNormalEventsManager(e, R.LINE_BUSY);
  }
  _handleCallingCancel(e) {
    var n;
    (n = this._callService) == null || n.executeExternalAfterCalling(), this._unNormalEventsManager(e, R.CALLING_CANCEL);
  }
  _handleCallingEnd(e) {
    var n, a;
    console.log(`${o.PREFIX}callEnd event data: ${JSON.stringify(e)}.`), (n = this._callService) == null || n.executeExternalAfterCalling(), (a = this._callService) == null || a._resetCallStore();
  }
  // SDK_READY 后才能调用 tim 接口, 否则登录后立刻获取导致调用接口失败. v2.27.4+、v3 接口 login 后会抛出 SDK_READY
  async _handleSDKReady(e) {
    var a, i, r;
    let n = Y.getData(d.CALL, o.LOCAL_USER_INFO);
    n = await vs(n.userId, (a = this._callService) == null ? void 0 : a.getTim()), (r = this._callService) == null || r.setDefaultOfflinePushInfo({ ...(i = this._callService) == null ? void 0 : i.getDefaultOfflinePushInfo(), title: n == null ? void 0 : n.displayUserInfo }), Y.update(d.CALL, o.LOCAL_USER_INFO, n), Y.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, n);
  }
  _handleKickedOut(e) {
    var n, a, i;
    console.log(`${o.PREFIX}kickOut event data: ${JSON.stringify(e)}.`), (n = this._callService) != null && n.kickedOut && ((a = this._callService) == null || a.kickedOut(e)), Y.update(d.CALL, o.CALL_TIPS, Lt(Ce.KICK_OUT)), (i = this._callService) == null || i._resetCallStore();
  }
  _messageSentByMe(e) {
    var a, i;
    const n = e == null ? void 0 : e.data;
    (a = this._callService) != null && a.onMessageSentByMe && ((i = this._callService) == null || i.onMessageSentByMe(n));
  }
  _handleCallMessage(e) {
    const n = Je(e);
    this._callService._chatCombine.callTUIService({ message: n });
  }
  _handleCallTypeChange(e) {
    const { newCallType: n, type: a } = Je(e);
    Y.update(d.CALL, o.CALL_MEDIA_TYPE, n || a);
  }
  _handleNetworkQuality(e) {
    const { networkQualityList: n = [] } = Je(e);
    Y.update(d.CALL, o.NETWORK_STATUS, n);
    const a = Y.getData(d.CALL, o.IS_GROUP), i = Y.getData(d.CALL, o.LOCAL_USER_INFO);
    if (Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST), !a && n.find((s) => (i == null ? void 0 : i.userId) === (s == null ? void 0 : s.userId) && (s == null ? void 0 : s.quality) >= us)) {
      Y.update(d.CALL, o.CALL_TIPS, k(Ce.LOCAL_NETWORK_IS_POOR));
      return;
    }
  }
  async _startRemoteView(e) {
    var n;
    if (!e) {
      console.warn(`${o.PREFIX}_startRemoteView userID is empty`);
      return;
    }
    if (!document.getElementById(e))
      return console.warn(`${o.PREFIX}_startRemoteView can't find HTMLElement sid: ${e}`), Promise.reject();
    try {
      const a = Y.getData(d.CALL, o.DISPLAY_MODE);
      await ((n = this._callService) == null ? void 0 : n.getTUICallEngineInstance().startRemoteView({ userID: e, videoViewDomID: e, options: { objectFit: a } }));
    } catch (a) {
      return console.error(`${o.PREFIX}_startRemoteView error: ${a}.`), Promise.reject(a);
    }
  }
  _setRemoteUserInfoAudioVideoAvailable(e, n, a) {
    let i = Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST);
    i = i.map((r) => {
      if (r.userId === a) {
        if (n === o.AUDIO)
          return { ...r, isAudioAvailable: e };
        if (n === o.VIDEO)
          return { ...r, isVideoAvailable: e };
      }
      return r;
    }), i.length > 0 && (Y.update(d.CALL, o.REMOTE_USER_INFO_LIST, i), Y.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, i));
  }
  async _handleUserVideoAvailable(e) {
    const { userID: n, isVideoAvailable: a } = Je(e);
    console.log(`${o.PREFIX}_handleUserVideoAvailable event data: ${JSON.stringify(e)}.`);
    try {
      a && await this._startRemoteView(n);
    } catch (i) {
      console.error(`${o.PREFIX}_startRemoteView failed, error: ${i}.`);
    }
    this._setRemoteUserInfoAudioVideoAvailable(a, o.VIDEO, n);
  }
  _handleUserAudioAvailable(e) {
    const { userID: n, isAudioAvailable: a } = Je(e);
    console.log(`${o.PREFIX}_handleUserAudioAvailable event data: ${JSON.stringify(e)}.`), this._setRemoteUserInfoAudioVideoAvailable(a, o.AUDIO, n);
  }
  _handleUserVoiceVolume(e) {
    try {
      const { volumeMap: n } = Je(e);
      if ((n || []).length === 0)
        return;
      const a = Y.getData(d.CALL, o.LOCAL_USER_INFO);
      let i = Y.getData(d.CALL, o.REMOTE_USER_INFO_LIST);
      const [r] = n.filter((l) => l.userId === a.userId), s = n.reduce((l, u) => u.userId !== a.userId ? { ...l, [u.userId]: u.audioVolume } : l, {});
      a.volume = r.audioVolume, i = i.map((l) => ({ ...l, volume: s[l.userId] }));
      const c = {
        [o.LOCAL_USER_INFO]: a,
        [o.REMOTE_USER_INFO_LIST]: i
      };
      Y.updateStore(c, d.CALL);
    } catch (n) {
      console.debug(n);
    }
  }
  _handleDeviceUpdate(e) {
    const { cameraList: n, microphoneList: a, speakerList: i, currentCamera: r, currentMicrophone: s, currentSpeaker: c } = e;
    Y.update(d.CALL, o.DEVICE_LIST, { cameraList: n, microphoneList: a, speakerList: i, currentCamera: r, currentMicrophone: s, currentSpeaker: c });
  }
}, v(dt, "instance"), dt);
Fs([
  Bs({
    retries: 5,
    timeout: 200,
    onRetrying(t) {
      console.warn(`${o.PREFIX}_startRemoteView, retrying [${t}]`);
    }
  })
], Rr.prototype, "_startRemoteView", 1);
let Ws = Rr;
var Ps = Object.defineProperty, Hs = Object.getOwnPropertyDescriptor, ne = (t, e, n, a) => {
  for (var i = a > 1 ? void 0 : a ? Hs(e, n) : e, r = t.length - 1, s; r >= 0; r--)
    (s = t[r]) && (i = (a ? s(e, n, i) : s(i)) || i);
  return a && i && Ps(e, n, i), i;
};
const z = Or.getInstance(), f = Na.getInstance(), Ct = ca.getInstance();
Ct.setTUIStore(f);
const _i = "3.3.8", Js = "react";
var Nt;
const ee = (Nt = class {
  constructor() {
    v(this, "_tuiCallEngine");
    v(this, "_tim", null);
    v(this, "_TUICore", null);
    v(this, "_timerId", -1);
    v(this, "_startTimeStamp", ma());
    v(this, "_bellContext", null);
    v(this, "_isFromChat", !1);
    v(this, "_currentGroupId", "");
    // The currentGroupId of the group chat that the user is currently in
    v(this, "_defaultOfflinePushInfo", {
      title: "",
      description: k("you have a new call")
    });
    v(this, "_permissionCheckTimer", null);
    v(this, "_chatCombine", null);
    v(this, "_engineEventHandler", null);
    // ========================【原 Web CallKit 提供的方法】========================
    v(this, "beforeCalling");
    // 原来
    v(this, "afterCalling");
    v(this, "onMinimized");
    v(this, "onMessageSentByMe");
    v(this, "kickedOut");
    v(this, "statusChanged");
    // =========================【监听 TUIStore 中的状态及处理】=========================
    v(this, "_handleCallStatusChange", async (e) => {
      var n, a, i, r;
      try {
        const s = {
          callRole: f.getData(d.CALL, o.CALL_ROLE),
          callStatus: f.getData(d.CALL, o.CALL_STATUS)
        };
        if (this._bellContext.setBellProperties(s), e === _.CALLING)
          await ((n = this == null ? void 0 : this._bellContext) == null ? void 0 : n.play());
        else {
          if (e === _.CONNECTED) {
            const c = f.getData(d.CALL, o.IS_GROUP), l = f.getData(d.CALL, o.CALL_MEDIA_TYPE), u = f.getData(d.CALL, o.REMOTE_USER_INFO_LIST), M = c ? fe.DIALING_GROUP : fe.DIALING_C2C;
            f.update(d.CALL, o.CALL_TIPS, ""), this.statusChanged && this.statusChanged({ oldStatus: M, newStatus: Xn() }), !c && l === $.VIDEO && this.switchScreen(u[0].domId);
          }
          if (e === _.IDLE && this._isFromChat) {
            const c = this._currentGroupId ? await ((a = this._chatCombine) == null ? void 0 : a.getGroupAttributes(this._tim, this._currentGroupId)) : {};
            await ((i = this._chatCombine) == null ? void 0 : i.updateStoreBasedOnGroupAttributes(c, f, this));
          }
          await ((r = this == null ? void 0 : this._bellContext) == null ? void 0 : r.stop());
        }
      } catch (s) {
        console.warn(`${o.PREFIX}handleCallStatusChange, ${s}.`);
      }
    });
    console.log(`${o.PREFIX}version: ${_i}`), this._watchTUIStore(), this._engineEventHandler = Ws.getInstance({ callService: this }), this._chatCombine = Fa.getInstance({ callService: this });
  }
  static getInstance() {
    return Nt.instance || (Nt.instance = new Nt()), Nt.instance;
  }
  async init(e) {
    var n, a;
    try {
      if (this._tuiCallEngine)
        return;
      let { userID: i, tim: r, userSig: s, sdkAppID: c, SDKAppID: l, isFromChat: u, component: M = ii.TUI_CALL_KIT } = e;
      this._TUICore && (c = this._TUICore.SDKAppID, r = this._TUICore.tim), this._tim = r, console.log(`${o.PREFIX}init sdkAppId: ${c || l}, userId: ${i}`), this._tuiCallEngine = Jo.createInstance({
        tim: r,
        SDKAppID: c || l,
        // 兼容传入 SDKAppID 的问题
        // @ts-ignore
        frameWork: Js,
        language: 7,
        callkitVersion: _i,
        chat: u || !1,
        component: M
      }), Ct.setEngineInstance(this._tuiCallEngine), this._addListenTuiCallEngineEvent(), this._bellContext = new ws(), f.update(d.CALL, o.LOCAL_USER_INFO, { userId: i }), f.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, { userId: i }), Ct.updateViewBackgroundUserId("local"), await this._tuiCallEngine.login({ userID: i, userSig: s, assetsPath: "" });
      const N = f.getData(d.CALL, o.CUSTOM_UI_CONFIG);
      (a = (n = this._tuiCallEngine) == null ? void 0 : n.reportLog) == null || a.call(n, {
        name: "TUICallkit.init",
        data: {
          uiConfig: N
        }
      });
    } catch (i) {
      throw console.error(`${o.PREFIX}init failed, error: ${i}.`), i;
    }
  }
  // component destroy
  async destroyed() {
    var e;
    try {
      const n = f.getData(d.CALL, o.CALL_STATUS);
      if (n !== _.IDLE)
        throw new Error(`please destroyed when status is idle, current status: ${n}`);
      this._tuiCallEngine && (this._removeListenTuiCallEngineEvent(), await this._tuiCallEngine.destroyInstance(), this._tuiCallEngine = null), (e = this._bellContext) == null || e.destroy(), this._bellContext = null;
    } catch (n) {
      throw console.error(`${o.PREFIX}destroyed failed, error: ${n}.`), n;
    }
  }
  async call(e) {
    if (f.getData(d.CALL, o.CALL_STATUS) === _.IDLE)
      try {
        const { type: n, userID: a, offlinePushInfo: i } = e;
        if (f.getData(d.CALL, o.CALL_STATUS) !== _.IDLE)
          return;
        await this._updateCallStoreBeforeCall(n, [{ userId: a }]), this.executeExternalBeforeCalling(), e.offlinePushInfo = { ...this._defaultOfflinePushInfo, ...i };
        const r = await this._tuiCallEngine.call(e);
        await this._updateCallStoreAfterCall([a], r);
      } catch (n) {
        this._handleCallError(n, "call");
      }
  }
  async groupCall(e) {
    if (f.getData(d.CALL, o.CALL_STATUS) === _.IDLE)
      try {
        const { userIDList: n, type: a, groupID: i, offlinePushInfo: r } = e;
        if (f.getData(d.CALL, o.CALL_STATUS) !== _.IDLE)
          return;
        const s = n.map((l) => ({ userId: l }));
        await this._updateCallStoreBeforeCall(a, s, i), this.executeExternalBeforeCalling(), e.offlinePushInfo = { ...this._defaultOfflinePushInfo, ...r };
        const c = await this._tuiCallEngine.groupCall(e);
        await this._updateCallStoreAfterCall(n, c);
      } catch (n) {
        this._handleCallError(n, "groupCall");
      }
  }
  async inviteUser(e) {
    if (f.getData(d.CALL, o.CALL_STATUS) !== _.IDLE)
      try {
        const { userIDList: n } = e;
        let a = await vn(n, this.getTim());
        const i = f.getData(d.CALL, o.REMOTE_USER_INFO_LIST);
        f.update(d.CALL, o.REMOTE_USER_INFO_LIST, [...i, ...a]), f.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, [...i, ...a]), this._tuiCallEngine && await this._tuiCallEngine.inviteUser(e);
      } catch (n) {
        throw console.error(`${o.PREFIX}inviteUser failed, error: ${n}.`), this._resetCallStore(), n;
      }
  }
  async joinInGroupCall(e) {
    if (f.getData(d.CALL, o.CALL_STATUS) !== _.CONNECTED)
      try {
        const n = {
          [o.CALL_ROLE]: De.CALLEE,
          [o.IS_GROUP]: !0,
          [o.CALL_STATUS]: _.CONNECTED,
          [o.CALL_MEDIA_TYPE]: e.type,
          [o.GROUP_ID]: e.groupID,
          [o.ROOM_ID]: e.roomID
        };
        f.updateStore(n, d.CALL);
        const a = await this._tuiCallEngine.joinInGroupCall(e), i = this._getFeatureButtonDefaultState(Wt.Camera) === cn.Close;
        e.type === $.VIDEO && !i && await this.openCamera(o.LOCAL_VIDEO), f.update(d.CALL, o.IS_CLICKABLE, !0), this.startTimer(), Oa(this._tuiCallEngine), await this._tuiCallEngine.setVideoQuality(f.getData(d.CALL, o.VIDEO_RESOLUTION));
        const r = f.getData(d.CALL, o.LOCAL_USER_INFO);
        f.update(d.CALL, o.LOCAL_USER_INFO, { ...r, isEnter: !0 }), f.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, { ...r, isEnter: !0 }), kt(!0, o.AUDIO);
      } catch (n) {
        this._handleCallError(n, "joinInGroupCall");
      }
  }
  // ===============================【其它对外接口】===============================
  getTUICallEngineInstance() {
    return (this == null ? void 0 : this._tuiCallEngine) || null;
  }
  setLogLevel(e) {
    var n;
    (n = this == null ? void 0 : this._tuiCallEngine) == null || n.setLogLevel(e);
  }
  setLanguage(e) {
    e && Object.values(hr).includes(e) && f.update(d.CALL, o.LANGUAGE, e);
  }
  enableFloatWindow(e) {
    f.update(d.CALL, o.ENABLE_FLOAT_WINDOW, e);
  }
  async setSelfInfo(e) {
    const { nickName: n, avatar: a } = e;
    try {
      await this._tuiCallEngine.setSelfInfo({ nickName: n, avatar: a });
    } catch (i) {
      console.error(`${o.PREFIX}setSelfInfo failed, error: ${i}.`);
    }
  }
  async enableVirtualBackground(e) {
    f.update(d.CALL, o.IS_SHOW_ENABLE_VIRTUAL_BACKGROUND, e);
  }
  async enableAIVoice(e) {
    try {
      await this._tuiCallEngine.enableAIVoice(e), console.log(`${o.PREFIX}enableAIVoice: ${e}.`);
    } catch (n) {
      throw console.error(`${o.PREFIX}enableAIVoice failed, error: ${n}.`), n;
    }
  }
  async setCallingBell(e) {
    let n = !0;
    if (n = await Ms(e), !n) {
      console.warn(`${o.PREFIX}setCallingBell failed, filePath: ${e}.`);
      return;
    }
    const a = { calleeBellFilePath: e };
    this._bellContext.setBellProperties(a);
  }
  async enableMuteMode(e) {
    try {
      const n = { isMuteBell: e };
      this._bellContext.setBellProperties(n), await this._bellContext.setBellMute(e);
    } catch (n) {
      console.warn(`${o.PREFIX}enableMuteMode failed, error: ${n}.`);
    }
  }
  hideFeatureButton(e) {
    Ct.hideFeatureButton(e);
  }
  setLocalViewBackgroundImage(e) {
    Ct.setLocalViewBackgroundImage(e);
  }
  setRemoteViewBackgroundImage(e, n) {
    Ct.setRemoteViewBackgroundImage(e, n);
  }
  setLayoutMode(e) {
    Ct.setLayoutMode(e);
  }
  setCameraDefaultState(e) {
    Ct.setCameraDefaultState(e);
  }
  async accept() {
    var n, a, i, r, s, c;
    const e = f.getData(d.CALL, o.CALL_STATUS);
    if ((a = (n = this._tuiCallEngine) == null ? void 0 : n.reportLog) == null || a.call(n, {
      name: "TUICallKit.accept.start",
      data: { callStatus: e }
    }), e !== _.CONNECTED)
      try {
        f.update(d.CALL, o.CALL_STATUS, _.CONNECTED), Oa(this._tuiCallEngine);
        const l = await this._tuiCallEngine.accept();
        if (l) {
          (r = this._chatCombine) == null || r.callTUIService({ message: (i = l == null ? void 0 : l.data) == null ? void 0 : i.message }), f.update(d.CALL, o.IS_CLICKABLE, !0), this.startTimer();
          const u = f.getData(d.CALL, o.CALL_MEDIA_TYPE), M = this._getFeatureButtonDefaultState(Wt.Camera) === cn.Close;
          u === $.VIDEO && !M && await this.openCamera(o.LOCAL_VIDEO), await this._tuiCallEngine.setVideoQuality(f.getData(d.CALL, o.VIDEO_RESOLUTION));
          const N = f.getData(d.CALL, o.LOCAL_USER_INFO);
          f.update(d.CALL, o.LOCAL_USER_INFO, { ...N, isEnter: !0 }), f.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, { ...N, isEnter: !0 }), kt(!0, o.AUDIO);
        }
      } catch (l) {
        if ((c = (s = this._tuiCallEngine) == null ? void 0 : s.reportLog) == null || c.call(s, {
          name: "TUICallKit.accept.fail",
          level: "error",
          error: l
        }), xi(l))
          return;
        wa(l, $.AUDIO, this._tuiCallEngine), this._resetCallStore();
      }
  }
  async hangup() {
    if (f.getData(d.CALL, o.CALL_STATUS) !== _.IDLE) {
      try {
        const e = await this._tuiCallEngine.hangup();
        e == null || e.forEach((n) => {
          var a, i;
          (n == null ? void 0 : n.code) === 0 && ((i = this._chatCombine) == null || i.callTUIService({ message: (a = n == null ? void 0 : n.data) == null ? void 0 : a.message }));
        });
      } catch (e) {
        console.debug(e);
      }
      this._resetCallStore();
    }
  }
  async reject() {
    var e, n;
    if (f.getData(d.CALL, o.CALL_STATUS) !== _.IDLE) {
      try {
        const a = await this._tuiCallEngine.reject();
        (a == null ? void 0 : a.code) === 0 && ((n = this._chatCombine) == null || n.callTUIService({ message: (e = a == null ? void 0 : a.data) == null ? void 0 : e.message }));
      } catch (a) {
        console.debug(a);
      }
      this._resetCallStore();
    }
  }
  async openCamera(e) {
    try {
      await this._tuiCallEngine.openCamera(e), kt(!0, o.VIDEO);
    } catch (n) {
      wa(n, $.VIDEO, this._tuiCallEngine), console.error(`${o.PREFIX}openCamera error: ${n}.`);
    }
  }
  async closeCamera() {
    try {
      await this._tuiCallEngine.closeCamera(), kt(!1, o.VIDEO);
    } catch (e) {
      console.error(`${o.PREFIX}closeCamera error: ${e}.`);
    }
  }
  async openMicrophone() {
    try {
      await this._tuiCallEngine.openMicrophone(), kt(!0, o.AUDIO);
    } catch (e) {
      console.error(`${o.PREFIX}openMicrophone failed, error: ${e}.`);
    }
  }
  async closeMicrophone() {
    try {
      await this._tuiCallEngine.closeMicrophone(), kt(!1, o.AUDIO);
    } catch (e) {
      console.error(`${o.PREFIX}closeMicrophone failed, error: ${e}.`);
    }
  }
  unMuteSpeaker() {
    var e, n;
    try {
      const a = (n = (e = this._tuiCallEngine) == null ? void 0 : e.getTRTCCloudInstance) == null ? void 0 : n.call(e);
      a && (a.muteAllRemoteAudio(!1), f.update(d.CALL, o.IS_MUTE_SPEAKER, !1));
    } catch (a) {
      console.error(`${o.PREFIX}unMuteSpeaker failed, error: ${a}.`);
    }
  }
  muteSpeaker() {
    var e, n;
    try {
      const a = (n = (e = this._tuiCallEngine) == null ? void 0 : e.getTRTCCloudInstance) == null ? void 0 : n.call(e);
      a && (a.muteAllRemoteAudio(!0), f.update(d.CALL, o.IS_MUTE_SPEAKER, !0));
    } catch (a) {
      console.error(`${o.PREFIX}muteSpeaker failed, error: ${a}.`);
    }
  }
  switchScreen(e) {
    e && f.update(d.CALL, o.BIG_SCREEN_USER_ID, e);
  }
  async switchCallMediaType() {
    var e, n;
    try {
      const a = f.getData(d.CALL, o.CALL_MEDIA_TYPE);
      if (a === $.AUDIO) {
        console.warn(`${o.PREFIX}switchCallMediaType failed, ${a} not support.`);
        return;
      }
      const i = await this._tuiCallEngine.switchCallMediaType($.AUDIO);
      (i == null ? void 0 : i.code) === 0 && ((n = this._chatCombine) == null || n.callTUIService({ message: (e = i == null ? void 0 : i.data) == null ? void 0 : e.message })), f.update(d.CALL, o.CALL_MEDIA_TYPE, $.AUDIO);
      const s = f.getData(d.CALL, o.IS_GROUP) ? fe.CALLING_GROUP_VIDEO : fe.CALLING_C2C_VIDEO, c = Xn();
      this.statusChanged && this.statusChanged({ oldStatus: s, newStatus: c });
    } catch (a) {
      console.error(`${o.PREFIX}switchCallMediaType failed, error: ${a}.`);
    }
  }
  async switchCamera() {
    const n = f.getData(d.CALL, o.CAMERA_POSITION) === On.BACK ? On.FRONT : On.BACK;
    try {
      await this._tuiCallEngine.switchCamera(n), f.update(d.CALL, o.CAMERA_POSITION, n);
    } catch (a) {
      console.error(`${o.PREFIX}_switchCamera failed, error: ${a}.`);
    }
  }
  async setBlurBackground(e) {
    try {
      await this._tuiCallEngine.setBlurBackground(e ? cs : 0), f.update(d.CALL, o.ENABLE_VIRTUAL_BACKGROUND, e);
    } catch (n) {
      console.error(`${o.PREFIX}_setBlurBackground failed, error: ${n}.`);
    }
  }
  async switchDevice(e) {
    try {
      await this._tuiCallEngine.switchDevice(e);
    } catch (n) {
      console.error(`${o.PREFIX}_switchDevice failed, error: ${n}.`);
    }
  }
  async getDeviceList(e) {
    try {
      return await this._tuiCallEngine.getDeviceList(e);
    } catch (n) {
      this._handleCallError(n, "call");
    }
  }
  // ==========================【TUICallEngine 事件处理】==========================
  _addListenTuiCallEngineEvent() {
    this._engineEventHandler.addListenTuiCallEngineEvent();
  }
  _removeListenTuiCallEngineEvent() {
    this._engineEventHandler.removeListenTuiCallEngineEvent();
  }
  setCallback(e) {
    const { beforeCalling: n, afterCalling: a, onMinimized: i, onMessageSentByMe: r, kickedOut: s, statusChanged: c } = e;
    n && (this.beforeCalling = n), a && (this.afterCalling = a), i && (this.onMinimized = i), r && (this.onMessageSentByMe = r), s && (this.kickedOut = s), c && (this.statusChanged = c);
  }
  toggleMinimize() {
    const e = f.getData(d.CALL, o.IS_MINIMIZED);
    f.update(d.CALL, o.IS_MINIMIZED, !e), console.log(`${o.PREFIX}toggleMinimize: ${e} -> ${!e}.`), this.onMinimized && this.onMinimized(e, !e);
  }
  executeExternalBeforeCalling() {
    this.beforeCalling && this.beforeCalling();
  }
  executeExternalAfterCalling() {
    this.afterCalling && this.afterCalling();
  }
  setVideoDisplayMode(e) {
    f.update(d.CALL, o.DISPLAY_MODE, e);
  }
  async setVideoResolution(e) {
    var n;
    try {
      if (!e)
        return;
      f.update(d.CALL, o.VIDEO_RESOLUTION, e), await ((n = this._tuiCallEngine) == null ? void 0 : n.setVideoQuality(e));
    } catch (a) {
      console.warn(`${o.PREFIX}setVideoResolution failed, error: ${a}.`);
    }
  }
  // 通话时长更新
  startTimer() {
    this._timerId === -1 && (this._startTimeStamp = ma(), this._timerId = la.run(o.TIMEOUT, this._updateCallDuration.bind(this), { delay: 1e3 }));
  }
  // =========================【private methods for service use】=========================
  // 处理 “呼叫” 抛出的异常
  _handleCallError(e, n) {
    if (this._permissionCheckTimer && clearInterval(this._permissionCheckTimer), !xi(e))
      throw wa(e, $.AUDIO, this._tuiCallEngine), console.error(`${o.PREFIX}${n} failed, error: ${e}.`), this._resetCallStore(), e;
  }
  async _updateCallStoreBeforeCall(e, n, a) {
    const i = a || f.getData(d.CALL, o.IS_MINIMIZED) ? Ce.CALLER_GROUP_CALLING_MSG : Ce.CALLER_CALLING_MSG;
    let r = {
      [o.CALL_MEDIA_TYPE]: e,
      [o.CALL_ROLE]: De.CALLER,
      [o.REMOTE_USER_INFO_LIST]: n,
      [o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST]: n,
      [o.IS_GROUP]: !!a,
      [o.CALL_TIPS]: k(i),
      [o.GROUP_ID]: a
    };
    f.updateStore({ ...r, [o.CALL_STATUS]: _.CALLING }, d.CALL), this.statusChanged && this.statusChanged({
      oldStatus: fe.IDLE,
      newStatus: a ? fe.DIALING_GROUP : fe.DIALING_C2C
    }), Oa(this._tuiCallEngine);
    const s = await vn(n.map((c) => c.userId), this.getTim());
    s.length > 0 && (f.update(d.CALL, o.REMOTE_USER_INFO_LIST, s), f.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, s));
  }
  async _updateCallStoreAfterCall(e, n) {
    var a, i;
    if (n) {
      f.update(d.CALL, o.IS_CLICKABLE, !0), vr(n == null ? void 0 : n.roomID, n == null ? void 0 : n.strRoomID);
      const r = f.getData(d.CALL, o.CALL_MEDIA_TYPE);
      if (n.code === 0) {
        (i = this._chatCombine) == null || i.callTUIService({ message: (a = n == null ? void 0 : n.data) == null ? void 0 : a.message });
        try {
          await this._tuiCallEngine.setVideoQuality(f.getData(d.CALL, o.VIDEO_RESOLUTION));
        } catch (l) {
          console.warn(`${o.PREFIX}setVideoQuality failed, error: ${l}.`);
        }
      } else {
        this._resetCallStore();
        return;
      }
      const s = this._getFeatureButtonDefaultState(Wt.Camera) === cn.Close;
      r === $.VIDEO && !s && await this.openCamera(o.LOCAL_VIDEO);
      const c = f.getData(d.CALL, o.LOCAL_USER_INFO);
      f.update(d.CALL, o.LOCAL_USER_INFO, { ...c, isEnter: !0 }), f.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, { ...c, isEnter: !0 }), kt(!0, o.AUDIO);
    } else
      this._permissionCheckTimer && clearInterval(this._permissionCheckTimer), this._permissionCheckTimer = null, this._resetCallStore();
  }
  _getFeatureButtonDefaultState(e) {
    var a;
    const { button: n } = f.getData(d.CALL, o.CUSTOM_UI_CONFIG);
    return (a = n == null ? void 0 : n[e]) == null ? void 0 : a.state;
  }
  _updateCallDuration() {
    const e = Math.round((ma() - this._startTimeStamp) / 1e3), n = xr(e);
    f.update(d.CALL, o.CALL_DURATION, n);
  }
  _stopTimer() {
    this._timerId !== -1 && (la.clearTask(this._timerId), this._timerId = -1);
  }
  _resetCallStore() {
    const e = Xn();
    this._stopTimer();
    let n = Object.keys(ea).filter((r) => {
      switch (ea[r]) {
        case o.CALL_STATUS:
        case o.LANGUAGE:
        case o.IS_GROUP:
        case o.DISPLAY_MODE:
        case o.VIDEO_RESOLUTION:
        case o.ENABLE_FLOAT_WINDOW:
        case o.LOCAL_USER_INFO:
        case o.IS_SHOW_ENABLE_VIRTUAL_BACKGROUND:
        case o.LOCAL_USER_INFO_EXCLUDE_VOLUMN:
          return !1;
        default:
          return !0;
      }
    });
    n = n.map((r) => ea[r]), f.reset(d.CALL, n), f.getData(d.CALL, o.CALL_STATUS) !== _.IDLE && f.reset(d.CALL, [o.CALL_STATUS], !0), f.reset(d.CALL, [o.IS_MINIMIZED], !0), f.reset(d.CALL, [o.IS_EAR_PHONE], !0), f.reset(d.CALL, [o.ENABLE_VIRTUAL_BACKGROUND], !0), f.reset(d.CALL, [o.IS_MUTE_SPEAKER], !0), f.update(d.CALL, o.LOCAL_USER_INFO, {
      ...f.getData(d.CALL, o.LOCAL_USER_INFO),
      isVideoAvailable: !1,
      isAudioAvailable: !1
    }), f.update(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN, {
      ...f.getData(d.CALL, o.LOCAL_USER_INFO_EXCLUDE_VOLUMN),
      isVideoAvailable: !1,
      isAudioAvailable: !1
    }), f.update(d.CALL, o.REMOTE_USER_INFO_LIST, []), f.update(d.CALL, o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST, []);
    const i = Xn();
    e !== i && this.statusChanged && this.statusChanged({ oldStatus: e, newStatus: i });
  }
  // =========================【Calling the Chat SDK APi】=========================
  // 获取群成员
  async getGroupMemberList(e, n) {
    const a = f.getData(d.CALL, o.GROUP_ID);
    return await Rs(a, this.getTim(), e, n);
  }
  // 获取群信息
  async getGroupProfile() {
    const e = f.getData(d.CALL, o.GROUP_ID);
    return await bs(e, this.getTim());
  }
  _watchTUIStore() {
    f == null || f.watch(d.CALL, {
      [o.CALL_STATUS]: this._handleCallStatusChange
    });
  }
  _unwatchTUIStore() {
    f == null || f.unwatch(d.CALL, {
      [o.CALL_STATUS]: this._handleCallStatusChange
    });
  }
  // =========================【融合 chat 】=========================
  bindTUICore(e) {
    this._TUICore = e;
  }
  // =========================【set、get methods】=========================
  getTim() {
    var e, n;
    return this._tim ? this._tim : this._tuiCallEngine ? ((e = this._tuiCallEngine) == null ? void 0 : e.tim) || ((n = this._tuiCallEngine) == null ? void 0 : n.getTim()) : (console.warn(`${o.PREFIX}getTim warning: _tuiCallEngine Instance is not available.`), null);
  }
  setIsFromChat(e) {
    this._isFromChat = e;
  }
  setCurrentGroupId(e) {
    this._currentGroupId = e;
  }
  getCurrentGroupId() {
    return this._currentGroupId;
  }
  setDefaultOfflinePushInfo(e) {
    this._defaultOfflinePushInfo = e;
  }
  getDefaultOfflinePushInfo() {
    return this._defaultOfflinePushInfo;
  }
  async getCallMessage(e) {
    return await this._chatCombine.getCallKitMessage(e, this.getTim());
  }
}, v(Nt, "instance"), Nt);
ne([
  Ne(),
  be(_e.init)
], ee.prototype, "init", 1);
ne([
  Ne(),
  be(_e.call),
  da({ engineInstance: !0 })
], ee.prototype, "call", 1);
ne([
  Ne(),
  be(_e.groupCall),
  da({ engineInstance: !0 })
], ee.prototype, "groupCall", 1);
ne([
  Ne(),
  be(_e.inviteUser),
  da({ engineInstance: !0 })
], ee.prototype, "inviteUser", 1);
ne([
  Ne(),
  be(_e.joinInGroupCall),
  da({ engineInstance: !0 })
], ee.prototype, "joinInGroupCall", 1);
ne([
  be(_e.setLanguage)
], ee.prototype, "setLanguage", 1);
ne([
  be(_e.enableFloatWindow)
], ee.prototype, "enableFloatWindow", 1);
ne([
  be(_e.setSelfInfo)
], ee.prototype, "setSelfInfo", 1);
ne([
  be(_e.enableAIVoice)
], ee.prototype, "enableAIVoice", 1);
ne([
  be(_e.setCallingBell)
], ee.prototype, "setCallingBell", 1);
ne([
  be(_e.enableMuteMode)
], ee.prototype, "enableMuteMode", 1);
ne([
  Ne()
], ee.prototype, "accept", 1);
ne([
  Ne()
], ee.prototype, "hangup", 1);
ne([
  Ne()
], ee.prototype, "reject", 1);
ne([
  Ne()
], ee.prototype, "openCamera", 1);
ne([
  Ne()
], ee.prototype, "closeCamera", 1);
ne([
  Ne()
], ee.prototype, "openMicrophone", 1);
ne([
  Ne()
], ee.prototype, "closeMicrophone", 1);
ne([
  Ne()
], ee.prototype, "unMuteSpeaker", 1);
ne([
  Ne()
], ee.prototype, "muteSpeaker", 1);
ne([
  Ne()
], ee.prototype, "switchScreen", 1);
ne([
  Ne()
], ee.prototype, "switchCallMediaType", 1);
ne([
  Ne()
], ee.prototype, "switchCamera", 1);
ne([
  Ne()
], ee.prototype, "setBlurBackground", 1);
ne([
  Ne()
], ee.prototype, "switchDevice", 1);
ne([
  be(_e.setVideoDisplayMode)
], ee.prototype, "setVideoDisplayMode", 1);
ne([
  be(_e.setVideoResolution)
], ee.prototype, "setVideoResolution", 1);
let Xs = ee;
const X = Xs.getInstance();
function Ks(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Za = { exports: {} }, hn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ki;
function $s() {
  if (ki)
    return hn;
  ki = 1;
  var t = Le, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(c, l, u) {
    var M, N = {}, g = null, D = null;
    u !== void 0 && (g = "" + u), l.key !== void 0 && (g = "" + l.key), l.ref !== void 0 && (D = l.ref);
    for (M in l)
      a.call(l, M) && !r.hasOwnProperty(M) && (N[M] = l[M]);
    if (c && c.defaultProps)
      for (M in l = c.defaultProps, l)
        N[M] === void 0 && (N[M] = l[M]);
    return { $$typeof: e, type: c, key: g, ref: D, props: N, _owner: i.current };
  }
  return hn.Fragment = n, hn.jsx = s, hn.jsxs = s, hn;
}
var Cn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vi;
function qs() {
  return Vi || (Vi = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Le, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), M = Symbol.for("react.suspense_list"), N = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), D = Symbol.for("react.offscreen"), T = Symbol.iterator, E = "@@iterator";
    function j(A) {
      if (A === null || typeof A != "object")
        return null;
      var h = T && A[T] || A[E];
      return typeof h == "function" ? h : null;
    }
    var p = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(A) {
      {
        for (var h = arguments.length, O = new Array(h > 1 ? h - 1 : 0), V = 1; V < h; V++)
          O[V - 1] = arguments[V];
        m("error", A, O);
      }
    }
    function m(A, h, O) {
      {
        var V = p.ReactDebugCurrentFrame, J = V.getStackAddendum();
        J !== "" && (h += "%s", O = O.concat([J]));
        var te = O.map(function(W) {
          return String(W);
        });
        te.unshift("Warning: " + h), Function.prototype.apply.call(console[A], console, te);
      }
    }
    var L = !1, S = !1, y = !1, w = !1, b = !1, B;
    B = Symbol.for("react.module.reference");
    function F(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === a || A === r || b || A === i || A === u || A === M || w || A === D || L || S || y || typeof A == "object" && A !== null && (A.$$typeof === g || A.$$typeof === N || A.$$typeof === s || A.$$typeof === c || A.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === B || A.getModuleId !== void 0));
    }
    function oe(A, h, O) {
      var V = A.displayName;
      if (V)
        return V;
      var J = h.displayName || h.name || "";
      return J !== "" ? O + "(" + J + ")" : O;
    }
    function Ae(A) {
      return A.displayName || "Context";
    }
    function K(A) {
      if (A == null)
        return null;
      if (typeof A.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
        return A.displayName || A.name || null;
      if (typeof A == "string")
        return A;
      switch (A) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case r:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case M:
          return "SuspenseList";
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case c:
            var h = A;
            return Ae(h) + ".Consumer";
          case s:
            var O = A;
            return Ae(O._context) + ".Provider";
          case l:
            return oe(A, A.render, "ForwardRef");
          case N:
            var V = A.displayName || null;
            return V !== null ? V : K(A.type) || "Memo";
          case g: {
            var J = A, te = J._payload, W = J._init;
            try {
              return K(W(te));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ue = Object.assign, ge = 0, se, Te, ot, Ve, st, Et, $e;
    function lt() {
    }
    lt.__reactDisabledLog = !0;
    function qe() {
      {
        if (ge === 0) {
          se = console.log, Te = console.info, ot = console.warn, Ve = console.error, st = console.group, Et = console.groupCollapsed, $e = console.groupEnd;
          var A = {
            configurable: !0,
            enumerable: !0,
            value: lt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: A,
            log: A,
            warn: A,
            error: A,
            group: A,
            groupCollapsed: A,
            groupEnd: A
          });
        }
        ge++;
      }
    }
    function Qe() {
      {
        if (ge--, ge === 0) {
          var A = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ue({}, A, {
              value: se
            }),
            info: ue({}, A, {
              value: Te
            }),
            warn: ue({}, A, {
              value: ot
            }),
            error: ue({}, A, {
              value: Ve
            }),
            group: ue({}, A, {
              value: st
            }),
            groupCollapsed: ue({}, A, {
              value: Et
            }),
            groupEnd: ue({}, A, {
              value: $e
            })
          });
        }
        ge < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var He = p.ReactCurrentDispatcher, et;
    function me(A, h, O) {
      {
        if (et === void 0)
          try {
            throw Error();
          } catch (J) {
            var V = J.stack.trim().match(/\n( *(at )?)/);
            et = V && V[1] || "";
          }
        return `
` + et + A;
      }
    }
    var ct = !1, ft;
    {
      var xt = typeof WeakMap == "function" ? WeakMap : Map;
      ft = new xt();
    }
    function qt(A, h) {
      if (!A || ct)
        return "";
      {
        var O = ft.get(A);
        if (O !== void 0)
          return O;
      }
      var V;
      ct = !0;
      var J = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var te;
      te = He.current, He.current = null, qe();
      try {
        if (h) {
          var W = function() {
            throw Error();
          };
          if (Object.defineProperty(W.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(W, []);
            } catch (Se) {
              V = Se;
            }
            Reflect.construct(A, [], W);
          } else {
            try {
              W.call();
            } catch (Se) {
              V = Se;
            }
            A.call(W.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Se) {
            V = Se;
          }
          A();
        }
      } catch (Se) {
        if (Se && V && typeof Se.stack == "string") {
          for (var Z = Se.stack.split(`
`), je = V.stack.split(`
`), le = Z.length - 1, Me = je.length - 1; le >= 1 && Me >= 0 && Z[le] !== je[Me]; )
            Me--;
          for (; le >= 1 && Me >= 0; le--, Me--)
            if (Z[le] !== je[Me]) {
              if (le !== 1 || Me !== 1)
                do
                  if (le--, Me--, Me < 0 || Z[le] !== je[Me]) {
                    var Ye = `
` + Z[le].replace(" at new ", " at ");
                    return A.displayName && Ye.includes("<anonymous>") && (Ye = Ye.replace("<anonymous>", A.displayName)), typeof A == "function" && ft.set(A, Ye), Ye;
                  }
                while (le >= 1 && Me >= 0);
              break;
            }
        }
      } finally {
        ct = !1, He.current = te, Qe(), Error.prepareStackTrace = J;
      }
      var an = A ? A.displayName || A.name : "", _t = an ? me(an) : "";
      return typeof A == "function" && ft.set(A, _t), _t;
    }
    function vt(A, h, O) {
      return qt(A, !1);
    }
    function Dn(A) {
      var h = A.prototype;
      return !!(h && h.isReactComponent);
    }
    function pt(A, h, O) {
      if (A == null)
        return "";
      if (typeof A == "function")
        return qt(A, Dn(A));
      if (typeof A == "string")
        return me(A);
      switch (A) {
        case u:
          return me("Suspense");
        case M:
          return me("SuspenseList");
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case l:
            return vt(A.render);
          case N:
            return pt(A.type, h, O);
          case g: {
            var V = A, J = V._payload, te = V._init;
            try {
              return pt(te(J), h, O);
            } catch {
            }
          }
        }
      return "";
    }
    var tt = Object.prototype.hasOwnProperty, Rt = {}, bt = p.ReactDebugCurrentFrame;
    function G(A) {
      if (A) {
        var h = A._owner, O = pt(A.type, A._source, h ? h.type : null);
        bt.setExtraStackFrame(O);
      } else
        bt.setExtraStackFrame(null);
    }
    function Be(A, h, O, V, J) {
      {
        var te = Function.call.bind(tt);
        for (var W in A)
          if (te(A, W)) {
            var Z = void 0;
            try {
              if (typeof A[W] != "function") {
                var je = Error((V || "React class") + ": " + O + " type `" + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[W] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              Z = A[W](h, W, V, O, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (le) {
              Z = le;
            }
            Z && !(Z instanceof Error) && (G(J), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", V || "React class", O, W, typeof Z), G(null)), Z instanceof Error && !(Z.message in Rt) && (Rt[Z.message] = !0, G(J), C("Failed %s type: %s", O, Z.message), G(null));
          }
      }
    }
    var en = Array.isArray;
    function tn(A) {
      return en(A);
    }
    function Pn(A) {
      {
        var h = typeof Symbol == "function" && Symbol.toStringTag, O = h && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return O;
      }
    }
    function Tn(A) {
      try {
        return En(A), !1;
      } catch {
        return !0;
      }
    }
    function En(A) {
      return "" + A;
    }
    function fn(A) {
      if (Tn(A))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pn(A)), En(A);
    }
    var jt = p.ReactCurrentOwner, Hn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ei, fi, ja;
    ja = {};
    function wo(A) {
      if (tt.call(A, "ref")) {
        var h = Object.getOwnPropertyDescriptor(A, "ref").get;
        if (h && h.isReactWarning)
          return !1;
      }
      return A.ref !== void 0;
    }
    function Uo(A) {
      if (tt.call(A, "key")) {
        var h = Object.getOwnPropertyDescriptor(A, "key").get;
        if (h && h.isReactWarning)
          return !1;
      }
      return A.key !== void 0;
    }
    function zo(A, h) {
      if (typeof A.ref == "string" && jt.current && h && jt.current.stateNode !== h) {
        var O = K(jt.current.type);
        ja[O] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(jt.current.type), A.ref), ja[O] = !0);
      }
    }
    function xo(A, h) {
      {
        var O = function() {
          Ei || (Ei = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", h));
        };
        O.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: O,
          configurable: !0
        });
      }
    }
    function vo(A, h) {
      {
        var O = function() {
          fi || (fi = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", h));
        };
        O.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: O,
          configurable: !0
        });
      }
    }
    var Ro = function(A, h, O, V, J, te, W) {
      var Z = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: A,
        key: h,
        ref: O,
        props: W,
        // Record the component responsible for creating this element.
        _owner: te
      };
      return Z._store = {}, Object.defineProperty(Z._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Z, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.defineProperty(Z, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: J
      }), Object.freeze && (Object.freeze(Z.props), Object.freeze(Z)), Z;
    };
    function bo(A, h, O, V, J) {
      {
        var te, W = {}, Z = null, je = null;
        O !== void 0 && (fn(O), Z = "" + O), Uo(h) && (fn(h.key), Z = "" + h.key), wo(h) && (je = h.ref, zo(h, J));
        for (te in h)
          tt.call(h, te) && !Hn.hasOwnProperty(te) && (W[te] = h[te]);
        if (A && A.defaultProps) {
          var le = A.defaultProps;
          for (te in le)
            W[te] === void 0 && (W[te] = le[te]);
        }
        if (Z || je) {
          var Me = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          Z && xo(W, Me), je && vo(W, Me);
        }
        return Ro(A, Z, je, J, V, jt.current, W);
      }
    }
    var ha = p.ReactCurrentOwner, pi = p.ReactDebugCurrentFrame;
    function nn(A) {
      if (A) {
        var h = A._owner, O = pt(A.type, A._source, h ? h.type : null);
        pi.setExtraStackFrame(O);
      } else
        pi.setExtraStackFrame(null);
    }
    var Ca;
    Ca = !1;
    function La(A) {
      return typeof A == "object" && A !== null && A.$$typeof === e;
    }
    function ji() {
      {
        if (ha.current) {
          var A = K(ha.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
    }
    function _o(A) {
      {
        if (A !== void 0) {
          var h = A.fileName.replace(/^.*[\\\/]/, ""), O = A.lineNumber;
          return `

Check your code at ` + h + ":" + O + ".";
        }
        return "";
      }
    }
    var hi = {};
    function ko(A) {
      {
        var h = ji();
        if (!h) {
          var O = typeof A == "string" ? A : A.displayName || A.name;
          O && (h = `

Check the top-level render call using <` + O + ">.");
        }
        return h;
      }
    }
    function Ci(A, h) {
      {
        if (!A._store || A._store.validated || A.key != null)
          return;
        A._store.validated = !0;
        var O = ko(h);
        if (hi[O])
          return;
        hi[O] = !0;
        var V = "";
        A && A._owner && A._owner !== ha.current && (V = " It was passed a child from " + K(A._owner.type) + "."), nn(A), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', O, V), nn(null);
      }
    }
    function Li(A, h) {
      {
        if (typeof A != "object")
          return;
        if (tn(A))
          for (var O = 0; O < A.length; O++) {
            var V = A[O];
            La(V) && Ci(V, h);
          }
        else if (La(A))
          A._store && (A._store.validated = !0);
        else if (A) {
          var J = j(A);
          if (typeof J == "function" && J !== A.entries)
            for (var te = J.call(A), W; !(W = te.next()).done; )
              La(W.value) && Ci(W.value, h);
        }
      }
    }
    function Vo(A) {
      {
        var h = A.type;
        if (h == null || typeof h == "string")
          return;
        var O;
        if (typeof h == "function")
          O = h.propTypes;
        else if (typeof h == "object" && (h.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        h.$$typeof === N))
          O = h.propTypes;
        else
          return;
        if (O) {
          var V = K(h);
          Be(O, A.props, "prop", V, A);
        } else if (h.PropTypes !== void 0 && !Ca) {
          Ca = !0;
          var J = K(h);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", J || "Unknown");
        }
        typeof h.getDefaultProps == "function" && !h.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Qo(A) {
      {
        for (var h = Object.keys(A.props), O = 0; O < h.length; O++) {
          var V = h[O];
          if (V !== "children" && V !== "key") {
            nn(A), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", V), nn(null);
            break;
          }
        }
        A.ref !== null && (nn(A), C("Invalid attribute `ref` supplied to `React.Fragment`."), nn(null));
      }
    }
    var yi = {};
    function mi(A, h, O, V, J, te) {
      {
        var W = F(A);
        if (!W) {
          var Z = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (Z += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = _o(J);
          je ? Z += je : Z += ji();
          var le;
          A === null ? le = "null" : tn(A) ? le = "array" : A !== void 0 && A.$$typeof === e ? (le = "<" + (K(A.type) || "Unknown") + " />", Z = " Did you accidentally export a JSX literal instead of a component?") : le = typeof A, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", le, Z);
        }
        var Me = bo(A, h, O, J, te);
        if (Me == null)
          return Me;
        if (W) {
          var Ye = h.children;
          if (Ye !== void 0)
            if (V)
              if (tn(Ye)) {
                for (var an = 0; an < Ye.length; an++)
                  Li(Ye[an], A);
                Object.freeze && Object.freeze(Ye);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Li(Ye, A);
        }
        if (tt.call(h, "key")) {
          var _t = K(A), Se = Object.keys(h).filter(function(Wo) {
            return Wo !== "key";
          }), ya = Se.length > 0 ? "{key: someKey, " + Se.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!yi[_t + ya]) {
            var Zo = Se.length > 0 ? "{" + Se.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ya, _t, Zo, _t), yi[_t + ya] = !0;
          }
        }
        return A === a ? Qo(Me) : Vo(Me), Me;
      }
    }
    function Bo(A, h, O) {
      return mi(A, h, O, !0);
    }
    function Yo(A, h, O) {
      return mi(A, h, O, !1);
    }
    var Go = Yo, Fo = Bo;
    Cn.Fragment = a, Cn.jsx = Go, Cn.jsxs = Fo;
  }()), Cn;
}
process.env.NODE_ENV === "production" ? Za.exports = $s() : Za.exports = qs();
var I = Za.exports;
function x(...t) {
  const e = [], n = {}.hasOwnProperty;
  for (let a = 0; a < t.length; a++) {
    const i = t[a];
    if (!i)
      continue;
    const r = typeof i;
    if (r === "string" || r === "number")
      e.push(i);
    else if (Array.isArray(i)) {
      if (i.length) {
        const s = x.apply(null, i);
        s && e.push(s);
      }
    } else if (r === "object") {
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
        e.push(i.toString());
        continue;
      }
      for (const s in i)
        n.call(i, s) && i[s] && e.push(s);
    }
  }
  return e.join(" ");
}
function ie(t) {
  const {
    url: e,
    style: n,
    className: a,
    onClick: i = () => null
  } = t;
  return /* @__PURE__ */ I.jsx(
    "img",
    {
      className: a,
      style: { width: "100%", height: "100%", ...n },
      src: e,
      onClick: i,
      alt: ""
    }
  );
}
const el = "data:image/svg+xml;base64,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", tl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjgyMDUgNS45MDcyM0w2LjQyMTEgNC4zMzQ2OEM2Ljg0ODMzIDMuODg4NDQgNy41NDEwMSAzLjg4ODQ0IDcuOTY4MjUgNC4zMzQ2OEwxMC41NTI1IDcuMDMzODhDMTAuOTc5OCA3LjQ4MDEyIDEwLjk3OTggOC4yMDM2MSAxMC41NTI1IDguNjQ5ODRMOS40MDc1NiA5Ljg0NTcyQzkuODk5MDYgMTAuOTI2MyAxMC41ODY3IDExLjkwOTEgMTEuNDQyOSAxMi43MzQ5QzEyLjM5MTEgMTMuNjQ5NCAxMy41MDY2IDE0LjMzMzMgMTQuNzA5OCAxNC43NTQxTDE1Ljc1NjkgMTMuNjYwNUMxNi4xODQxIDEzLjIxNDMgMTYuODc2OCAxMy4yMTQzIDE3LjMwNCAxMy42NjA1TDE5LjY3OTYgMTYuMTQxN0MyMC4xMDY4IDE2LjU4NzkgMjAuMTA2OCAxNy4zMTE0IDE5LjY3OTYgMTcuNzU3NkwxNy45NDg1IDE5LjYxOTFDMTcuOTM4OSAxOS42MTkxIDE3Ljk1ODEgMTkuNjE5MSAxNy45NDg1IDE5LjYxOTFDMTcuNzcwOSAxOS44MDQ3IDE3LjUzODUgMTkuOTI4NSAxNy4yODU0IDE5Ljk3MjZMMTcuMTI4IDIwQzEzLjc1MzggMTkuOTcgMTAuODQ5NSAxOC42MDU0IDguMzY4NDQgMTYuMjEyNEM1Ljg1OSAxMy43OTIxIDQuMjcxNjMgMTAuOTg3IDQgNy40MzA3N0M0IDYuOTQ1MDIgNC4yMDIyOCA2LjQ4MTIgNC41NTgyNiA2LjE1MDdMNC44MjA1IDUuOTA3MjNaIiBmaWxsPSIjMTQ3QUZGIiBzdHlsZT0iZmlsbDojMTQ3QUZGO2ZpbGw6Y29sb3IoZGlzcGxheS1wMyAwLjA3ODQgMC40Nzg0IDEuMDAwMCk7ZmlsbC1vcGFjaXR5OjE7Ii8+Cjwvc3ZnPgo=", nl = "_c2c_14m8l_10", al = "_icon_14m8l_13", za = {
  "message-c2c-container": "_message-c2c-container_14m8l_1",
  "call-content": "_call-content_14m8l_7",
  c2c: nl,
  icon: al
};
function il(t) {
  const {
    message: e = {},
    onClick: n
  } = t, [a, i] = U(), [r, s] = U(), [c, l] = U([]);
  H(() => {
    X.getCallMessage(e).then((D) => {
      const { callMediaType: T, messageCardContent: E = "", inviteeList: j = [] } = D || {};
      s(T), i(E), l(j);
    });
  }, [e]);
  const u = r === $.AUDIO ? tl : el, M = x([
    za["message-c2c-container"],
    "c2c"
  ]), N = () => {
    typeof n == "function" && n({ callMediaType: r, inviteeList: c });
  }, g = x([
    za.icon
  ]);
  return /* @__PURE__ */ I.jsxs(
    "div",
    {
      className: M,
      onClick: N,
      children: [
        /* @__PURE__ */ I.jsx("div", { className: g, children: /* @__PURE__ */ I.jsx(ie, { url: u }) }),
        /* @__PURE__ */ I.jsx("span", { className: za["call-content"], children: a })
      ]
    }
  );
}
const rl = "_group_hjjzg_1", Qi = {
  "message-group-container": "_message-group-container_hjjzg_1",
  group: rl
};
function ol(t) {
  const {
    message: e = {},
    onClick: n
  } = t, [a, i] = U(), [r, s] = U();
  H(() => {
    X.getCallMessage(e).then((l) => {
      const { callType: u, messageCardContent: M = "" } = l || {};
      s(u), i(M);
    });
  }, [e]);
  const c = x([
    Qi["message-group-container"],
    "group"
  ]);
  return /* @__PURE__ */ I.jsx(
    "div",
    {
      className: c,
      children: /* @__PURE__ */ I.jsx("span", { className: Qi["call-content"], children: a })
    }
  );
}
function DN(t) {
  const { callType: e = "C2C" } = t;
  return e === "C2C" ? /* @__PURE__ */ I.jsx(il, { ...t }) : /* @__PURE__ */ I.jsx(ol, { ...t });
}
const P = "tk";
function br(t) {
  const { callDuration: e, style: n } = t;
  return /* @__PURE__ */ I.jsx("div", { className: `${P}-time`, style: n, children: e });
}
const _r = Ut({ gutter: void 0 });
function Ht(t) {
  const {
    className: e = "",
    children: n = [],
    gutter: a,
    style: i,
    justify: r = "center"
  } = t, s = Ie(() => ({ gutter: a }), [a]), c = x([
    `${P}-row-container`,
    `${P}-row-justify-${r}`,
    e
  ]), l = () => ((n == null ? void 0 : n.length) || 0) < 2 ? n : Le.Children.map(n, (M) => {
    var N;
    if (((N = M == null ? void 0 : M.type) == null ? void 0 : N.displayName) === "Col")
      return M;
  });
  return /* @__PURE__ */ I.jsx("div", { className: c, style: i, children: /* @__PURE__ */ I.jsx(_r.Provider, { value: s, children: l() }) });
}
function ve(t) {
  const {
    span: e = 12,
    children: n,
    style: a = {},
    justify: i = "center",
    align: r = "start"
  } = t, { gutter: s } = Q(_r), c = x([
    `${P}-col-container`,
    `${P}-col-${e}`,
    `${P}-col-justify-content-${i}`,
    `${P}-col-align-items-${r}`
  ]), u = (() => {
    if (typeof s == "number")
      return {
        paddingLeft: `${s / 2}px`,
        paddingRight: `${s / 2}px`
      };
  })();
  return /* @__PURE__ */ I.jsx(
    "div",
    {
      className: c,
      style: { ...u, ...a },
      children: n
    }
  );
}
ve.displayName = "Col";
const sl = "data:image/svg+xml;base64,PHN2ZyB0PSIxNzAwMDU0NjMzMjQxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjU3NjciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCI+PHBhdGggZD0iTTUyMC42NjUwOTkgNjQuNTY0MTMxYTI5LjI0NDM0MSAyOS4yNDQzNDEgMCAwIDAtNy4wNzEzOTQtMC44OTQxOTZjLTE2LjIxMDk4NCAwLTI5LjM1MDAwMSAxMy4xNDA5NzQtMjkuMzUwMDAxIDI5LjM1IDAgMTUuODI5NDM0IDEyLjUzODMyIDI4LjY5NjQ3NCAyOC4yMjI5NjEgMjkuMjkzMjU4djAuMDcyMzk2YzAuMzc1NjggMCAwLjc1MTM2LTAuMDEzNjk3IDEuMTI3MDQtMC4wMTM2OTYgMjE2LjQ5MzQzMiAwIDM4OS42MjkwODYgMTczLjk0MTgwMSAzODkuNjI5MDg2IDM5MC40MzMyNzUgMCAyMTYuNDk1Mzg4LTE3My4xMzU2NTQgMzg4LjgyNjg1Mi0zODkuNjI5MDg2IDM4OC44MjY4NTNzLTM4OS42MzEwNDItMTcyLjMzMzQyMS0zODkuNjMxMDQyLTM4OC44Mjg4MDljMC0wLjI3MDAyIDAuMDA5NzgzLTAuNTM2MTI3IDAuMDA5NzgzLTAuODA0MTloLTAuMDA5NzgzYzAtMTYuMjA5MDI3LTEzLjE0MDk3NC0yOS4zNTAwMDEtMjkuMzUwMDAxLTI5LjM1MDAwMXMtMjkuMzUwMDAxIDEzLjEzOTAxNy0yOS4zNTAwMDEgMjkuMzUwMDAxYzAgMC4wNTQ3ODcgMC4wMDc4MjcgMC4xMDk1NzMgMC4wMDc4MjcgMC4xNjQzNi0wLjAwMTk1NyAwLjIxMzI3Ny0wLjAwNzgyNyAwLjQyNDU5Ny0wLjAwNzgyNyAwLjYzOTgzIDAgMjQ3LjYwODM0NiAyMDAuNzIyNjk4IDQ0OC4zMzEwNDQgNDQ4LjMzMTA0NCA0NDguMzMxMDQzIDI0Ny42MDYzODkgMCA0NDguMzI5MDg3LTIwMC43MjI2OTggNDQ4LjMyOTA4Ny00NDguMzMxMDQzLTAuMDAxOTU3LTI0NS4yNDA3NzktMTk2LjkxNjk4MS00NDQuNDU0ODg3LTQ0MS4yNTc2OTMtNDQ4LjIzOTA4MXoiIGZpbGw9IiNmZmZmZmYiIHAtaWQ9IjU3NjgiPjwvcGF0aD48L3N2Zz4=";
function ll(t) {
  const { size: e } = t;
  return /* @__PURE__ */ I.jsx(
    "div",
    {
      className: `${P}-circle-container`,
      style: { width: e, height: e },
      children: /* @__PURE__ */ I.jsx("img", { alt: "", style: { width: "100%", height: "100%" }, className: `${P}-circle-loading`, src: sl })
    }
  );
}
function cl(t) {
  const { size: e } = t;
  return /* @__PURE__ */ I.jsxs(
    "div",
    {
      className: `${P}-dot-container`,
      style: { width: e, height: e },
      children: [
        /* @__PURE__ */ I.jsx("div", { className: "dot" }),
        /* @__PURE__ */ I.jsx("div", { className: "dot" }),
        /* @__PURE__ */ I.jsx("div", { className: "dot" })
      ]
    }
  );
}
function kr(t) {
  const {
    style: e,
    className: n,
    background: a,
    showOverlayer: i = !0,
    fit: r = "cover",
    defaultSrc: s,
    onError: c
  } = t, l = x([
    n,
    `${P}-overlayer-container`
  ]), [u, M] = U(a || s), [N, g] = U({ objectFit: r }), D = { width: "100%", height: "100%" };
  H(() => {
    g({ objectFit: r });
  }, [r]);
  function T(E) {
    c == null || c(E), M(s);
  }
  return /* @__PURE__ */ I.jsxs("div", { className: l, children: [
    i && /* @__PURE__ */ I.jsx("div", { style: e, className: "overlay" }),
    u && /* @__PURE__ */ I.jsx("img", { alt: "bg", style: { ...D, ...N }, src: u, onError: T })
  ] });
}
function oi(t) {
  const {
    theme: e = "circle",
    size: n,
    showOverlayer: a = !0,
    children: i,
    style: r = {},
    showLoading: s = !0,
    fit: c
  } = t, l = () => e === "dot" ? /* @__PURE__ */ I.jsx(cl, { size: n }) : /* @__PURE__ */ I.jsx(ll, { size: n }), u = x([
    `${P}-loading-container`,
    {
      [`${P}-loading-overlayer`]: a
    }
  ]);
  return /* @__PURE__ */ I.jsxs("div", { className: u, style: r, children: [
    a && /* @__PURE__ */ I.jsx(kr, { fit: c }),
    s && l(),
    i
  ] });
}
const Pe = ai((t, e) => {
  const {
    icon: n,
    iconSize: a,
    content: i,
    loading: r,
    children: s,
    showText: c = !0,
    ghost: l = !1,
    onClick: u = (S) => null,
    isStopPropagation: M = !1,
    size: N = "middle",
    direction: g = "vertical",
    className: D = "",
    iconClassName: T = "",
    isMobile: E = !1,
    style: j,
    ...p
  } = t, C = (S) => {
    M && S.stopPropagation(), !r && (u == null || u(S));
  }, m = () => {
    const S = x([
      `${P}-icon`,
      T,
      {
        [`${P}-size-s`]: N === "small",
        [`${P}-size-m`]: N === "middle",
        [`${P}-size-l`]: N === "large"
      }
    ]), y = a ? { width: a, height: a } : {};
    return /* @__PURE__ */ I.jsx(
      "div",
      {
        className: S,
        onClick: C,
        style: y,
        children: r ? /* @__PURE__ */ I.jsx(oi, { showOverlayer: !1 }) : n
      }
    );
  }, L = () => c && /* @__PURE__ */ I.jsx("div", { className: `${P}-content`, children: i || s });
  return /* @__PURE__ */ I.jsxs(
    "div",
    {
      ref: e,
      style: j,
      className: x([
        D,
        `${P}-btn-container`,
        {
          mobile: E,
          pc: !E,
          [`${P}-flex-vertical`]: g === "vertical",
          [`${P}-flex-horizontal`]: g === "horizontal",
          [`${P}-size-s`]: N === "small",
          [`${P}-size-m`]: N === "middle",
          [`${P}-size-l`]: N === "large",
          [`${P}-ghost`]: l === !0
        }
      ]),
      ...p,
      children: [
        n && m(),
        L()
      ]
    }
  );
}), ul = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjAuNzY5MjMxIiB5PSIwLjc2OTIzMSIgd2lkdGg9IjE4LjQ2MTUiIGhlaWdodD0iMTguNDYxNSIgcng9IjAuNzY5MjMxIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNTM4NDYiLz4KICAgIDxwYXRoIGQ9Ik0xMS41Mzg1IDEyLjMwNzdDMTEuNTM4NSAxMS44ODI5IDExLjg4MjkgMTEuNTM4NSAxMi4zMDc3IDExLjUzODVIMTkuMjMwOFYxOC40NjE1QzE5LjIzMDggMTguODg2NCAxOC44ODY0IDE5LjIzMDggMTguNDYxNiAxOS4yMzA4SDExLjUzODVWMTIuMzA3N1oiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41Mzg0NiIvPgogICAgPHBhdGggZD0iTTAuNzY5Mjg3IDAuNzY5MjI2TDguOTcyMyA4LjkyNDEyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNTM4NDYiLz4KICAgIDxwYXRoIGQ9Ik05LjQ5NjcgNC43MTcxNlY5LjQ0ODZINC43NDE0NiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUzODQ2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8L3N2Zz4=", Ml = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNDk5OTEgNEgyLjk5OTkxQzIuNDQ3NjIgNCAxLjk5OTkxIDQuNDQ3NzIgMS45OTk5MSA1VjE3QzEuOTk5OTEgMTcuNTUyMyAyLjQ0NzYyIDE4IDIuOTk5OTEgMThIMTQuOTk5OUMxNS41NTIyIDE4IDE1Ljk5OTkgMTcuNTUyMyAxNS45OTk5IDE3VjExLjUiIHN0cm9rZT0iI0Q1RTBGMiIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS40OTk5IDMuNVY4LjVIMTYuNDk5OVYzLjVIMTEuNDk5OVpNMTAuOTk5OSAyQzEwLjQ0NzYgMiA5Ljk5OTkxIDIuNDQ3NzIgOS45OTk5MSAzVjlDOS45OTk5MSA5LjU1MjI4IDEwLjQ0NzYgMTAgMTAuOTk5OSAxMEgxNi45OTk5QzE3LjU1MjIgMTAgMTcuOTk5OSA5LjU1MjI4IDE3Ljk5OTkgOVYzQzE3Ljk5OTkgMi40NDc3MiAxNy41NTIyIDIgMTYuOTk5OSAySDEwLjk5OTlaIiBmaWxsPSIjRDVFMEYyIi8+Cjwvc3ZnPgo=", Bi = {
  "minimize-desk-container": "_minimize-desk-container_gxy8f_1",
  "minimize-mobile-container": "_minimize-mobile-container_gxy8f_11"
};
function Vr() {
  const t = !z.isPC, e = () => {
    try {
      document.fullscreenElement && document.exitFullscreen();
    } catch (a) {
      console.debug(a);
    }
    X.toggleMinimize();
  }, n = /* @__PURE__ */ I.jsx(ie, { url: t ? Ml : ul });
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      className: t ? Bi["minimize-mobile-container"] : Bi["minimize-desk-container"],
      icon: n,
      onClick: e,
      isMobile: t
    }
  );
}
const Il = "data:image/svg+xml;base64,PHN2ZyB0PSIxNzAwMTIzNzY2MjQ3IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjgyODIiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHBhdGggZD0iTTU1Ny4yIDUxMmwyMzMuNC0yMzMuNGMxMi41LTEyLjUgMTIuNS0zMi44IDAtNDUuMnMtMzIuOC0xMi41LTQ1LjIgMEw1MTIgNDY2LjggMjc4LjYgMjMzLjRjLTEyLjUtMTIuNS0zMi44LTEyLjUtNDUuMiAwcy0xMi41IDMyLjggMCA0NS4yTDQ2Ni44IDUxMiAyMzMuNCA3NDUuNGMtMTIuNSAxMi41LTEyLjUgMzIuOCAwIDQ1LjIgNi4yIDYuMiAxNC40IDkuNCAyMi42IDkuNHMxNi40LTMuMSAyMi42LTkuNEw1MTIgNTU3LjJsMjMzLjQgMjMzLjRjNi4yIDYuMiAxNC40IDkuNCAyMi42IDkuNHMxNi40LTMuMSAyMi42LTkuNGMxMi41LTEyLjUgMTIuNS0zMi44IDAtNDUuMkw1NTcuMiA1MTJ6IiBwLWlkPSI4MjgzIj48L3BhdGg+PC9zdmc+";
function Al() {
  return /* @__PURE__ */ I.jsx("svg", { width: "20", height: "19", viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ I.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99967 16.9987C14.1418 16.9987 17.4997 13.6409 17.4997 9.4987C17.4997 5.35657 14.1418 1.9987 9.99967 1.9987C5.85754 1.9987 2.49967 5.35657 2.49967 9.4987C2.49967 13.6409 5.85754 16.9987 9.99967 16.9987ZM19.1663 9.4987C19.1663 14.5613 15.0623 18.6654 9.99967 18.6654C4.93707 18.6654 0.833008 14.5613 0.833008 9.4987C0.833008 4.43609 4.93707 0.332031 9.99967 0.332031C15.0623 0.332032 19.1663 4.43609 19.1663 9.4987ZM9.16634 14.082V7.83203H10.833V14.082H9.16634ZM10.833 6.58203H9.16309V4.91211H10.833V6.58203Z", fillOpacity: "0.9" }) });
}
function dl() {
  return /* @__PURE__ */ I.jsx("svg", { width: "20", height: "19", viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ I.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0016 17.0007C14.1438 17.0007 17.5016 13.6428 17.5016 9.50065C17.5016 5.35852 14.1438 2.00065 10.0016 2.00065C5.85949 2.00065 2.50163 5.35852 2.50163 9.50065C2.50163 13.6428 5.85949 17.0007 10.0016 17.0007ZM19.1683 9.50065C19.1683 14.5632 15.0642 18.6673 10.0016 18.6673C4.93902 18.6673 0.834961 14.5632 0.834961 9.50065C0.834961 4.43804 4.93902 0.333984 10.0016 0.333984C15.0642 0.333985 19.1683 4.43804 19.1683 9.50065ZM6.17119 12.1526L8.82313 9.50065L6.17119 6.84872L7.34969 5.67021L10.0016 8.32215L12.653 5.67078L13.8315 6.84929L11.1801 9.50065L13.8315 12.152L12.653 13.3306L10.0016 10.6792L7.34969 13.3311L6.17119 12.1526Z", fill: "#E54545" }) });
}
function Nl() {
  return /* @__PURE__ */ I.jsxs("svg", { width: "20", height: "19", viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ I.jsx("path", { d: "M5.58317 9.57612L9.17951 13.2052L14.6332 7.05264L13.5732 6.16634L8.97764 10.4388L6.42478 8.66748L5.58317 9.57612Z", fill: "#0ABF77" }),
    /* @__PURE__ */ I.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1663 9.49967C19.1663 14.5623 15.0623 18.6663 9.99967 18.6663C4.93706 18.6663 0.833008 14.5623 0.833008 9.49967C0.833008 4.43706 4.93706 0.333008 9.99967 0.333008C15.0623 0.333008 19.1663 4.43706 19.1663 9.49967ZM17.4997 9.49967C17.4997 13.6418 14.1418 16.9997 9.99967 16.9997C5.85754 16.9997 2.49967 13.6418 2.49967 9.49967C2.49967 5.35754 5.85754 1.99967 9.99967 1.99967C14.1418 1.99967 17.4997 5.35754 17.4997 9.49967Z", fill: "#0ABF77" })
  ] });
}
function gl() {
  return /* @__PURE__ */ I.jsx("svg", { width: "20", height: "19", viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ I.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99967 1.9987C14.1418 1.9987 17.4997 5.35653 17.4997 9.4987C17.4997 13.6408 14.1418 16.9987 9.99967 16.9987C5.85754 16.9987 2.49967 13.6408 2.49967 9.4987C2.49967 5.35653 5.85754 1.9987 9.99967 1.9987ZM19.1663 9.4987C19.1663 4.43612 15.0623 0.332031 9.99967 0.332031C4.93707 0.332031 0.833008 4.43612 0.833008 9.4987C0.833008 14.5613 4.93707 18.6654 9.99967 18.6654C15.0623 18.6654 19.1663 14.5613 19.1663 9.4987ZM9.16634 4.91536V11.1654H10.833V4.91536H9.16634ZM10.833 12.4154H9.16309V14.0853H10.833V12.4154Z", fill: "#FF7200" }) });
}
const Dl = {
  info: /* @__PURE__ */ I.jsx(Al, {}),
  waring: /* @__PURE__ */ I.jsx(gl, {}),
  success: /* @__PURE__ */ I.jsx(Nl, {}),
  error: /* @__PURE__ */ I.jsx(dl, {})
};
function Qr(t) {
  const {
    icon: e,
    showIcon: n = !0,
    duration: a = 3e3,
    theme: i = "info",
    style: r,
    closeBtn: s,
    showCloseBtn: c,
    className: l,
    children: u,
    plaintext: M = !1,
    onClose: N = () => null
  } = t, g = at(), D = x([
    l,
    `${P}-message-container`,
    { [`${P}-message-plaintext`]: M }
  ]);
  H(() => (g.current && clearTimeout(g.current), a > 0 && (g.current = setTimeout(() => {
    N == null || N();
  }, a)), () => {
    g && clearTimeout(g.current);
  }), [a, N]);
  const T = () => e || /* @__PURE__ */ I.jsx(I.Fragment, { children: Dl[i] }), E = () => s || /* @__PURE__ */ I.jsx(
    ie,
    {
      onClick: N,
      className: x([
        `${P}-message-icon`,
        "close-icon"
      ]),
      url: Il
    }
  );
  return /* @__PURE__ */ I.jsxs("div", { className: D, style: r, children: [
    n && !M && T(),
    u,
    c && !M && E()
  ] });
}
function Br(t) {
  const { className: e, style: n } = t, [a, i] = U(null), [r, s] = U(!0), [c, l] = U(0), u = x([
    e
  ]);
  function M(g) {
    l(0), i(g);
  }
  function N(g) {
    let D = g;
    typeof D == "object" && (D = g == null ? void 0 : g.text), D && (l(2e3), i(D));
  }
  return H(() => (f.watch(
    d.CALL,
    {
      [o.CALL_TIPS]: M
    },
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), f.watch(
    d.CALL,
    {
      [o.TOAST_INFO]: N
    }
  ), () => {
    f.unwatch(
      d.CALL,
      {
        [o.CALL_TIPS]: M,
        [o.TOAST_INFO]: N
      }
    );
  }), []), /* @__PURE__ */ I.jsx("div", { className: u, style: n, children: r && /* @__PURE__ */ I.jsx(Qr, { style: { whiteSpace: "nowrap" }, duration: c, onClose: () => s(!1), plaintext: !0, children: a }) });
}
const re = Ut({}), Yr = Ut({}), si = Ut({
  focusItem: null,
  setFocusItem: () => {
  }
}), ke = Ut({
  localUserInfo: { userId: "" },
  remoteList: []
}), Gr = Ut(!1), Bn = Ut({}), Yi = {
  "top-bar-container": "_top-bar-container_1m8fv_1",
  "top-bar": "_top-bar_1m8fv_1"
};
function Tl(t) {
  const { callDuration: e } = t, {
    isGroupCall: n,
    callStatus: a,
    callRole: i,
    allowedMinimized: r
  } = Q(re), s = n && (a === _.CONNECTED || i === De.CALLER);
  return /* @__PURE__ */ I.jsx("div", { className: Yi["top-bar-container"], children: /* @__PURE__ */ I.jsxs(Ht, { className: Yi["top-bar"], children: [
    /* @__PURE__ */ I.jsx(ve, { justify: "start", span: 4, children: r && /* @__PURE__ */ I.jsx(Vr, {}) }),
    /* @__PURE__ */ I.jsx(ve, { align: "center", span: 4, children: a === _.CONNECTED ? /* @__PURE__ */ I.jsx(br, { callDuration: e }) : s && /* @__PURE__ */ I.jsx(Br, {}) }),
    /* @__PURE__ */ I.jsx(ve, { span: 4 })
  ] }) });
}
const Fr = !!(typeof window < "u" && window.document && window.document.createElement);
function El(t) {
  const e = document.getElementById(t);
  !document.fullscreenElement && e ? e.requestFullscreen().catch((n) => {
    console.error(
      `Error attempting to enable fullscreen mode: ${n.message} (${n.name})`
    );
  }) : document.exitFullscreen();
}
function fl() {
}
const pl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjY2NjgzIDkuMzMzMzdIMy4zMzM1VjQuMDAwMDRDMy4zMzM1IDMuNjMxODUgMy42MzE5NyAzLjMzMzM3IDQuMDAwMTYgMy4zMzMzN0w5LjMzMzUgMy4zMzMzN1Y0LjY2NjcxSDUuNjA5NjNMOS44MDQ5IDguODYxOTlMOC44NjIwOSA5LjgwNDhMNC42NjY4MyA1LjYwOTUyVjkuMzMzMzdaTTE1LjMzMzMgMTAuNjY2N0gxNi42NjY3VjE2QzE2LjY2NjcgMTYuMzY4MiAxNi4zNjgyIDE2LjY2NjcgMTYgMTYuNjY2N0wxMC42NjY3IDE2LjY2NjdMMTAuNjY2NyAxNS4zMzMzSDE0LjM5MDVMMTAuMTk1MyAxMS4xMzhMMTEuMTM4MSAxMC4xOTUyTDE1LjMzMzMgMTQuMzkwNVYxMC42NjY3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTAuNjY2NjY3IDEuMzMzMzNDMC42NjY2NjcgMC45NjUxNDQgMC45NjUxNDQgMC42NjY2NjcgMS4zMzMzMyAwLjY2NjY2N0gxOC42NjY3QzE5LjAzNDkgMC42NjY2NjcgMTkuMzMzMyAwLjk2NTE0NCAxOS4zMzMzIDEuMzMzMzNWMTguNjY2N0MxOS4zMzMzIDE5LjAzNDkgMTkuMDM0OSAxOS4zMzMzIDE4LjY2NjcgMTkuMzMzM0gxLjMzMzMzQzAuOTY1MTQzIDE5LjMzMzMgMC42NjY2NjcgMTkuMDM0OSAwLjY2NjY2NyAxOC42NjY3VjEuMzMzMzNaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuMzMzMzMiLz4KPC9zdmc+", jl = {
  "full-screen-container": "_full-screen-container_16bjq_1"
};
function hl(t) {
  const { domID: e } = t, n = /* @__PURE__ */ I.jsx(ie, { url: pl });
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      className: jl["full-screen-container"],
      icon: n,
      onClick: () => {
        typeof e == "string" && El(e);
      }
    }
  );
}
const Cl = {
  "single-top-bar": "_single-top-bar_15cxx_1"
};
function Ll(t) {
  const { callDuration: e } = t, {
    isGroupCall: n,
    callStatus: a,
    allowedMinimized: i,
    allowedFullScreen: r
  } = Q(re), s = a === _.CONNECTED && !n;
  return /* @__PURE__ */ I.jsxs(Ht, { className: Cl["single-top-bar"], children: [
    /* @__PURE__ */ I.jsx(ve, { span: 4 }),
    /* @__PURE__ */ I.jsx(ve, { span: 4, children: s && /* @__PURE__ */ I.jsx(br, { callDuration: e }) }),
    /* @__PURE__ */ I.jsxs(ve, { span: 4, justify: "end", children: [
      i && /* @__PURE__ */ I.jsx(Vr, {}),
      r && /* @__PURE__ */ I.jsx(hl, { domID: "tuicallkit-id" })
    ] })
  ] });
}
function li() {
  const [
    t,
    e
  ] = U(f.getData(d.CALL, o.CALL_DURATION)), n = (i) => {
    e(i);
  }, a = {
    [o.CALL_DURATION]: n
  };
  return H(() => (f.watch(
    d.CALL,
    a,
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), () => {
    f.unwatch(
      d.CALL,
      a
    );
  }), []), t;
}
function Zr() {
  const t = !z.isPC, e = li();
  return /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
    t && /* @__PURE__ */ I.jsx(Tl, { callDuration: e }),
    !t && /* @__PURE__ */ I.jsx(Ll, { callDuration: e })
  ] });
}
const yl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIyXzE2OTcpIj4KPHBhdGggZD0iTTQuMTYxODIgNS42NzY5OUMyLjU4MDQ5IDcuMjU4MzIgMS45NjcxOCA5LjYwODA1IDIuODczOTUgMTEuNjUyM0M0LjQ0OTc3IDE1LjIwNDkgNi42OTM5OSAxOC41MzI4IDkuNjA2NiAyMS40NDU0QzEyLjUxOTIgMjQuMzU4IDE1Ljg0NzEgMjYuNjAyMiAxOS4zOTk3IDI4LjE3ODFDMjEuNDQ0IDI5LjA4NDggMjMuNzkzNyAyOC40NzE1IDI1LjM3NSAyNi44OTAyTDI3LjkxODMgMjQuMzQ2OUMyOC41MzE5IDIzLjczMzMgMjguNDk4NCAyMi43Mjg4IDI3Ljg0NTQgMjIuMTU3NEwyMy4wMzcxIDE3Ljk1MDFDMjIuNDQyOCAxNy40MzAxIDIxLjU0NzEgMTcuNDU5OSAyMC45ODg3IDE4LjAxODNMMTguODU3NyAyMC4xNDkzQzE4LjYwODQgMjAuMzk4NiAxOC4yMTg0IDIwLjQ0MTUgMTcuOTI2MiAyMC4yNDQzQzE2LjU1MDUgMTkuMzE2MSAxNS4yNDM0IDE4LjI0MzMgMTQuMDI2IDE3LjAyNkMxMi44MDg3IDE1LjgwODYgMTEuNzM1OSAxNC41MDE1IDEwLjgwNzcgMTMuMTI1OEMxMC42MTA1IDEyLjgzMzYgMTAuNjUzNCAxMi40NDM2IDEwLjkwMjcgMTIuMTk0M0wxMy4wMzM3IDEwLjA2MzNDMTMuNTkyMSA5LjUwNDk0IDEzLjYyMTkgOC42MDkyMyAxMy4xMDE5IDguMDE0OTNMOC44OTQ2NCAzLjIwNjZDOC4zMjMyNSAyLjU1MzU5IDcuMzE4NjcgMi41MjAxNCA2LjcwNTExIDMuMTMzN0w0LjE2MTgyIDUuNjc2OTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIyXzE2OTciPgo8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", Fe = "tk", ce = {
  "btn-icon": "_btn-icon_zmhpj_1",
  "btn-icon-container": "_btn-icon-container_zmhpj_6",
  "arrow-btn": "_arrow-btn_zmhpj_21",
  "tk-btn": "_tk-btn_zmhpj_33"
}, ml = {
  "accept-icon-container": "_accept-icon-container_2gkee_1"
};
function mt(t) {
  const e = () => X.accept(), n = x([
    ce["btn-icon-container"],
    ml["accept-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC
    }
  ]), a = /* @__PURE__ */ I.jsx(ie, { className: ce["btn-icon"], url: yl });
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      className: ce[`${Fe}-btn`],
      icon: a,
      iconClassName: n,
      onClick: e,
      ...t,
      children: k("accept")
    }
  );
}
const Wr = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwIDE2LjA1MDlDMzAgMTMuODE0NiAyOC43NzIyIDExLjcxOTQgMjYuNjg1NSAxMC45MTVDMjMuMDU5MSA5LjUxNzI2IDE5LjExOSA4Ljc1MDk4IDE1IDguNzUwOThDMTAuODgwOSA4Ljc1MDk4IDYuOTQwODYgOS41MTcyNiAzLjMxNDUzIDEwLjkxNUMxLjIyNzg0IDExLjcxOTQgMCAxMy44MTQ2IDAgMTYuMDUwOVYxOS42NDc2QzAgMjAuNTE1MyAwLjczNDAwMyAyMS4yMDIgMS41OTk3OCAyMS4xNDQzTDcuOTc0NzggMjAuNzE5M0M4Ljc2MjcyIDIwLjY2NjggOS4zNzUgMjAuMDEyMyA5LjM3NSAxOS4yMjI2VjE2LjIwOUM5LjM3NSAxNS44NTY0IDkuNjIwMzQgMTUuNTUwMyA5Ljk2NjQ0IDE1LjQ4MzFDMTEuNTk1NSAxNS4xNjY3IDEzLjI3ODQgMTUuMDAxIDE1IDE1LjAwMUMxNi43MjE2IDE1LjAwMSAxOC40MDQ1IDE1LjE2NjcgMjAuMDMzNiAxNS40ODMxQzIwLjM3OTcgMTUuNTUwMyAyMC42MjUgMTUuODU2NCAyMC42MjUgMTYuMjA5VjE5LjIyMjZDMjAuNjI1IDIwLjAxMjMgMjEuMjM3MyAyMC42NjY4IDIyLjAyNTIgMjAuNzE5M0wyOC40MDAyIDIxLjE0NDNDMjkuMjY2IDIxLjIwMiAzMCAyMC41MTUzIDMwIDE5LjY0NzZWMTYuMDUwOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", Sl = {
  "reject-icon-container": "_reject-icon-container_15q4l_1"
};
function St(t) {
  const e = () => X.reject(), n = x([
    ce["btn-icon-container"],
    Sl["reject-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC
    }
  ]), a = /* @__PURE__ */ I.jsx(ie, { className: ce["btn-icon"], url: Wr });
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      className: ce[`${Fe}-btn`],
      icon: a,
      iconClassName: n,
      onClick: e,
      ...t,
      children: k("reject")
    }
  );
}
var Gi = function(e) {
  return e.reduce(function(n, a) {
    var i = a[0], r = a[1];
    return n[i] = r, n;
  }, {});
}, Fi = typeof window < "u" && window.document && window.document.createElement ? Gt.useLayoutEffect : Gt.useEffect, we = "top", Ze = "bottom", We = "right", Ue = "left", ci = "auto", Yn = [we, Ze, We, Ue], un = "start", Rn = "end", Ol = "clippingParents", Pr = "viewport", Ln = "popper", wl = "reference", Zi = /* @__PURE__ */ Yn.reduce(function(t, e) {
  return t.concat([e + "-" + un, e + "-" + Rn]);
}, []), Hr = /* @__PURE__ */ [].concat(Yn, [ci]).reduce(function(t, e) {
  return t.concat([e, e + "-" + un, e + "-" + Rn]);
}, []), Ul = "beforeRead", zl = "read", xl = "afterRead", vl = "beforeMain", Rl = "main", bl = "afterMain", _l = "beforeWrite", kl = "write", Vl = "afterWrite", Ql = [Ul, zl, xl, vl, Rl, bl, _l, kl, Vl];
function rt(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Re(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Jt(t) {
  var e = Re(t).Element;
  return t instanceof e || t instanceof Element;
}
function Ge(t) {
  var e = Re(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function ui(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Re(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function Bl(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var a = e.styles[n] || {}, i = e.attributes[n] || {}, r = e.elements[n];
    !Ge(r) || !rt(r) || (Object.assign(r.style, a), Object.keys(i).forEach(function(s) {
      var c = i[s];
      c === !1 ? r.removeAttribute(s) : r.setAttribute(s, c === !0 ? "" : c);
    }));
  });
}
function Yl(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(a) {
      var i = e.elements[a], r = e.attributes[a] || {}, s = Object.keys(e.styles.hasOwnProperty(a) ? e.styles[a] : n[a]), c = s.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Ge(i) || !rt(i) || (Object.assign(i.style, c), Object.keys(r).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const Gl = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Bl,
  effect: Yl,
  requires: ["computeStyles"]
};
function it(t) {
  return t.split("-")[0];
}
var Pt = Math.max, ua = Math.min, Mn = Math.round;
function Wa() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Jr() {
  return !/^((?!chrome|android).)*safari/i.test(Wa());
}
function In(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var a = t.getBoundingClientRect(), i = 1, r = 1;
  e && Ge(t) && (i = t.offsetWidth > 0 && Mn(a.width) / t.offsetWidth || 1, r = t.offsetHeight > 0 && Mn(a.height) / t.offsetHeight || 1);
  var s = Jt(t) ? Re(t) : window, c = s.visualViewport, l = !Jr() && n, u = (a.left + (l && c ? c.offsetLeft : 0)) / i, M = (a.top + (l && c ? c.offsetTop : 0)) / r, N = a.width / i, g = a.height / r;
  return {
    width: N,
    height: g,
    top: M,
    right: u + N,
    bottom: M + g,
    left: u,
    x: u,
    y: M
  };
}
function Mi(t) {
  var e = In(t), n = t.offsetWidth, a = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - a) <= 1 && (a = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: a
  };
}
function Xr(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && ui(n)) {
    var a = e;
    do {
      if (a && t.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function gt(t) {
  return Re(t).getComputedStyle(t);
}
function Fl(t) {
  return ["table", "td", "th"].indexOf(rt(t)) >= 0;
}
function zt(t) {
  return ((Jt(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function ga(t) {
  return rt(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (ui(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zt(t)
  );
}
function Wi(t) {
  return !Ge(t) || // https://github.com/popperjs/popper-core/issues/837
  gt(t).position === "fixed" ? null : t.offsetParent;
}
function Zl(t) {
  var e = /firefox/i.test(Wa()), n = /Trident/i.test(Wa());
  if (n && Ge(t)) {
    var a = gt(t);
    if (a.position === "fixed")
      return null;
  }
  var i = ga(t);
  for (ui(i) && (i = i.host); Ge(i) && ["html", "body"].indexOf(rt(i)) < 0; ) {
    var r = gt(i);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || e && r.willChange === "filter" || e && r.filter && r.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Gn(t) {
  for (var e = Re(t), n = Wi(t); n && Fl(n) && gt(n).position === "static"; )
    n = Wi(n);
  return n && (rt(n) === "html" || rt(n) === "body" && gt(n).position === "static") ? e : n || Zl(t) || e;
}
function Ii(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function wn(t, e, n) {
  return Pt(t, ua(e, n));
}
function Wl(t, e, n) {
  var a = wn(t, e, n);
  return a > n ? n : a;
}
function Kr() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function $r(t) {
  return Object.assign({}, Kr(), t);
}
function qr(t, e) {
  return e.reduce(function(n, a) {
    return n[a] = t, n;
  }, {});
}
var Pl = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, $r(typeof e != "number" ? e : qr(e, Yn));
};
function Hl(t) {
  var e, n = t.state, a = t.name, i = t.options, r = n.elements.arrow, s = n.modifiersData.popperOffsets, c = it(n.placement), l = Ii(c), u = [Ue, We].indexOf(c) >= 0, M = u ? "height" : "width";
  if (!(!r || !s)) {
    var N = Pl(i.padding, n), g = Mi(r), D = l === "y" ? we : Ue, T = l === "y" ? Ze : We, E = n.rects.reference[M] + n.rects.reference[l] - s[l] - n.rects.popper[M], j = s[l] - n.rects.reference[l], p = Gn(r), C = p ? l === "y" ? p.clientHeight || 0 : p.clientWidth || 0 : 0, m = E / 2 - j / 2, L = N[D], S = C - g[M] - N[T], y = C / 2 - g[M] / 2 + m, w = wn(L, y, S), b = l;
    n.modifiersData[a] = (e = {}, e[b] = w, e.centerOffset = w - y, e);
  }
}
function Jl(t) {
  var e = t.state, n = t.options, a = n.element, i = a === void 0 ? "[data-popper-arrow]" : a;
  i != null && (typeof i == "string" && (i = e.elements.popper.querySelector(i), !i) || Xr(e.elements.popper, i) && (e.elements.arrow = i));
}
const Xl = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hl,
  effect: Jl,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function An(t) {
  return t.split("-")[1];
}
var Kl = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function $l(t, e) {
  var n = t.x, a = t.y, i = e.devicePixelRatio || 1;
  return {
    x: Mn(n * i) / i || 0,
    y: Mn(a * i) / i || 0
  };
}
function Pi(t) {
  var e, n = t.popper, a = t.popperRect, i = t.placement, r = t.variation, s = t.offsets, c = t.position, l = t.gpuAcceleration, u = t.adaptive, M = t.roundOffsets, N = t.isFixed, g = s.x, D = g === void 0 ? 0 : g, T = s.y, E = T === void 0 ? 0 : T, j = typeof M == "function" ? M({
    x: D,
    y: E
  }) : {
    x: D,
    y: E
  };
  D = j.x, E = j.y;
  var p = s.hasOwnProperty("x"), C = s.hasOwnProperty("y"), m = Ue, L = we, S = window;
  if (u) {
    var y = Gn(n), w = "clientHeight", b = "clientWidth";
    if (y === Re(n) && (y = zt(n), gt(y).position !== "static" && c === "absolute" && (w = "scrollHeight", b = "scrollWidth")), y = y, i === we || (i === Ue || i === We) && r === Rn) {
      L = Ze;
      var B = N && y === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        y[w]
      );
      E -= B - a.height, E *= l ? 1 : -1;
    }
    if (i === Ue || (i === we || i === Ze) && r === Rn) {
      m = We;
      var F = N && y === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        y[b]
      );
      D -= F - a.width, D *= l ? 1 : -1;
    }
  }
  var oe = Object.assign({
    position: c
  }, u && Kl), Ae = M === !0 ? $l({
    x: D,
    y: E
  }, Re(n)) : {
    x: D,
    y: E
  };
  if (D = Ae.x, E = Ae.y, l) {
    var K;
    return Object.assign({}, oe, (K = {}, K[L] = C ? "0" : "", K[m] = p ? "0" : "", K.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + D + "px, " + E + "px)" : "translate3d(" + D + "px, " + E + "px, 0)", K));
  }
  return Object.assign({}, oe, (e = {}, e[L] = C ? E + "px" : "", e[m] = p ? D + "px" : "", e.transform = "", e));
}
function ql(t) {
  var e = t.state, n = t.options, a = n.gpuAcceleration, i = a === void 0 ? !0 : a, r = n.adaptive, s = r === void 0 ? !0 : r, c = n.roundOffsets, l = c === void 0 ? !0 : c, u = {
    placement: it(e.placement),
    variation: An(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: i,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, Pi(Object.assign({}, u, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, Pi(Object.assign({}, u, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const ec = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ql,
  data: {}
};
var $n = {
  passive: !0
};
function tc(t) {
  var e = t.state, n = t.instance, a = t.options, i = a.scroll, r = i === void 0 ? !0 : i, s = a.resize, c = s === void 0 ? !0 : s, l = Re(e.elements.popper), u = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return r && u.forEach(function(M) {
    M.addEventListener("scroll", n.update, $n);
  }), c && l.addEventListener("resize", n.update, $n), function() {
    r && u.forEach(function(M) {
      M.removeEventListener("scroll", n.update, $n);
    }), c && l.removeEventListener("resize", n.update, $n);
  };
}
const nc = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: tc,
  data: {}
};
var ac = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function na(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return ac[e];
  });
}
var ic = {
  start: "end",
  end: "start"
};
function Hi(t) {
  return t.replace(/start|end/g, function(e) {
    return ic[e];
  });
}
function Ai(t) {
  var e = Re(t), n = e.pageXOffset, a = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: a
  };
}
function di(t) {
  return In(zt(t)).left + Ai(t).scrollLeft;
}
function rc(t, e) {
  var n = Re(t), a = zt(t), i = n.visualViewport, r = a.clientWidth, s = a.clientHeight, c = 0, l = 0;
  if (i) {
    r = i.width, s = i.height;
    var u = Jr();
    (u || !u && e === "fixed") && (c = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: c + di(t),
    y: l
  };
}
function oc(t) {
  var e, n = zt(t), a = Ai(t), i = (e = t.ownerDocument) == null ? void 0 : e.body, r = Pt(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Pt(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), c = -a.scrollLeft + di(t), l = -a.scrollTop;
  return gt(i || n).direction === "rtl" && (c += Pt(n.clientWidth, i ? i.clientWidth : 0) - r), {
    width: r,
    height: s,
    x: c,
    y: l
  };
}
function Ni(t) {
  var e = gt(t), n = e.overflow, a = e.overflowX, i = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + a);
}
function eo(t) {
  return ["html", "body", "#document"].indexOf(rt(t)) >= 0 ? t.ownerDocument.body : Ge(t) && Ni(t) ? t : eo(ga(t));
}
function Un(t, e) {
  var n;
  e === void 0 && (e = []);
  var a = eo(t), i = a === ((n = t.ownerDocument) == null ? void 0 : n.body), r = Re(a), s = i ? [r].concat(r.visualViewport || [], Ni(a) ? a : []) : a, c = e.concat(s);
  return i ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(Un(ga(s)))
  );
}
function Pa(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function sc(t, e) {
  var n = In(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Ji(t, e, n) {
  return e === Pr ? Pa(rc(t, n)) : Jt(e) ? sc(e, n) : Pa(oc(zt(t)));
}
function lc(t) {
  var e = Un(ga(t)), n = ["absolute", "fixed"].indexOf(gt(t).position) >= 0, a = n && Ge(t) ? Gn(t) : t;
  return Jt(a) ? e.filter(function(i) {
    return Jt(i) && Xr(i, a) && rt(i) !== "body";
  }) : [];
}
function cc(t, e, n, a) {
  var i = e === "clippingParents" ? lc(t) : [].concat(e), r = [].concat(i, [n]), s = r[0], c = r.reduce(function(l, u) {
    var M = Ji(t, u, a);
    return l.top = Pt(M.top, l.top), l.right = ua(M.right, l.right), l.bottom = ua(M.bottom, l.bottom), l.left = Pt(M.left, l.left), l;
  }, Ji(t, s, a));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function to(t) {
  var e = t.reference, n = t.element, a = t.placement, i = a ? it(a) : null, r = a ? An(a) : null, s = e.x + e.width / 2 - n.width / 2, c = e.y + e.height / 2 - n.height / 2, l;
  switch (i) {
    case we:
      l = {
        x: s,
        y: e.y - n.height
      };
      break;
    case Ze:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case We:
      l = {
        x: e.x + e.width,
        y: c
      };
      break;
    case Ue:
      l = {
        x: e.x - n.width,
        y: c
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var u = i ? Ii(i) : null;
  if (u != null) {
    var M = u === "y" ? "height" : "width";
    switch (r) {
      case un:
        l[u] = l[u] - (e[M] / 2 - n[M] / 2);
        break;
      case Rn:
        l[u] = l[u] + (e[M] / 2 - n[M] / 2);
        break;
    }
  }
  return l;
}
function bn(t, e) {
  e === void 0 && (e = {});
  var n = e, a = n.placement, i = a === void 0 ? t.placement : a, r = n.strategy, s = r === void 0 ? t.strategy : r, c = n.boundary, l = c === void 0 ? Ol : c, u = n.rootBoundary, M = u === void 0 ? Pr : u, N = n.elementContext, g = N === void 0 ? Ln : N, D = n.altBoundary, T = D === void 0 ? !1 : D, E = n.padding, j = E === void 0 ? 0 : E, p = $r(typeof j != "number" ? j : qr(j, Yn)), C = g === Ln ? wl : Ln, m = t.rects.popper, L = t.elements[T ? C : g], S = cc(Jt(L) ? L : L.contextElement || zt(t.elements.popper), l, M, s), y = In(t.elements.reference), w = to({
    reference: y,
    element: m,
    strategy: "absolute",
    placement: i
  }), b = Pa(Object.assign({}, m, w)), B = g === Ln ? b : y, F = {
    top: S.top - B.top + p.top,
    bottom: B.bottom - S.bottom + p.bottom,
    left: S.left - B.left + p.left,
    right: B.right - S.right + p.right
  }, oe = t.modifiersData.offset;
  if (g === Ln && oe) {
    var Ae = oe[i];
    Object.keys(F).forEach(function(K) {
      var ue = [We, Ze].indexOf(K) >= 0 ? 1 : -1, ge = [we, Ze].indexOf(K) >= 0 ? "y" : "x";
      F[K] += Ae[ge] * ue;
    });
  }
  return F;
}
function uc(t, e) {
  e === void 0 && (e = {});
  var n = e, a = n.placement, i = n.boundary, r = n.rootBoundary, s = n.padding, c = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? Hr : l, M = An(a), N = M ? c ? Zi : Zi.filter(function(T) {
    return An(T) === M;
  }) : Yn, g = N.filter(function(T) {
    return u.indexOf(T) >= 0;
  });
  g.length === 0 && (g = N);
  var D = g.reduce(function(T, E) {
    return T[E] = bn(t, {
      placement: E,
      boundary: i,
      rootBoundary: r,
      padding: s
    })[it(E)], T;
  }, {});
  return Object.keys(D).sort(function(T, E) {
    return D[T] - D[E];
  });
}
function Mc(t) {
  if (it(t) === ci)
    return [];
  var e = na(t);
  return [Hi(t), e, Hi(e)];
}
function Ic(t) {
  var e = t.state, n = t.options, a = t.name;
  if (!e.modifiersData[a]._skip) {
    for (var i = n.mainAxis, r = i === void 0 ? !0 : i, s = n.altAxis, c = s === void 0 ? !0 : s, l = n.fallbackPlacements, u = n.padding, M = n.boundary, N = n.rootBoundary, g = n.altBoundary, D = n.flipVariations, T = D === void 0 ? !0 : D, E = n.allowedAutoPlacements, j = e.options.placement, p = it(j), C = p === j, m = l || (C || !T ? [na(j)] : Mc(j)), L = [j].concat(m).reduce(function(qe, Qe) {
      return qe.concat(it(Qe) === ci ? uc(e, {
        placement: Qe,
        boundary: M,
        rootBoundary: N,
        padding: u,
        flipVariations: T,
        allowedAutoPlacements: E
      }) : Qe);
    }, []), S = e.rects.reference, y = e.rects.popper, w = /* @__PURE__ */ new Map(), b = !0, B = L[0], F = 0; F < L.length; F++) {
      var oe = L[F], Ae = it(oe), K = An(oe) === un, ue = [we, Ze].indexOf(Ae) >= 0, ge = ue ? "width" : "height", se = bn(e, {
        placement: oe,
        boundary: M,
        rootBoundary: N,
        altBoundary: g,
        padding: u
      }), Te = ue ? K ? We : Ue : K ? Ze : we;
      S[ge] > y[ge] && (Te = na(Te));
      var ot = na(Te), Ve = [];
      if (r && Ve.push(se[Ae] <= 0), c && Ve.push(se[Te] <= 0, se[ot] <= 0), Ve.every(function(qe) {
        return qe;
      })) {
        B = oe, b = !1;
        break;
      }
      w.set(oe, Ve);
    }
    if (b)
      for (var st = T ? 3 : 1, Et = function(Qe) {
        var He = L.find(function(et) {
          var me = w.get(et);
          if (me)
            return me.slice(0, Qe).every(function(ct) {
              return ct;
            });
        });
        if (He)
          return B = He, "break";
      }, $e = st; $e > 0; $e--) {
        var lt = Et($e);
        if (lt === "break")
          break;
      }
    e.placement !== B && (e.modifiersData[a]._skip = !0, e.placement = B, e.reset = !0);
  }
}
const Ac = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Ic,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Xi(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function Ki(t) {
  return [we, We, Ze, Ue].some(function(e) {
    return t[e] >= 0;
  });
}
function dc(t) {
  var e = t.state, n = t.name, a = e.rects.reference, i = e.rects.popper, r = e.modifiersData.preventOverflow, s = bn(e, {
    elementContext: "reference"
  }), c = bn(e, {
    altBoundary: !0
  }), l = Xi(s, a), u = Xi(c, i, r), M = Ki(l), N = Ki(u);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: M,
    hasPopperEscaped: N
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": M,
    "data-popper-escaped": N
  });
}
const Nc = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: dc
};
function gc(t, e, n) {
  var a = it(t), i = [Ue, we].indexOf(a) >= 0 ? -1 : 1, r = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, s = r[0], c = r[1];
  return s = s || 0, c = (c || 0) * i, [Ue, We].indexOf(a) >= 0 ? {
    x: c,
    y: s
  } : {
    x: s,
    y: c
  };
}
function Dc(t) {
  var e = t.state, n = t.options, a = t.name, i = n.offset, r = i === void 0 ? [0, 0] : i, s = Hr.reduce(function(M, N) {
    return M[N] = gc(N, e.rects, r), M;
  }, {}), c = s[e.placement], l = c.x, u = c.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += u), e.modifiersData[a] = s;
}
const Tc = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Dc
};
function Ec(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = to({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const fc = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ec,
  data: {}
};
function pc(t) {
  return t === "x" ? "y" : "x";
}
function jc(t) {
  var e = t.state, n = t.options, a = t.name, i = n.mainAxis, r = i === void 0 ? !0 : i, s = n.altAxis, c = s === void 0 ? !1 : s, l = n.boundary, u = n.rootBoundary, M = n.altBoundary, N = n.padding, g = n.tether, D = g === void 0 ? !0 : g, T = n.tetherOffset, E = T === void 0 ? 0 : T, j = bn(e, {
    boundary: l,
    rootBoundary: u,
    padding: N,
    altBoundary: M
  }), p = it(e.placement), C = An(e.placement), m = !C, L = Ii(p), S = pc(L), y = e.modifiersData.popperOffsets, w = e.rects.reference, b = e.rects.popper, B = typeof E == "function" ? E(Object.assign({}, e.rects, {
    placement: e.placement
  })) : E, F = typeof B == "number" ? {
    mainAxis: B,
    altAxis: B
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, B), oe = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, Ae = {
    x: 0,
    y: 0
  };
  if (y) {
    if (r) {
      var K, ue = L === "y" ? we : Ue, ge = L === "y" ? Ze : We, se = L === "y" ? "height" : "width", Te = y[L], ot = Te + j[ue], Ve = Te - j[ge], st = D ? -b[se] / 2 : 0, Et = C === un ? w[se] : b[se], $e = C === un ? -b[se] : -w[se], lt = e.elements.arrow, qe = D && lt ? Mi(lt) : {
        width: 0,
        height: 0
      }, Qe = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Kr(), He = Qe[ue], et = Qe[ge], me = wn(0, w[se], qe[se]), ct = m ? w[se] / 2 - st - me - He - F.mainAxis : Et - me - He - F.mainAxis, ft = m ? -w[se] / 2 + st + me + et + F.mainAxis : $e + me + et + F.mainAxis, xt = e.elements.arrow && Gn(e.elements.arrow), qt = xt ? L === "y" ? xt.clientTop || 0 : xt.clientLeft || 0 : 0, vt = (K = oe == null ? void 0 : oe[L]) != null ? K : 0, Dn = Te + ct - vt - qt, pt = Te + ft - vt, tt = wn(D ? ua(ot, Dn) : ot, Te, D ? Pt(Ve, pt) : Ve);
      y[L] = tt, Ae[L] = tt - Te;
    }
    if (c) {
      var Rt, bt = L === "x" ? we : Ue, G = L === "x" ? Ze : We, Be = y[S], en = S === "y" ? "height" : "width", tn = Be + j[bt], Pn = Be - j[G], Tn = [we, Ue].indexOf(p) !== -1, En = (Rt = oe == null ? void 0 : oe[S]) != null ? Rt : 0, fn = Tn ? tn : Be - w[en] - b[en] - En + F.altAxis, jt = Tn ? Be + w[en] + b[en] - En - F.altAxis : Pn, Hn = D && Tn ? Wl(fn, Be, jt) : wn(D ? fn : tn, Be, D ? jt : Pn);
      y[S] = Hn, Ae[S] = Hn - Be;
    }
    e.modifiersData[a] = Ae;
  }
}
const hc = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: jc,
  requiresIfExists: ["offset"]
};
function Cc(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function Lc(t) {
  return t === Re(t) || !Ge(t) ? Ai(t) : Cc(t);
}
function yc(t) {
  var e = t.getBoundingClientRect(), n = Mn(e.width) / t.offsetWidth || 1, a = Mn(e.height) / t.offsetHeight || 1;
  return n !== 1 || a !== 1;
}
function mc(t, e, n) {
  n === void 0 && (n = !1);
  var a = Ge(e), i = Ge(e) && yc(e), r = zt(e), s = In(t, i, n), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (a || !a && !n) && ((rt(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ni(r)) && (c = Lc(e)), Ge(e) ? (l = In(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : r && (l.x = di(r))), {
    x: s.left + c.scrollLeft - l.x,
    y: s.top + c.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Sc(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), a = [];
  t.forEach(function(r) {
    e.set(r.name, r);
  });
  function i(r) {
    n.add(r.name);
    var s = [].concat(r.requires || [], r.requiresIfExists || []);
    s.forEach(function(c) {
      if (!n.has(c)) {
        var l = e.get(c);
        l && i(l);
      }
    }), a.push(r);
  }
  return t.forEach(function(r) {
    n.has(r.name) || i(r);
  }), a;
}
function Oc(t) {
  var e = Sc(t);
  return Ql.reduce(function(n, a) {
    return n.concat(e.filter(function(i) {
      return i.phase === a;
    }));
  }, []);
}
function wc(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function Uc(t) {
  var e = t.reduce(function(n, a) {
    var i = n[a.name];
    return n[a.name] = i ? Object.assign({}, i, a, {
      options: Object.assign({}, i.options, a.options),
      data: Object.assign({}, i.data, a.data)
    }) : a, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var $i = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function qi() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function zc(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, a = n === void 0 ? [] : n, i = e.defaultOptions, r = i === void 0 ? $i : i;
  return function(c, l, u) {
    u === void 0 && (u = r);
    var M = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, $i, r),
      modifiersData: {},
      elements: {
        reference: c,
        popper: l
      },
      attributes: {},
      styles: {}
    }, N = [], g = !1, D = {
      state: M,
      setOptions: function(p) {
        var C = typeof p == "function" ? p(M.options) : p;
        E(), M.options = Object.assign({}, r, M.options, C), M.scrollParents = {
          reference: Jt(c) ? Un(c) : c.contextElement ? Un(c.contextElement) : [],
          popper: Un(l)
        };
        var m = Oc(Uc([].concat(a, M.options.modifiers)));
        return M.orderedModifiers = m.filter(function(L) {
          return L.enabled;
        }), T(), D.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var p = M.elements, C = p.reference, m = p.popper;
          if (qi(C, m)) {
            M.rects = {
              reference: mc(C, Gn(m), M.options.strategy === "fixed"),
              popper: Mi(m)
            }, M.reset = !1, M.placement = M.options.placement, M.orderedModifiers.forEach(function(F) {
              return M.modifiersData[F.name] = Object.assign({}, F.data);
            });
            for (var L = 0; L < M.orderedModifiers.length; L++) {
              if (M.reset === !0) {
                M.reset = !1, L = -1;
                continue;
              }
              var S = M.orderedModifiers[L], y = S.fn, w = S.options, b = w === void 0 ? {} : w, B = S.name;
              typeof y == "function" && (M = y({
                state: M,
                options: b,
                name: B,
                instance: D
              }) || M);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: wc(function() {
        return new Promise(function(j) {
          D.forceUpdate(), j(M);
        });
      }),
      destroy: function() {
        E(), g = !0;
      }
    };
    if (!qi(c, l))
      return D;
    D.setOptions(u).then(function(j) {
      !g && u.onFirstUpdate && u.onFirstUpdate(j);
    });
    function T() {
      M.orderedModifiers.forEach(function(j) {
        var p = j.name, C = j.options, m = C === void 0 ? {} : C, L = j.effect;
        if (typeof L == "function") {
          var S = L({
            state: M,
            name: p,
            instance: D,
            options: m
          }), y = function() {
          };
          N.push(S || y);
        }
      });
    }
    function E() {
      N.forEach(function(j) {
        return j();
      }), N = [];
    }
    return D;
  };
}
var xc = [nc, fc, ec, Gl, Tc, Ac, hc, Xl, Nc], vc = /* @__PURE__ */ zc({
  defaultModifiers: xc
}), Rc = typeof Element < "u", bc = typeof Map == "function", _c = typeof Set == "function", kc = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function aa(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    if (t.constructor !== e.constructor)
      return !1;
    var n, a, i;
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (!aa(t[a], e[a]))
          return !1;
      return !0;
    }
    var r;
    if (bc && t instanceof Map && e instanceof Map) {
      if (t.size !== e.size)
        return !1;
      for (r = t.entries(); !(a = r.next()).done; )
        if (!e.has(a.value[0]))
          return !1;
      for (r = t.entries(); !(a = r.next()).done; )
        if (!aa(a.value[1], e.get(a.value[0])))
          return !1;
      return !0;
    }
    if (_c && t instanceof Set && e instanceof Set) {
      if (t.size !== e.size)
        return !1;
      for (r = t.entries(); !(a = r.next()).done; )
        if (!e.has(a.value[0]))
          return !1;
      return !0;
    }
    if (kc && ArrayBuffer.isView(t) && ArrayBuffer.isView(e)) {
      if (n = t.length, n != e.length)
        return !1;
      for (a = n; a-- !== 0; )
        if (t[a] !== e[a])
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === e.source && t.flags === e.flags;
    if (t.valueOf !== Object.prototype.valueOf && typeof t.valueOf == "function" && typeof e.valueOf == "function")
      return t.valueOf() === e.valueOf();
    if (t.toString !== Object.prototype.toString && typeof t.toString == "function" && typeof e.toString == "function")
      return t.toString() === e.toString();
    if (i = Object.keys(t), n = i.length, n !== Object.keys(e).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(e, i[a]))
        return !1;
    if (Rc && t instanceof Element)
      return !1;
    for (a = n; a-- !== 0; )
      if (!((i[a] === "_owner" || i[a] === "__v" || i[a] === "__o") && t.$$typeof) && !aa(t[i[a]], e[i[a]]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
var Vc = function(e, n) {
  try {
    return aa(e, n);
  } catch (a) {
    if ((a.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw a;
  }
};
const Qc = /* @__PURE__ */ Ks(Vc);
var Bc = [], Yc = function(e, n, a) {
  a === void 0 && (a = {});
  var i = Gt.useRef(null), r = {
    onFirstUpdate: a.onFirstUpdate,
    placement: a.placement || "bottom",
    strategy: a.strategy || "absolute",
    modifiers: a.modifiers || Bc
  }, s = Gt.useState({
    styles: {
      popper: {
        position: r.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), c = s[0], l = s[1], u = Gt.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(D) {
        var T = D.state, E = Object.keys(T.elements);
        es.flushSync(function() {
          l({
            styles: Gi(E.map(function(j) {
              return [j, T.styles[j] || {}];
            })),
            attributes: Gi(E.map(function(j) {
              return [j, T.attributes[j]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), M = Gt.useMemo(function() {
    var g = {
      onFirstUpdate: r.onFirstUpdate,
      placement: r.placement,
      strategy: r.strategy,
      modifiers: [].concat(r.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return Qc(i.current, g) ? i.current || g : (i.current = g, g);
  }, [r.onFirstUpdate, r.placement, r.strategy, r.modifiers, u]), N = Gt.useRef();
  return Fi(function() {
    N.current && N.current.setOptions(M);
  }, [M]), Fi(function() {
    if (!(e == null || n == null)) {
      var g = a.createPopper || vc, D = g(e, n, M);
      return N.current = D, function() {
        D.destroy(), N.current = null;
      };
    }
  }, [e, n, a.createPopper]), {
    state: N.current ? N.current.state : null,
    styles: c.styles,
    attributes: c.attributes,
    update: N.current ? N.current.update : null,
    forceUpdate: N.current ? N.current.forceUpdate : null
  };
};
function Gc(t, e) {
  if (!Fr)
    return null;
  let n;
  return typeof t == "string" && (n = document.querySelector(t)), typeof t == "function" && (n = t(e)), typeof t == "object" && t instanceof window.HTMLElement && (n = t), n && n.nodeType === 1 ? n : document.body;
}
const Fn = ai((t, e) => {
  const {
    attach: n,
    children: a,
    triggerNode: i,
    className: r,
    style: s = {}
  } = t, c = Ie(() => {
    if (!Fr)
      return null;
    const l = document.createElement("div");
    return l.className = `${Fe}-portal-wrapper ${r}`, Object.keys(s).forEach((u) => {
      l.style[u] = s[u];
    }), l;
  }, [Fe, r]);
  return H(() => {
    var u;
    const l = Gc(n, i);
    return (u = l == null ? void 0 : l.appendChild) == null || u.call(l, c), () => {
      var M;
      (M = l == null ? void 0 : l.removeChild) == null || M.call(l, c);
    };
  }, [c, n, i]), Ko(e, () => c), ts(a, c);
});
Fn.displayName = "Portal";
const Fc = {
  debounceTime: 0,
  config: {
    attributes: !0,
    childList: !0,
    characterData: !0,
    subtree: !0
  }
};
function Zc(t, e, n = Fc) {
  const a = at(null);
  H(() => {
    !e || typeof e != "function" || (a.current = new MutationObserver(e));
  }, [e, n]), H(() => {
    if (!t || !(t != null && t.nodeType))
      return;
    const { config: i } = n;
    try {
      a.current.observe(t, i);
    } catch (r) {
      console.error(r);
    }
    return () => {
      a.current.disconnect();
    };
  }, [t, n]);
}
function Wc(...t) {
  let e = window == null ? void 0 : window.document, n = "", a = () => {
  }, i = {};
  if (typeof t[0] == "string" ? [n, a, i] = t : [e, n, a, i] = t, !!e)
    return e == null || e.addEventListener(n, a, i), () => {
      e == null || e.removeEventListener(n, a, i);
    };
}
function Pc(t, e) {
  let n = () => {
  };
  H(() => (n = Wc("click", (i) => {
    const r = t.map((l) => l == null ? void 0 : l.current), s = i.composedPath(), c = [];
    for (let l = 0; l < r.length; l++)
      c[l] = s.includes(r[l]);
    c.every((l) => !l) && e();
  }, { passive: !0 }), () => {
    n == null || n();
  }), [t, e]);
}
function Hc({
  props: t,
  key: e,
  onChange: n,
  defaultOptions: a
}) {
  const i = Reflect.has(t, e), r = t[e], s = a[e];
  if (i)
    return [r, n || fl];
  const [c, l] = U(s);
  return [
    c,
    (u) => {
      l(u), n == null || n(u);
    }
  ];
}
function Jc({
  trigger: t,
  visible: e,
  disabled: n,
  onVisibleChange: a
}) {
  const i = at(null);
  function r() {
    return n ? {} : {
      onMouseEnter: () => {
        t === "hover" && (clearTimeout(i.current), a(!0));
      },
      onMouseLeave: () => {
        t === "hover" && (clearTimeout(i.current), a(!1));
      }
    };
  }
  function s(l) {
    return n ? {} : {
      onClick: (M) => {
        var N, g;
        t === "click" && a(!e), (g = (N = l.props) == null ? void 0 : N.onClick) == null || g.call(N, M);
      },
      onTouchStart: () => {
        t === "hover" && a(!0);
      },
      onMouseEnter: () => {
        t === "hover" && a(!0);
      },
      onMouseLeave: () => {
        t === "hover" && a(!1);
      }
    };
  }
  function c(l) {
    const u = $o(l) ? l : /* @__PURE__ */ I.jsx("span", { className: "t-trigger", children: l }), M = s(u);
    return Le.cloneElement(u, M);
  }
  return {
    getTriggerNode: c,
    getPopupProps: r
  };
}
const gi = ai((t, e) => {
  const {
    children: n,
    content: a,
    trigger: i = "hover",
    disabled: r = !1,
    teleported: s = !0
  } = t, [c, l] = U(null), [u, M] = U(null), [N, g] = U(null), D = at(null), T = at(), E = at(null), { styles: j } = Yc(c, u, {
    modifiers: [{ name: "arrow", options: { element: N } }],
    placement: "top"
  }), [p, C] = Hc({
    props: t,
    key: "visible",
    onChange: t.onVisibleChange,
    defaultOptions: { visible: !1 }
  });
  Pc([E], () => p && C(!1));
  const {
    getTriggerNode: m,
    getPopupProps: L
  } = Jc({
    trigger: i,
    disabled: r,
    visible: p,
    onVisibleChange: C
  }), S = Qn(() => {
    clearTimeout(T.current), T.current = setTimeout(() => {
      var B;
      return (B = u == null ? void 0 : u.update) == null ? void 0 : B.call(u);
    }, 0);
  }, [u, j]);
  Zc(c, S), H(() => () => clearTimeout(T.current), []);
  const y = Le.cloneElement(m(n), { ref: l }), w = /* @__PURE__ */ I.jsxs("div", { style: { ...j.popper, paddingBottom: "10px" }, ref: M, ...L(), children: [
    /* @__PURE__ */ I.jsx(
      "div",
      {
        ref: D,
        className: x(
          `${Fe}-popup__content`
        ),
        children: a
      }
    ),
    /* @__PURE__ */ I.jsx("div", { ref: N, style: j.arrow, className: `${Fe}-popup__arrow` })
  ] }), b = s ? /* @__PURE__ */ I.jsx(Fn, { children: w }) : w;
  return /* @__PURE__ */ I.jsxs("div", { ref: E, children: [
    y,
    p && b
  ] });
}), Da = (t) => {
  const [e, n] = U([]), [a, i] = U(), r = (c) => {
    var l, u, M;
    switch (t) {
      case pe.CAMERA:
        n((c == null ? void 0 : c.cameraList) || []), i(((l = c == null ? void 0 : c.currentCamera) == null ? void 0 : l.deviceId) || "");
        break;
      case pe.MICROPHONE:
        i(((u = c == null ? void 0 : c.currentMicrophone) == null ? void 0 : u.deviceId) || ""), n((c == null ? void 0 : c.microphoneList) || []);
        break;
      case pe.SPEAKER:
        i(((M = c == null ? void 0 : c.currentSpeaker) == null ? void 0 : M.deviceId) || ""), n((c == null ? void 0 : c.speakerList) || []);
        break;
    }
  }, s = {
    [o.DEVICE_LIST]: r
  };
  return H(() => (f.watch(
    d.CALL,
    s,
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), () => {
    f.unwatch(
      d.CALL,
      s
    );
  }), []), [{ deviceList: e, currentDeviceId: a }, { setCurrentDeviceId: i }];
}, Xc = "_btn_caues_24", Kc = "_select_caues_31", ht = {
  "device-selector-container": "_device-selector-container_caues_1",
  "device-item": "_device-item_caues_9",
  "control-item": "_control-item_caues_20",
  btn: Xc,
  select: Kc,
  "scroll-container": "_scroll-container_caues_36",
  "scroll-content": "_scroll-content_caues_41"
};
function Di(t) {
  const { deviceType: e, isShowControlBtn: n = !0 } = t, { localUserInfo: a } = Q(ke), { isMuteSpeaker: i } = Q(re), [{ deviceList: r, currentDeviceId: s }, { setCurrentDeviceId: c }] = Da(e), l = x([
    ht["device-item"],
    ht["control-item"]
  ]), u = async (D) => {
    try {
      await X.switchDevice({
        deviceType: e,
        deviceId: D
      }), c(D);
    } catch (T) {
      console.debug(T);
    }
  }, M = async () => {
    e === pe.CAMERA && (a != null && a.isVideoAvailable ? await X.closeCamera() : await X.openCamera("localVideo")), e === pe.MICROPHONE && (a != null && a.isAudioAvailable ? await X.closeMicrophone() : await X.openMicrophone()), e === pe.SPEAKER && (i ? await X.unMuteSpeaker() : await X.muteSpeaker());
  }, N = () => {
    if (e === pe.CAMERA)
      return a != null && a.isVideoAvailable ? k("close camera") : k("open camera");
    if (e === pe.MICROPHONE)
      return a != null && a.isAudioAvailable ? k("close microphone") : k("open microphone");
    if (e === pe.SPEAKER)
      return k(i ? "open speaker" : "close speaker");
  };
  function g() {
    return (r == null ? void 0 : r.length) > 0 ? r == null ? void 0 : r.map((D) => {
      const { deviceId: T, label: E } = D;
      return /* @__PURE__ */ I.jsx(
        "div",
        {
          className: x([
            ht["device-item"],
            { [ht.select]: s === T }
          ]),
          onClick: () => u(T),
          children: E
        },
        T
      );
    }) : /* @__PURE__ */ I.jsx("div", { className: ht["device-item"], children: k("failed to obtain speakers") });
  }
  return /* @__PURE__ */ I.jsxs("div", { className: ht["device-selector-container"], children: [
    /* @__PURE__ */ I.jsx("div", { className: ht["scroll-container"], children: /* @__PURE__ */ I.jsx("div", { className: ht["scroll-content"], children: g() }) }),
    n && /* @__PURE__ */ I.jsx("div", { onClick: M, className: l, children: N() })
  ] });
}
const $c = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDE1LjYyNVYxMy43NUg2VjE1LjYyNUM2IDIwLjU5NTYgMTAuMDI5NCAyNC42MjUgMTUgMjQuNjI1QzE5Ljk3MDYgMjQuNjI1IDI0IDIwLjU5NTYgMjQgMTUuNjI1VjEzLjc1SDI2VjE1LjYyNUMyNiAyMS4zNjMgMjEuNjA2NSAyNi4wNzQ5IDE2IDI2LjU4MDJWMzBIMTRWMjYuNTgwMkM4LjM5MzUgMjYuMDc0OSA0IDIxLjM2MyA0IDE1LjYyNVoiIGZpbGw9IiMyMjI2MkUiLz4KPHJlY3QgeD0iOC43NSIgeT0iMS4yNSIgd2lkdGg9IjEyLjUiIGhlaWdodD0iMjAuNjI1IiByeD0iNi4yNSIgZmlsbD0iIzIyMjYyRSIvPgo8L3N2Zz4K", qc = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljc1IDcuNUM4Ljc1IDQuMDQ4MjIgMTEuNTQ4MiAxLjI1IDE1IDEuMjVDMTYuOTc1OCAxLjI1IDE4LjczNzYgMi4xNjY4NiAxOS44ODI5IDMuNTk4MzRMOC44NzI0OCAxNi44NjI0QzguNzkyMTUgMTYuNDYyNCA4Ljc1IDE2LjA0ODYgOC43NSAxNS42MjVWNy41Wk02LjgwNTY3IDE5LjM1MjNDNi4yODgyNSAxOC4yMTY2IDYgMTYuOTU0NCA2IDE1LjYyNVYxMy43NUg0VjE1LjYyNUM0IDE3LjU4ODIgNC41MTQzMSAxOS40MzEzIDUuNDE1NTUgMjEuMDI2OUw2LjgwNTY3IDE5LjM1MjNaTTkuMjExNzcgMjQuOTgwN0wxMC41MDQ0IDIzLjQyMzVDMTEuODI3MiAyNC4xODc3IDEzLjM2MjUgMjQuNjI1IDE1IDI0LjYyNUMxOS45NzA2IDI0LjYyNSAyNCAyMC41OTU2IDI0IDE1LjYyNVYxMy43NUgyNlYxNS42MjVDMjYgMjEuMzYzIDIxLjYwNjUgMjYuMDc0OSAxNiAyNi41ODAyVjMwSDE0VjI2LjU4MDJDMTIuMjU0MyAyNi40MjI4IDEwLjYyNjIgMjUuODU3NyA5LjIxMTc3IDI0Ljk4MDdaTTEyLjI5ODMgMjEuMjYyNUwyMS4yNSAxMC40Nzg0VjE1LjYyNUMyMS4yNSAxOS4wNzY4IDE4LjQ1MTggMjEuODc1IDE1IDIxLjg3NUMxNC4wMzIzIDIxLjg3NSAxMy4xMTYgMjEuNjU1MSAxMi4yOTgzIDIxLjI2MjVaIiBmaWxsPSJ3aGl0ZSIgc3R5bGU9ImZpbGw6d2hpdGU7ZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTsiLz4KPHBhdGggZD0iTTYuNDE4OTUgMjQuMDg0TDIyLjA5MzkgNS4yMDkzOCIgc3Ryb2tlPSJ3aGl0ZSIgc3R5bGU9InN0cm9rZTp3aGl0ZTtzdHJva2U6d2hpdGU7c3Ryb2tlLW9wYWNpdHk6MTsiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
function Oe(t) {
  const { localUserInfo: e } = Q(ke), n = Ie(() => e == null ? void 0 : e.isAudioAvailable, [e]), [{ deviceList: a }] = Da(pe.MICROPHONE), [i, r] = U(!0), s = Qn(
    async () => {
      r(!1), n ? await X.closeMicrophone() : await X.openMicrophone(), r(!0);
    },
    [n, r]
  ), c = x([
    ce["btn-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC,
      close: !n,
      disabled: !i
    }
  ]), l = k(n ? "microphone enabled" : "microphone disabled"), u = /* @__PURE__ */ I.jsx(ie, { className: ce["btn-icon"], url: n ? $c : qc });
  return /* @__PURE__ */ I.jsx(
    gi,
    {
      content: /* @__PURE__ */ I.jsx(Di, { deviceType: pe.MICROPHONE }),
      disabled: !z.isPC || !((a == null ? void 0 : a.length) > 0),
      teleported: !1,
      children: /* @__PURE__ */ I.jsx("div", { style: { display: "flex" }, children: /* @__PURE__ */ I.jsx(
        Pe,
        {
          className: ce[`${Fe}-btn`],
          iconClassName: c,
          icon: u,
          loading: !i,
          onClick: s,
          ...t,
          children: l
        }
      ) })
    }
  );
}
const eu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguOTE2NSA4LjE5OTc4SDkuNzY2NVY3LjM0OTc4VjUuNjQ5NzhWNC43OTk3OEg4LjkxNjVINC44MzMxN0gzLjk4MzE3VjUuNjQ5NzhWNy4zNDk3OFY4LjE5OTc4SDQuODMzMTdIOC45MTY1Wk0xLjAxNjUgMS42NjY2MkMxLjAxNjUgMS41ODM3OCAxLjA4MzY2IDEuNTE2NjMgMS4xNjY1IDEuNTE2NjNIMTcuODMzMkMxNy45MTYgMS41MTY2MyAxNy45ODMyIDEuNTgzNzggMTcuOTgzMiAxLjY2NjYzVjE4LjMzMzNDMTcuOTgzMiAxOC40MTYxIDE3LjkxNiAxOC40ODMzIDE3LjgzMzIgMTguNDgzM0gxLjE2NjVDMS4wODM2NiAxOC40ODMzIDEuMDE2NSAxOC40MTYxIDEuMDE2NSAxOC4zMzMzVjEuNjY2NjJaTTIxLjIxNDMgNS4wMjIyNEMyMS4yMTQzIDQuOTYzOTYgMjEuMjQ4IDQuOTEwOTYgMjEuMzAwOCA0Ljg4NjMxTDI0Ljc2OTYgMy4yNjc1NkMyNC44NjkgMy4yMjExNSAyNC45ODMgMy4yOTM3NSAyNC45ODMgMy40MDM0OUwyNC45ODMgMTYuNTk2NEMyNC45ODMgMTYuNzA2MiAyNC44NjkgMTYuNzc4OCAyNC43Njk2IDE2LjczMjRMMjEuMzAwOCAxNS4xMTM2QzIxLjI0OCAxNS4wODkgMjEuMjE0MyAxNS4wMzYgMjEuMjE0MyAxNC45Nzc3TDIxLjIxNDMgNS4wMjIyNFoiIGZpbGw9IiMyMjI2MkUiIHN0cm9rZT0iIzIyMjYyRSIgc3Ryb2tlLXdpZHRoPSIxLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K", tu = "data:image/svg+xml;base64,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";
function nt(t) {
  const { localUserInfo: e } = Q(ke), n = Ie(
    () => e == null ? void 0 : e.isVideoAvailable,
    [e == null ? void 0 : e.isVideoAvailable]
  ), [a, i] = U(!0), [{ deviceList: r }] = Da(pe.CAMERA), s = Qn(
    async () => {
      i(!1), n ? await X.closeCamera() : await X.openCamera("localVideo"), i(!0);
    },
    [n]
  ), c = x([
    ce["btn-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC,
      close: !n,
      disabled: !a
    }
  ]), l = /* @__PURE__ */ I.jsx(ie, { url: n ? eu : tu, className: ce["btn-icon"] }), u = k(n ? "camera enabled" : "camera disabled");
  return /* @__PURE__ */ I.jsx(
    gi,
    {
      content: /* @__PURE__ */ I.jsx(Di, { deviceType: pe.CAMERA }),
      disabled: !z.isPC || !((r == null ? void 0 : r.length) > 0),
      teleported: !1,
      children: /* @__PURE__ */ I.jsx("div", { style: { display: "flex" }, children: /* @__PURE__ */ I.jsx(
        Pe,
        {
          className: ce[`${Fe}-btn`],
          iconClassName: c,
          icon: l,
          loading: !a,
          onClick: s,
          ...t,
          children: u
        }
      ) })
    }
  );
}
const nu = {
  "hangup-icon-container": "_hangup-icon-container_1o1xr_1"
};
function Ee(t) {
  const e = Q(Gr), n = () => X.hangup(), a = x([
    ce["btn-icon-container"],
    nu["hangup-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC
    }
  ]), i = /* @__PURE__ */ I.jsx(ie, { className: ce["btn-icon"], url: Wr });
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      loading: !e,
      className: ce[`${Fe}-btn`],
      iconClassName: a,
      icon: i,
      onClick: n,
      ...t,
      children: k("hangup")
    }
  );
}
const au = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS4xMzUxIDIuMzcyODZMMjIuMDAwNyAyLjg3MzU5QzI2LjE4MjcgNS4yOTI3NSAyOSA5LjgxNjc5IDI5IDE1QzI5IDIwLjE4MzMgMjYuMTgyNyAyNC43MDczIDIyLjAwMDcgMjcuMTI2NUwyMS4xMzUxIDI3LjYyNzJMMjAuMTMzNiAyNS44OTZMMjAuOTk5MiAyNS4zOTUzQzI0LjU4ODcgMjMuMzE4OSAyNyAxOS40NDA1IDI3IDE1QzI3IDEwLjU1OTYgMjQuNTg4NyA2LjY4MTE3IDIwLjk5OTIgNC42MDQ4TDIwLjEzMzYgNC4xMDQwOEwyMS4xMzUxIDIuMzcyODZaTTE0LjY0NDggMy4zODg5M0MxNS4zNTE3IDIuODYzMjcgMTYuMzU1NiAzLjM2Nzc5IDE2LjM1NTYgNC4yNDg2OVYyNS43NTE0QzE2LjM1NTYgMjYuNjMyMyAxNS4zNTE3IDI3LjEzNjggMTQuNjQ0OCAyNi42MTExTDcuOTk1NyAyMS42NjY1QzcuODEwODcgMjEuNTI5IDcuNTg2NjcgMjEuNDU0OCA3LjM1NjM0IDIxLjQ1NDhIMi4yNTE2QzEuNjU5ODcgMjEuNDU0OCAxLjE4MDE4IDIwLjk3NTEgMS4xODAxOCAyMC4zODM0VjkuNjM0MTFDMS4xODAxOCA5LjA0MzcxIDEuNjU3NzkgOC41NjQ1NyAyLjI0ODE5IDguNTYyNjlMNy4zNTgyNCA4LjU0NjM5QzcuNTg3NCA4LjU0NTY2IDcuODEwMjkgOC40NzE0NyA3Ljk5NDE4IDguMzM0NzJMMTQuNjQ0OCAzLjM4ODkzWk0yMC41NTUzIDguMTY4NEwxOS43MjM3IDcuNjEzMDRMMTguNjEzIDkuMjc2MjZMMTkuNDQ0NiA5LjgzMTYyQzIwLjkzNjggMTAuODI4MSAyMiAxMi43NDExIDIyIDE1QzIyIDE3LjI1ODkgMjAuOTM2OCAxOS4xNzE5IDE5LjQ0NDYgMjAuMTY4NEwxOC42MTMgMjAuNzIzOEwxOS43MjM3IDIyLjM4N0wyMC41NTUzIDIxLjgzMTZDMjIuNjQ5OSAyMC40MzI4IDI0IDE3Ljg2ODggMjQgMTVDMjQgMTIuMTMxMiAyMi42NDk5IDkuNTY3MTcgMjAuNTU1MyA4LjE2ODRaIiBmaWxsPSIjMkUzMzNEIi8+Cjwvc3ZnPgo=", iu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4zNjAyIDIyLjg0MTZMMTQuNTk0NiAyNi40MDI1QzE1LjI5MTYgMjYuOTg4NiAxNi4zNTU2IDI2LjQ5MzEgMTYuMzU1NiAyNS41ODI1VjE1LjYxOUwxMC4zNjAyIDIyLjg0MTZaTTIzLjcxNjIgNi43NTE4N0wyNS4wMDEzIDUuMjAzNjRDMjcuNDc0MSA3LjcyNzkxIDI5IDExLjE4NTUgMjkgMTVDMjkgMjAuMTgzMyAyNi4xODI3IDI0LjcwNzMgMjIuMDAwNyAyNy4xMjY1TDIxLjEzNTEgMjcuNjI3MkwyMC4xMzM3IDI1Ljg5NkwyMC45OTkzIDI1LjM5NTNDMjQuNTg4NyAyMy4zMTg5IDI3IDE5LjQ0MDUgMjcgMTVDMjcgMTEuODA2IDI1Ljc1MjQgOC45MDI4MiAyMy43MTYyIDYuNzUxODdaTTIwLjQzNzcgMTAuNzAxNEwyMS43MjYyIDkuMTQ5MTdDMjMuMTM5MyAxMC42MTMyIDI0IDEyLjcwOTQgMjQgMTVDMjQgMTcuODY4OSAyMi42NDk5IDIwLjQzMjkgMjAuNTU1NCAyMS44MzE2TDE5LjcyMzcgMjIuMzg3TDE4LjYxMyAyMC43MjM4TDE5LjQ0NDYgMjAuMTY4NEMyMC45MzY5IDE5LjE3MTkgMjIgMTcuMjU4OSAyMiAxNUMyMiAxMy4yODQyIDIxLjM4NjYgMTEuNzY4IDIwLjQzNzcgMTAuNzAxNFpNMTYuMzU1NiA2LjQ4Mjg4TDMuOTI3NTYgMjEuNDU0OEgyLjI1MTY0QzEuNjU5OSAyMS40NTQ4IDEuMTgwMjEgMjAuOTc1MSAxLjE4MDIxIDIwLjM4MzRWOS42MzQ1OUMxLjE4MDIxIDkuMDQ0MDEgMS42NTgxIDguNTY0NzkgMi4yNDg2NyA4LjU2MzE2TDguMzIyMTUgOC41NDYzNkM4LjU3MzQyIDguNTQ1NjcgOC44MTY0NiA4LjQ1NjY4IDkuMDA4NzcgOC4yOTQ5NkwxNC41OTQ2IDMuNTk3NjFDMTUuMjkxNiAzLjAxMTUxIDE2LjM1NTYgMy41MDY5OSAxNi4zNTU2IDQuNDE3NjNWNi40ODI4OFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00LjU2MzcyIDI1LjI2ODNMMjIuMTQwNyA0LjA4MzY1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
function yt(t) {
  const [{ deviceList: e, currentDeviceId: n }] = Da(pe.SPEAKER), { isMuteSpeaker: a } = Q(re), i = (l) => {
    if (z.isPC) {
      const u = e.find((M) => M.deviceId === l);
      return u ? u.label : k("speaker enabled");
    } else
      return k(a ? "speaker disabled" : "speaker enabled");
  }, r = Qn(
    () => {
      a ? X.unMuteSpeaker() : X.muteSpeaker();
    },
    [a]
  ), s = /* @__PURE__ */ I.jsx(ie, { url: a ? iu : au, className: ce["btn-icon"] }), c = x([
    ce["btn-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC,
      close: a
    }
  ]);
  return /* @__PURE__ */ I.jsx(
    gi,
    {
      trigger: z.isPC ? "hover" : "click",
      disabled: !(e.length > 0 && z.isPC),
      content: /* @__PURE__ */ I.jsx(Di, { deviceType: pe.SPEAKER }),
      teleported: !1,
      children: /* @__PURE__ */ I.jsx("div", { style: { display: "flex" }, children: /* @__PURE__ */ I.jsx(
        Pe,
        {
          className: ce[`${Fe}-btn`],
          iconClassName: c,
          icon: s,
          onClick: r,
          ...t,
          children: i(n)
        }
      ) })
    }
  );
}
const no = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS4wMTg0IDUuNzYzMzZDMjYuMTIyOSA1Ljc2MzM2IDI3LjAxODQgNi42NTg3OSAyNy4wMTg0IDcuNzYzMzZWMjMuMjkwOUMyNy4wMTg0IDI0LjM5NTUgMjYuMTIyOSAyNS4yOTA5IDI1LjAxODQgMjUuMjkwOUgyLjk4MTYzQzEuODc3MDYgMjUuMjkwOSAwLjk4MTYyOCAyNC4zOTU1IDAuOTgxNjI4IDIzLjI5MDlWNy43NjMzNkMwLjk4MTYyOCA2LjY1ODc5IDEuODc3MDYgNS43NjMzNiAyLjk4MTYzIDUuNzYzMzZINy4yNDM2QzcuODE0ODggNS43NjMzNiA4LjM1ODg4IDUuNTE5MDcgOC43Mzg0MiA1LjA5MjA5TDEwLjE0ODcgMy41MDU1QzEwLjUyODMgMy4wNzg1MiAxMS4wNzIzIDIuODM0MjMgMTEuNjQzNSAyLjgzNDIzSDE0SDE2LjM1NjVDMTYuOTI3NyAyLjgzNDIzIDE3LjQ3MTcgMy4wNzg1MiAxNy44NTEzIDMuNTA1NUwxOS4yNjE2IDUuMDkyMDlDMTkuNjQxMSA1LjUxOTA3IDIwLjE4NTEgNS43NjMzNiAyMC43NTY0IDUuNzYzMzZIMjUuMDE4NFpNMTEuNzIyOSA5LjU4NDk1QzEyLjM5OTQgOS4zMTYwMiAxMy4xMzc3IDkuMTY4NDYgMTMuOTA5MSA5LjE2ODQ2QzE1LjYyNzcgOS4xNjg0NiAxNy4xNzg4IDkuOTAxMzIgMTguMjUgMTEuMDcxVjkuOTE4NDZIMTkuNzVWMTQuOTEzOEwxOS43NSAxNC45MTg1SDE4LjI1TDE4LjI1IDE0LjkxNDRDMTguMjQ3OCAxMi41ODE3IDE2LjMxNzkgMTAuNjY4NSAxMy45MDkxIDEwLjY2ODVDMTMuMzMwMiAxMC42Njg1IDEyLjc3OTcgMTAuNzc5IDEyLjI3NzEgMTAuOTc4OEwxMS43MjI5IDkuNTg0OTVaTTguMjUgMTkuOTE4NVYxNC45MTg1SDkuNzVDOS43NSAxNy4yNTMgMTEuNjgwNyAxOS4xNjg1IDE0LjA5MDkgMTkuMTY4NUMxNC42Njk4IDE5LjE2ODUgMTUuMjIwMyAxOS4wNTc5IDE1LjcyMjkgMTguODU4MUwxNi4yNzcxIDIwLjI1MkMxNS42MDA2IDIwLjUyMDkgMTQuODYyMyAyMC42Njg1IDE0LjA5MDkgMjAuNjY4NUMxMi4zNzIzIDIwLjY2ODUgMTAuODIxMiAxOS45MzU2IDkuNzUgMTguNzY2VjE5LjkxODVIOC4yNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
function ru(t) {
  const e = () => X.switchCamera(), n = /* @__PURE__ */ I.jsx(ie, { url: no });
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      style: { width: "28px", height: "28px" },
      iconSize: "28px",
      icon: n,
      onClick: e,
      ...t
    }
  );
}
const ou = "data:image/svg+xml;base64,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", su = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDFDMCAwLjQ0NzcxNiAwLjQ0NzcxNSAwIDEgMEgyNUMyNS41NTIzIDAgMjYgMC40NDc3MTUgMjYgMVYyNUMyNiAyNS41NTIzIDI1LjU1MjMgMjYgMjUgMjZIMUMwLjQ0NzcxNiAyNiAwIDI1LjU1MjMgMCAyNVYxWk0xMyAxNEMxNS4zMDc4IDE0IDE3LjE3ODYgMTIuMTI5MiAxNy4xNzg2IDkuODIxNDNDMTcuMTc4NiA3LjUxMzY3IDE1LjMwNzggNS42NDI4NiAxMyA1LjY0Mjg2QzEwLjY5MjIgNS42NDI4NiA4LjgyMTQzIDcuNTEzNjcgOC44MjE0MyA5LjgyMTQzQzguODIxNDMgMTIuMTI5MiAxMC42OTIyIDE0IDEzIDE0Wk0xMS4xNDI5IDE1LjM0NTlDOC4wNjU4NCAxNS4zNDU5IDUuNTcxNDMgMTcuODQwMyA1LjU3MTQzIDIwLjkxNzRWMjMuMTY3NEM1LjU3MTQzIDIzLjcxOTYgNi4wMTkxNCAyNC4xNjc0IDYuNTcxNDMgMjQuMTY3NEgxOS40Mjg2QzE5Ljk4MDkgMjQuMTY3NCAyMC40Mjg2IDIzLjcxOTYgMjAuNDI4NiAyMy4xNjc0VjIwLjkxNzRDMjAuNDI4NiAxNy44NDAzIDE3LjkzNDIgMTUuMzQ1OSAxNC44NTcxIDE1LjM0NTlMMTMgMTguMDE5M0wxMS4xNDI5IDE1LjM0NTlaTTEuMzkyODYgOC4wMzU1M0w4LjAzNTUzIDEuMzkyODZIMTAuMjY4TDEuMzkyODYgMTAuMjY4VjguMDM1NTNaTTEuMzkyODYgMjAuMjY4VjE4LjAzNTVMOC4wMzQ2NiAxMS4zOTM3TDkuMTUwODggMTIuNTA5OUwxLjM5Mjg2IDIwLjI2OFpNMjQuNjA3MSAxNC44MjEyVjE3LjA1MzdMMjIuMTM0IDE5LjUyNjlMMjEuMDE3NyAxOC40MTA2TDI0LjYwNzEgMTQuODIxMlpNMjQuNjA3MSA0LjgyMTI5VjcuMDUzNzNMMTcuNTE0OSAxNC4xNDZMMTYuMzk4NyAxMy4wMjk4TDI0LjYwNzEgNC44MjEyOVpNMjAuMjY4IDEuMzkyODZMMTYuMzcyNiA1LjI4ODIxTDE1LjI1NjQgNC4xNzE5OUwxOC4wMzU1IDEuMzkyODZIMjAuMjY4WiIgZmlsbD0iIzIyMjYyRSIvPgo8L3N2Zz4K", lu = "_close_12dh2_4", cu = {
  "background-blur-icon-container": "_background-blur-icon-container_12dh2_1",
  close: lu
};
function on() {
  const { enableVirtualBackground: t } = Q(re), [e, n] = U(!0), a = /* @__PURE__ */ I.jsx(ie, { url: t ? su : ou, className: ce["btn-icon"] }), i = x([
    ce["btn-icon-container"],
    cu["background-blur-icon-container"],
    {
      mobile: !z.isPC,
      pc: z.isPC,
      close: !t
    }
  ]), r = async () => {
    n(!1), await X.setBlurBackground(!t), n(!0);
  };
  return /* @__PURE__ */ I.jsx(
    Pe,
    {
      loading: !e,
      className: ce[`${Fe}-btn`],
      iconClassName: i,
      icon: a,
      onClick: r,
      children: k("virtual-background")
    }
  );
}
const uu = {
  singleCall: {
    video: {
      calling: [
        [
          {
            component: nt,
            name: "camera",
            props: {}
          },
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee
          }
        ]
      ],
      accept: [
        [
          {
            component: nt,
            name: "camera",
            props: {}
          },
          {
            component: St,
            name: ""
          },
          {
            component: mt,
            name: ""
          }
        ]
      ],
      connected: [
        [
          {
            component: nt,
            name: "camera",
            props: {}
          },
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ]
    },
    audio: {
      calling: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: ""
          },
          {
            component: mt,
            name: ""
          }
        ]
      ],
      connected: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ]
    }
  },
  groupCall: {
    video: {
      calling: [
        [
          {
            component: nt,
            name: "camera",
            props: {}
          },
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: ""
          },
          {
            component: mt,
            name: ""
          }
        ]
      ],
      connected: [
        [
          {
            component: nt,
            name: "camera",
            props: {}
          },
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ]
    },
    audio: {
      calling: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: ""
          },
          {
            component: mt,
            name: ""
          }
        ]
      ],
      connected: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee,
            name: ""
          }
        ]
      ]
    }
  }
}, Mu = {
  singleCall: {
    video: {
      calling: [
        [
          {
            component: Ee,
            props: {
              showText: !1
            }
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: "",
            props: {
              showText: !1
            }
          },
          {
            component: mt,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ],
      connected: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: nt,
            name: "camera",
            props: {}
          }
        ],
        [
          {
            component: on,
            name: "backgroundBlur",
            props: {
              style: {
                justifyContent: "center",
                alignItems: "center",
                visibility: "hidden"
              }
            }
          },
          {
            component: Ee,
            name: "",
            props: {
              showText: !1
            }
          },
          {
            component: ru,
            name: "switchCamera",
            props: {
              style: {
                justifyContent: "center",
                alignItems: "center"
              }
            }
          }
        ]
      ]
    },
    audio: {
      calling: [
        [
          {
            component: Ee,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: ""
          },
          {
            component: mt,
            name: ""
          }
        ]
      ],
      connected: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: Ee,
            name: ""
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          }
        ]
      ]
    }
  },
  groupCall: {
    video: {
      calling: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: nt,
            name: "camera",
            props: {}
          }
        ],
        [
          {
            component: Ee,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: "",
            props: {
              showText: !1
            }
          },
          {
            component: mt,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ],
      connected: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: nt,
            name: "camera",
            props: {}
          }
        ],
        [
          {
            component: Ee,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ]
    },
    audio: {
      calling: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: nt,
            name: "camera",
            props: {}
          }
        ],
        [
          {
            component: Ee,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ],
      accept: [
        [
          {
            component: St,
            name: "",
            props: {
              showText: !1
            }
          },
          {
            component: mt,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ],
      connected: [
        [
          {
            component: Oe,
            name: "microphone",
            props: {}
          },
          {
            component: yt,
            name: "speaker",
            props: {}
          },
          {
            component: nt,
            name: "camera",
            props: {}
          }
        ],
        [
          {
            component: Ee,
            name: "",
            props: {
              showText: !1
            }
          }
        ]
      ]
    }
  }
}, Ha = {
  pc: uu,
  h5: Mu
}, Iu = 500;
function Ti(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError("Expected a function");
  const n = (...a) => {
    const i = e ? e.apply(this, a) : a[0], { cache: r } = n;
    if (r.has(i))
      return r.get(i);
    const s = t.apply(this, a);
    return n.cache = r.set(i, s) || r, s;
  };
  return n.cache = new (Ti.Cache || Map)(), n;
}
Ti.Cache = Map;
function Au(t) {
  const e = Ti(t, (n) => {
    const { cache: a } = e;
    return a.size === Iu && a.clear(), n;
  });
  return e;
}
const du = ".".charCodeAt(0), Nu = /\\(\\)?/g, gu = RegExp(
  // Match anything that isn't a dot or bracket.
  `[^.[\\]]+|\\[(?:([^"'][^[]*)|(["'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))`,
  "g"
), ao = Au((t) => {
  const e = [];
  return t.charCodeAt(0) === du && e.push(""), t.replace(gu, (n, a, i, r) => {
    let s = n;
    i ? s = r.replace(Nu, "$1") : a && (s = a.trim()), e.push(s);
  }), e;
});
function Du(t) {
  return t == null || typeof t == "string" && t.trim().length === 0 ? !0 : Array.isArray(t) || typeof t == "object" ? Object.keys(t).length === 0 : !1;
}
function Ja(t, e, n, a, i) {
  Object.keys(t).forEach((r) => {
    const s = t[r], c = Du(n) ? r : `${n}.${r}`;
    if (typeof s == "object")
      if (Array.isArray(s))
        for (let l = 0; l < s.length; l++) {
          const u = `${c}[${l}]`;
          Ja(s[l], e, u, a, i);
        }
      else
        Ja(s, e, c, a, i);
    else if (e(s)) {
      const l = typeof i == "function" ? i({ key: s, value: c }) : c;
      a.push(l);
    }
  });
}
function zn(t) {
  if (typeof t != "object" || t === null)
    return t;
  const e = Array.isArray(t) ? [] : {};
  return Object.keys(t).forEach((n) => {
    e[n] = zn(t[n]);
  }), e;
}
function io(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  if (e in t) {
    const n = zn(t);
    return delete n[e], n;
  }
}
const Tu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjUiIGN4PSIxNSIgY3k9IjE1IiByPSIxNSIgZmlsbD0iIzIyMjYyRSIgc3R5bGU9ImZpbGw6IzIyMjYyRTtmaWxsOmNvbG9yKGRpc3BsYXktcDMgMC4xMzMzIDAuMTQ5MCAwLjE4MDQpO2ZpbGwtb3BhY2l0eToxOyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwLjUxNiAxNy40NTE2QzIwLjY2ODIgMTcuNjExOCAyMC42NjE3IDE3Ljg2NSAyMC41MDE1IDE4LjAxNzFMMTkuNjMxNSAxOC44NDM2QzE5LjQ3MTMgMTguOTk1OCAxOS4yMTgyIDE4Ljk4OTMgMTkuMDY2IDE4LjgyOTFMMTQuOTk5OSAxNC41NDlMMTAuOTMzOSAxOC44MjkxQzEwLjc4MTggMTguOTg5MyAxMC41Mjg2IDE4Ljk5NTggMTAuMzY4NCAxOC44NDM2TDkuNDk4NDIgMTguMDE3MkM5LjMzODI2IDE3Ljg2NSA5LjMzMTc2IDE3LjYxMTggOS40ODM5MSAxNy40NTE3TDE0LjUxNjUgMTIuMTUzOUMxNC43NzkzIDExLjg3NzMgMTUuMjIwMyAxMS44NzcyIDE1LjQ4MzIgMTIuMTUzOUwyMC41MTYgMTcuNDUxNloiIGZpbGw9IndoaXRlIiBzdHlsZT0iZmlsbDp3aGl0ZTtmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eToxOyIvPgo8L3N2Zz4K", Eu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjUiIGN4PSIxNSIgY3k9IjE1IiByPSIxNSIgZmlsbD0iIzIyMjYyRSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNDgzNzUgMTQuMzEzM0M5LjMzMTYgMTQuMTUzMSA5LjMzODA5IDEzLjg5OTkgOS40OTgyNSAxMy43NDc4TDEwLjM2ODMgMTIuOTIxM0MxMC41Mjg0IDEyLjc2OTEgMTAuNzgxNiAxMi43NzU2IDEwLjkzMzggMTIuOTM1OEwxNC45OTk5IDE3LjIxNTlMMTkuMDY1OCAxMi45MzU4QzE5LjIxOCAxMi43NzU2IDE5LjQ3MTEgMTIuNzY5MSAxOS42MzEzIDEyLjkyMTNMMjAuNTAxMyAxMy43NDc3QzIwLjY2MTUgMTMuODk5OSAyMC42NjggMTQuMTUzMSAyMC41MTU4IDE0LjMxMzJMMTUuNDgzMyAxOS42MTFDMTUuMjIwNCAxOS44ODc2IDE0Ljc3OTQgMTkuODg3NiAxNC41MTY2IDE5LjYxMUw5LjQ4Mzc1IDE0LjMxMzNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", fu = "_groupcall_1a79k_16", pu = "_open_1a79k_22", ju = "_close_1a79k_36", ut = {
  "button-panel-h5-container": "_button-panel-h5-container_1a79k_1",
  groupcall: fu,
  "show-panel-background": "_show-panel-background_1a79k_19",
  open: pu,
  "singlecall-panel": "_singlecall-panel_1a79k_25",
  "groupcall-panel": "_groupcall-panel_1a79k_31",
  close: ju,
  "toggle-panel-btn": "_toggle-panel-btn_1a79k_40"
};
function hu(t) {
  const { buttons: e = [] } = t, { isGroupCall: n } = Q(re), { focusItem: a } = Q(si), [i, r] = U(!0);
  H(() => {
    r(a === null);
  }, [a, r]);
  const [s, c] = U(!1);
  H(() => {
    a !== null && !s && c(!0);
  }, [a, s]);
  const l = x([
    ut["button-panel-h5-container"],
    {
      [ut.open]: i,
      [ut.groupcall]: n,
      [ut["show-panel-background"]]: s
    }
  ]), u = () => e.map((T, E) => {
    const j = E === 0 ? T.filter((C) => {
      var m;
      return ((m = C == null ? void 0 : C.props) == null ? void 0 : m.show) !== !1;
    }) : T, p = () => j.map((C, m) => {
      const L = j.length > 2 ? m === 0 ? "start" : m === j.length - 1 ? "end" : "center" : "center", { component: S, props: y } = C, w = {};
      if ((y == null ? void 0 : y.show) === !1) {
        if (E === 0)
          return;
        w.visibility = "hidden";
      }
      const b = 12 / j.length, B = io(y, "show"), F = Le.createElement(S, { isMobile: !0, ...B });
      return /* @__PURE__ */ I.jsx(
        ve,
        {
          style: { overflow: "visible", ...y == null ? void 0 : y.style, ...w },
          span: b,
          justify: L,
          children: F
        },
        `col-${m}`
      );
    });
    return /* @__PURE__ */ I.jsx(
      Ht,
      {
        style: { marginTop: E === 1 ? "2.4vh" : 0 },
        children: p()
      },
      `row-${E}`
    );
  }), M = () => {
    r(!i);
  }, N = () => {
    const T = i ? /* @__PURE__ */ I.jsx(ie, { url: Eu }) : /* @__PURE__ */ I.jsx(ie, { url: Tu });
    return /* @__PURE__ */ I.jsx(
      Pe,
      {
        className: x([
          ut["toggle-panel-btn"],
          { [ut.close]: !i }
        ]),
        icon: T,
        onClick: M
      }
    );
  }, g = () => {
    const T = e.flat(), E = () => T.map((j, p) => {
      const { component: C, props: m } = j;
      if ((m == null ? void 0 : m.show) === !1)
        return;
      const L = Le.createElement(C, { isMobile: !0, size: "small", showText: !1 }), S = 12 / T.length;
      return /* @__PURE__ */ I.jsx(
        ve,
        {
          style: { overflow: "visible" },
          span: S,
          children: L
        },
        p
      );
    });
    return /* @__PURE__ */ I.jsx(Ht, { children: E() });
  }, D = () => n && !i ? g() : u();
  return /* @__PURE__ */ I.jsxs("div", { className: l, children: [
    s && N(),
    /* @__PURE__ */ I.jsx(
      "div",
      {
        className: x([
          {
            [ut["groupcall-panel"]]: n,
            [ut["singlecall-panel"]]: !n,
            [ut.close]: !i
          }
        ]),
        children: D()
      }
    )
  ] });
}
const Cu = {
  "button-panel-pc-container": "_button-panel-pc-container_x4npp_1"
};
function Lu(t) {
  const { buttons: e = [] } = t, n = () => e.map((a, i) => {
    const r = () => a.map((s, c) => {
      const { component: l, props: u } = s;
      if ((u == null ? void 0 : u.show) === !1)
        return;
      const M = io(t, "show"), N = Le.createElement(l, { ...M }), g = Math.floor(12 / a.length);
      return /* @__PURE__ */ I.jsx(ve, { style: { justifyContent: "center" }, span: g, children: N }, c);
    });
    return /* @__PURE__ */ I.jsx(Ht, { children: r() }, i);
  });
  return /* @__PURE__ */ I.jsx("div", { className: Cu["button-panel-pc-container"], children: n() });
}
function yu() {
  const { button: t } = Q(Bn), e = [];
  function n(i) {
    return Object.keys(t).includes(i);
  }
  function a({ key: i, value: r }) {
    var l;
    const s = r.split(".");
    let c = s.slice(0, s.length - 1);
    return c.push("props"), c.push("show"), c = c.join("."), {
      path: c,
      value: (l = t[i]) == null ? void 0 : l.show
    };
  }
  return Ja(Ha, n, "", e, a), e;
}
function yn(t, e, n) {
  if (typeof t != "object")
    return;
  const a = ao(e);
  let i = t;
  for (let r = 0; r < a.length; r++) {
    if (i == null)
      return;
    const s = a[r];
    r !== a.length - 1 ? i = i == null ? void 0 : i[s] : Object.assign(i, { [s]: n });
  }
}
function mn(t, e, n) {
  if (typeof t != "object")
    return;
  const a = ao(e);
  let i = t;
  for (let r = 0; r < a.length; r++) {
    if (i == null)
      return;
    const s = a[r];
    r !== a.length - 1 ? i = i == null ? void 0 : i[s] : Array.isArray(i) && i.splice(s, 0, n);
  }
}
const mu = !z.isPC;
function ro() {
  const {
    callStatus: t,
    isGroupCall: e,
    callRole: n,
    callType: a,
    isShowEnableVirtualBackground: i
  } = Q(re), { localUserInfo: r } = Q(ke), s = yu(), [
    c,
    l
  ] = U(f.getData(d.CALL, o.IS_CLICKABLE)), u = Ie(() => c, [c]), M = (T) => {
    l(T);
  };
  H(() => (f.watch(
    d.CALL,
    { [o.IS_CLICKABLE]: M },
    { notifyRangeWhenWatch: o.MYSELF }
  ), () => {
    f.unwatch(
      d.CALL,
      { [o.IS_CLICKABLE]: M }
    );
  }), []);
  const N = (T) => {
    const E = zn(T);
    return mn(E, "pc.singleCall.video.calling[0][2]", { component: on, props: {} }), mn(E, "pc.singleCall.video.accept[0][1]", { component: on, props: {} }), mn(E, "pc.singleCall.video.connected[0][3]", { component: on, props: {} }), mn(E, "pc.groupCall.video.calling[0][2]", { component: on, props: {} }), mn(E, "pc.groupCall.video.connected[0][2]", { component: on, props: {} }), E;
  }, g = (T, E, j) => {
    const p = zn(T);
    return E ? (yn(p, "h5.singleCall.video.connected[1][2].props.show", !0), j && N(p)) : (yn(p, "h5.singleCall.video.connected[1][2].props.show", !1), j && (yn(p, "pc.singleCall.video.connected[0][3].props.show", !1), yn(p, "pc.groupCall.video.connected[0][2].props.show", !1))), p;
  }, D = Ie(() => {
    var L, S, y;
    let T = zn(Ha);
    i && (T = N(Ha)), t === _.CONNECTED && (T = g(
      T,
      r == null ? void 0 : r.isVideoAvailable,
      i
    )), s == null || s.forEach((w) => {
      const { path: b, value: B } = w;
      yn(T, b, B);
    });
    const E = z.isPC ? "pc" : "h5", j = e ? "groupCall" : "singleCall", p = a === $.AUDIO ? "audio" : "video", C = t === _.CALLING ? n === De.CALLER ? "calling" : "accept" : t, m = ((y = (S = (L = T == null ? void 0 : T[E]) == null ? void 0 : L[j]) == null ? void 0 : S[p]) == null ? void 0 : y[C]) || [];
    return m.length === 1 && m.unshift([]), m;
  }, [
    e,
    a,
    t,
    n,
    i,
    s,
    r == null ? void 0 : r.isVideoAvailable
  ]);
  return /* @__PURE__ */ I.jsx(Gr.Provider, { value: u, children: mu ? /* @__PURE__ */ I.jsx(hu, { buttons: D }) : /* @__PURE__ */ I.jsx(Lu, { buttons: D }) });
}
const ye = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9Ii01IiB5PSItNSIgd2lkdGg9IjExMCIgaGVpZ2h0PSIxMTAiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yOTY0XzE3NTgpIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQuOTk5OSA3MS41QzI0Ljk5OTkgNjEuMjM1NyAzMi45MzA0IDUyLjgyMzcgNDIuOTk4MyA1Mi4wNTdDNDMuNDkzOSA1Mi4wMTkzIDQzLjk5NDcgNTIgNDQuNDk5OSA1Mkg1Ny40OTk5QzU4LjAwNTEgNTIgNTguNTA1OSA1Mi4wMTkzIDU5LjAwMTQgNTIuMDU3QzY5LjA2OTQgNTIuODIzNyA3Ni45OTk5IDYxLjIzNTcgNzYuOTk5OSA3MS41Vjc4LjI4MjZIMjQuOTk5OUwyNC45OTk5IDcxLjVaIiBmaWxsPSIjRDVFMEYyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNDQuNDk5OSA0NS42MDQ4QzQ0LjQzMTIgNDUuNTcwNyA0NC4zNjI5IDQ1LjUzNiA0NC4yOTQ4IDQ1LjUwMDhDMzkuNTkwNiA0My4wNjk3IDM2LjM3NDkgMzguMTYwNCAzNi4zNzQ5IDMyLjVDMzYuMzc0OSAyNC40MjI4IDQyLjkyMjcgMTcuODc1IDUwLjk5OTkgMTcuODc1QzU5LjA3NyAxNy44NzUgNjUuNjI0OSAyNC40MjI4IDY1LjYyNDkgMzIuNUM2NS42MjQ5IDM4LjE2MDQgNjIuNDA5MiA0My4wNjk3IDU3LjcwNDkgNDUuNTAwOEM1Ny42MzY5IDQ1LjUzNiA1Ny41Njg2IDQ1LjU3MDcgNTcuNDk5OSA0NS42MDQ4QzU1LjU0MTggNDYuNTc3OSA1My4zMzQ3IDQ3LjEyNSA1MC45OTk5IDQ3LjEyNUM0OC42NjUgNDcuMTI1IDQ2LjQ1NzkgNDYuNTc3OSA0NC40OTk5IDQ1LjYwNDhaIiBmaWxsPSIjRDVFMEYyIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjk2NF8xNzU4IiB4MT0iNzMuNSIgeTE9Ii01IiB4Mj0iNSIgeTI9Ijk4LjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzdDODU5QiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM3NDdDOTAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
function oo(t) {
  const {
    shape: e = "round",
    image: n,
    icon: a,
    children: i,
    className: r,
    style: s
  } = t, c = (M) => {
    M.target.src = ye;
  }, l = () => typeof n == "string" ? /* @__PURE__ */ I.jsx("img", { src: n, onError: c }) : a || i, u = x([
    r,
    `${P}-avatar-container`,
    `${P}-avatar-shape-${e}`
  ]);
  return /* @__PURE__ */ I.jsx("div", { className: u, style: s, children: l() });
}
const Su = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiIgY2xhc3M9ImRlc2lnbi1pY29uZm9udCI+CiAgICA8cGF0aAogICAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgZD0iTTQuODI4MjUgMTIuNDc1OUM1LjU4MTcyIDEyLjkwNDggNi40Mzc0MiAxMy4xOTc4IDcuMzMzMzMgMTMuMjk2N1YxNS4wMDAyQzcuMzMzMzMgMTUuMTg0MyA3LjQ4MjU3IDE1LjMzMzUgNy42NjY2NyAxNS4zMzM1SDguMzMzMzNDOC41MTc0MyAxNS4zMzM1IDguNjY2NjcgMTUuMTg0MyA4LjY2NjY3IDE1LjAwMDJWMTMuMjk2N0MxMS41NDAyIDEyLjk3OTYgMTQgMTAuNjY1OCAxNCA4LjI3MzQ3VjcuNjgxMTZDMTQgNy40OTcwNyAxMy44NTA4IDcuMzQ3ODMgMTMuNjY2NyA3LjM0NzgzSDEzQzEyLjgxNTkgNy4zNDc4MyAxMi42NjY3IDcuNDk3MDcgMTIuNjY2NyA3LjY4MTE2VjguMjczNDdMMTIuNjYzNCA4LjM5MzMzQzEyLjU2ODEgMTAuMTUyNiAxMC4zOTgyIDExLjk5ODIgOC4wMDM5NiAxMi4wMDAyTDggMTIuMDAwMkw3Ljk5NjA0IDEyLjAwMDJDNy4yMjUxNCAxMS45OTk2IDYuNDc3NDkgMTEuODA3OCA1LjgxNDg3IDExLjQ4OTNMNC44MjgyNSAxMi40NzU5Wk02LjgzMTY4IDEwLjQ3MjVDNy4xOTYgMTAuNTkyNyA3LjU4OTkgMTAuNjU4MyA4IDEwLjY1ODNDOS44Mjc0NyAxMC42NTgzIDExLjMzMzMgOS4zNTUxNyAxMS4zMzMzIDcuNzI1NjNWNS45NzA4M0w2LjgzMTY4IDEwLjQ3MjVaTTEwLjkwNjggMi4xNTQ3TDQuNzM2MjkgOC4zMjUyNEM0LjcwMDQzIDguMTczMjcgNC42Nzc5MyA4LjAxNjg5IDQuNjY5OTQgNy44NTcwMkw0LjY2NjY3IDcuNzI1NjNWMy41OTEwMkM0LjY2NjY3IDEuOTYxNDggNi4xNzI1MyAwLjY1ODMyNSA4IDAuNjU4MzI1QzkuMjQwNzIgMC42NTgzMjUgMTAuMzMzMiAxLjI1OTAxIDEwLjkwNjggMi4xNTQ3Wk0zLjYyNDU1IDkuNDM2OThMMi42NDYyMiAxMC40MTUzQzIuMjYyMDggOS43ODk4NSAyLjAzMTA4IDkuMTA4MDQgMi4wMDI5MiA4LjQxNjQ0TDIgOC4yNzM0N1Y3LjY2NTQ2QzIgNy40ODI3NyAyLjE0NzA2IDcuMzM0MTEgMi4zMjk3NSA3LjMzMjE1TDIuOTkzNTIgNy4zMjUwMkMzLjE3ODM5IDcuMzIzMDMgMy4zMjk1NiA3LjQ3MTg4IDMuMzMwNDMgNy42NTY3NkwzLjMzMzMzIDguMjczNDdDMy4zMzMzMyA4LjY2MTkxIDMuNDM3MSA5LjA1NjcyIDMuNjI0NTUgOS40MzY5OFoiCiAgICAgIGZpbGw9IiNmZmYiCiAgICAvPgogICAgPHJlY3QgeD0iLjYwOTg2MyIgeT0iMTMuNDUxNCIgd2lkdGg9IjE5LjAxMjciIGhlaWdodD0iMS41IiByeD0iLjc1IiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgLjYwOTg2MyAxMy40NTE0KSIgZmlsbD0iI0ZFM0M0NCIgLz4KICA8L3N2Zz4=", Ou = {
  "microphone-container": "_microphone-container_nczz7_1"
};
function so(t) {
  const { close: e, style: n = {}, volume: a = 0 } = t, i = () => /* @__PURE__ */ I.jsx(ie, { url: Su }), r = () => /* @__PURE__ */ I.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", className: "", viewBox: "0 0 16 16", children: [
    /* @__PURE__ */ I.jsxs("g", { children: [
      a > 0 && /* @__PURE__ */ I.jsx(
        "path",
        {
          d: "M8.62462 7.17395C8.90076 7.17395 9.12462 7.38807 9.12462 7.65221C9.12462 7.89434 8.93651 8.09444 8.69246 8.12611L8.62462 8.13047H7.3335C7.05735 8.13047 6.8335 7.91635 6.8335 7.65221C6.8335 7.41009 7.0216 7.20998 7.26565 7.17832L7.3335 7.17395H8.62462Z",
          fill: "#43D92B"
        }
      ),
      a > 5 && /* @__PURE__ */ I.jsx(
        "path",
        {
          d: "M8.62462 5.57971C8.90076 5.57971 9.12462 5.79384 9.12462 6.05797C9.12462 6.3001 8.93651 6.5002 8.69246 6.53187L8.62462 6.53623H7.3335C7.05735 6.53623 6.8335 6.32211 6.8335 6.05797C6.8335 5.81585 7.0216 5.61575 7.26565 5.58408L7.3335 5.57971H8.62462Z",
          fill: "#43D92B"
        }
      ),
      a > 10 && /* @__PURE__ */ I.jsx(
        "path",
        {
          d: "M8.62462 3.98547C8.90076 3.98547 9.12462 4.1996 9.12462 4.46373C9.12462 4.70586 8.93651 4.90596 8.69246 4.93763L8.62462 4.942H7.3335C7.05735 4.942 6.8335 4.72787 6.8335 4.46373C6.8335 4.22161 7.0216 4.02151 7.26565 3.98984L7.3335 3.98547H8.62462Z",
          fill: "#43D92B"
        }
      )
    ] }),
    /* @__PURE__ */ I.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3301 3.45938C11.2517 1.89175 9.77808 0.658081 8 0.658081C6.17253 0.658081 4.66667 1.96123 4.66667 3.59077V7.72539L4.66994 7.85678C4.7483 9.42442 6.22192 10.6581 8 10.6581C9.82747 10.6581 11.3333 9.35493 11.3333 7.72539V3.59077L11.3301 3.45938ZM6.0035 3.54179C6.06337 2.69234 6.92083 1.99146 8.00016 1.99146C9.11947 1.99146 10.0002 2.74521 10.0002 3.63675V7.67949L9.99682 7.77446C9.93695 8.62391 9.07949 9.32479 8.00016 9.32479C6.88086 9.32479 6.00016 8.57103 6.00016 7.67949V3.63675L6.0035 3.54179ZM8.33333 15.3333C8.51743 15.3333 8.66667 15.1841 8.66667 15V13.2964C11.5402 12.9793 14 10.6655 14 8.27322V7.68092C14 7.49682 13.8508 7.34758 13.6667 7.34758H13C12.8159 7.34758 12.6667 7.49682 12.6667 7.68092V8.27322L12.6634 8.39309C12.5681 10.1524 10.3982 11.9979 8.00396 12C8.00264 12 8.00132 12 8 12C7.99868 12 7.99736 12 7.99604 12C5.54737 11.9979 3.33333 10.0675 3.33333 8.27322L3.33043 7.65652C3.32956 7.47164 3.17839 7.32278 2.99352 7.32477L2.32975 7.33191C2.14706 7.33387 2 7.48252 2 7.66522V8.27322L2.00292 8.4162C2.09825 10.757 4.51708 12.9856 7.33333 13.2964V15C7.33333 15.1841 7.48257 15.3333 7.66667 15.3333H8.33333Z",
        fill: "#fff"
      }
    )
  ] });
  return /* @__PURE__ */ I.jsx("div", { className: Ou["microphone-container"], style: n, children: e ? i() : r() });
}
const wu = "_blur_eicsw_7", Uu = "_pc_eicsw_19", zu = "_avatar_eicsw_31", xu = "_float_eicsw_35", vu = "_small_eicsw_39", Ru = "_username_eicsw_47", bu = "_nick_eicsw_54", _u = "_mobile_eicsw_78", ku = "_tip_eicsw_129", ze = {
  "overlay-stream-container": "_overlay-stream-container_eicsw_1",
  blur: wu,
  pc: Uu,
  "user-info-container": "_user-info-container_eicsw_19",
  avatar: zu,
  float: xu,
  small: vu,
  username: Ru,
  nick: bu,
  mobile: _u,
  tip: ku
};
function dn(t) {
  const {
    avatar: e,
    username: n,
    isMobile: a,
    isSmall: i,
    blur: r = !0,
    theme: s = "circle",
    children: c,
    className: l,
    tip: u = "",
    volume: M,
    isMute: N = !1,
    showAvatar: g = !0,
    showUsername: D = !0,
    showOverlayer: T,
    showBackground: E = !0,
    showLoading: j = !0,
    showVolumn: p = !1,
    style: C = {},
    showTip: m = !0,
    background: L = "",
    fit: S,
    onError: y
  } = t, { isFloat: w } = Q(re), b = x([
    l,
    ze["overlay-stream-container"],
    {
      [ze.mobile]: a,
      [ze.pc]: !a
    }
  ]), B = (F) => {
    y == null || y(F);
  };
  return /* @__PURE__ */ I.jsx("div", { className: b, style: C, children: /* @__PURE__ */ I.jsxs(oi, { showLoading: j, size: 40, theme: s, showOverlayer: !1, children: [
    /* @__PURE__ */ I.jsxs("div", { className: ze["user-info-container"], children: [
      g && /* @__PURE__ */ I.jsx(
        oo,
        {
          className: x([
            ze.avatar,
            {
              [ze.small]: i,
              [ze.float]: w
            }
          ]),
          image: e
        }
      ),
      D && /* @__PURE__ */ I.jsxs("div", { className: ze.username, children: [
        /* @__PURE__ */ I.jsx(
          "div",
          {
            className: x([
              ze.nick,
              { [ze.small]: i, [ze.float]: w }
            ]),
            children: n
          }
        ),
        p && /* @__PURE__ */ I.jsx(so, { volume: M, close: N, style: { marginLeft: "10px" } })
      ] }),
      m && /* @__PURE__ */ I.jsx("div", { className: ze.tip, children: u }),
      c
    ] }),
    E && /* @__PURE__ */ I.jsx(
      kr,
      {
        showOverlayer: T,
        className: x({ [ze.blur]: r }),
        background: L,
        fit: S,
        defaultSrc: ye,
        onError: B
      }
    )
  ] }) });
}
function Zn() {
  const { viewBackground: t } = Q(Bn);
  return t;
}
const Vu = {
  "singlecall-waiting-container": "_singlecall-waiting-container_pmvxi_1"
};
function Qu(t) {
  const { avatar: e, username: n, userId: a } = t, { localUserInfo: i } = Q(ke), r = Zn(), [s, c] = U(r[a] || e), [l, u] = U(!r[a]), [M, N] = U(r[a] ? "fill" : "cover");
  return H(() => {
    c(r[a] || e || ye), u(!i.isVideoAvailable && !r[a]), N(r[a] ? "fill" : "cover");
  }, [r, a]), /* @__PURE__ */ I.jsx(
    dn,
    {
      className: Vu["singlecall-waiting-container"],
      showLoading: !1,
      avatar: e || ye,
      username: n,
      showAvatar: !z.isPC,
      background: s,
      showBackground: !i.isVideoAvailable,
      isMobile: !z.isPC,
      showOverlayer: l,
      fit: M
    }
  );
}
function Bu(t, e) {
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return t[n];
}
const lo = Ut({ bigWindow: null });
function Yu(t) {
  const {
    bigWindow: e,
    className: n,
    isMobile: a,
    showSmallWindow: i = !0,
    onToggle: r,
    children: s = null
  } = t, [c, l] = U(e);
  H(() => {
    l(e);
  }, [e]);
  const u = x([
    `${P}-togglewindow-container`,
    n
  ]), M = Ie(() => {
    const N = [], g = [];
    s && Le.Children.map(s, (T) => {
      var E, j;
      if (((E = T == null ? void 0 : T.type) == null ? void 0 : E.displayName) === "ToggleWindowItem" && N.length < 2 && (N.push(Le.cloneElement(T, { isMobile: a, showSmallWindow: i })), g.push((j = T == null ? void 0 : T.props) == null ? void 0 : j.value)), N.length >= 2)
        return null;
    });
    const D = () => {
      l((T) => {
        const E = Bu(g, T);
        return r == null || r(E), E;
      });
    };
    return N.map(
      (T) => Le.cloneElement(T, { updateBigWindow: D })
    );
  }, [s]);
  return /* @__PURE__ */ I.jsx("div", { className: u, children: /* @__PURE__ */ I.jsx(lo.Provider, { value: { bigWindow: c }, children: M }) });
}
function Xa(t) {
  const {
    children: e,
    value: n,
    isMobile: a,
    updateBigWindow: i,
    showSmallWindow: r,
    className: s
  } = t, { bigWindow: c } = Q(lo), l = c !== n, u = x([
    s,
    `${P}-togglewindowitem-container`,
    `${P}-togglewindowitem-${l ? "small" : "big"}`,
    { mobile: a }
  ]), M = () => {
    let N;
    return !r && l && (N = "hidden"), /* @__PURE__ */ I.jsx(
      "div",
      {
        onClick: () => l && i(),
        className: u,
        style: { visibility: N },
        children: e
      }
    );
  };
  return /* @__PURE__ */ I.jsx(I.Fragment, { children: M() });
}
Xa.displayName = "ToggleWindowItem";
function Gu(t) {
  const {
    maxWidth: e,
    truncated: n,
    lineClamp: a,
    children: i,
    className: r
  } = t, s = x([
    r,
    `${Fe}-text`
  ]), c = {
    maxWidth: e,
    textOverflow: n ? "ellipsis" : "auto",
    WebkitLineClamp: a
  };
  return /* @__PURE__ */ I.jsx("span", { style: c, className: s, children: i });
}
const Fu = "data:image/svg+xml;base64,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", Zu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF8xNzQxXzEwNjc4KSI+CjxjaXJjbGUgY3g9IjE0IiBjeT0iMTQiIHI9IjEyIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNjY2NyAxMC4wMDAxQzEwLjY2NjcgOC4xNTkxMyAxMi4xNTkgNi42NjY3NSAxNCA2LjY2Njc1QzE1LjA1MzggNi42NjY3NSAxNS45OTM0IDcuMTU1NzQgMTYuNjA0MiA3LjkxOTJMMTAuNzMyIDE0Ljk5MzRDMTAuNjg5MSAxNC43ODAxIDEwLjY2NjcgMTQuNTU5NCAxMC42NjY3IDE0LjMzMzRWMTAuMDAwMVpNOS42Mjk3NSAxNi4zMjEyQzkuMzUzNzUgMTUuNzE1NSA5LjIgMTUuMDQyMyA5LjIgMTQuMzMzMlYxMy4zMzMySDguMTMzMzNWMTQuMzMzMkM4LjEzMzMzIDE1LjM4MDMgOC40MDc2NiAxNi4zNjM0IDguODg4MzYgMTcuMjE0NEw5LjYyOTc1IDE2LjMyMTJaTTEwLjkxMyAxOS4zMjNMMTEuNjAyNSAxOC40OTI1QzEyLjMwNzkgMTguOSAxMy4xMjY3IDE5LjEzMzIgMTQgMTkuMTMzMkMxNi42NTEgMTkuMTMzMiAxOC44IDE2Ljk4NDIgMTguOCAxNC4zMzMyVjEzLjMzMzJIMTkuODY2N1YxNC4zMzMyQzE5Ljg2NjcgMTcuMzkzNSAxNy41MjM1IDE5LjkwNjUgMTQuNTMzMyAyMC4xNzZWMjIuMDAwMUgxMy40NjY3VjIwLjE3NkMxMi41MzU3IDIwLjA5MjEgMTEuNjY3NCAxOS43OTA3IDEwLjkxMyAxOS4zMjNaTTEyLjU1OTEgMTcuMzQwMUwxNy4zMzMzIDExLjU4ODZWMTQuMzMzNEMxNy4zMzMzIDE2LjE3NDQgMTUuODQwOSAxNy42NjY3IDE0IDE3LjY2NjdDMTMuNDgzOSAxNy42NjY3IDEyLjk5NTIgMTcuNTQ5NSAxMi41NTkxIDE3LjM0MDFaIiBmaWxsPSIjRTYzOTVDIi8+CjxwYXRoIGQ9Ik05LjQyMzQgMTguODQ0N0wxNy43ODM0IDguNzc4MjciIHN0cm9rZT0iI0U2Mzk1QyIgc3Ryb2tlLXdpZHRoPSIxLjA2NjY3IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RfMTc0MV8xMDY3OCIgeD0iMCIgeT0iMCIgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDEyNyAwIiByZXN1bHQ9ImhhcmRBbHBoYSIvPgo8ZmVPZmZzZXQvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxIi8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzE3NDFfMTA2NzgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMTc0MV8xMDY3OCIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K", Wu = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjgzMzI1IDQuOTk5OThDNS44MzMyNSAyLjY5ODc5IDcuNjk4NzMgMC44MzMzMTMgOS45OTk5MiAwLjgzMzMxM0MxMS42MDk4IDAuODMzMzEzIDEzLjAwNjQgMS43NDYzMiAxMy43MDAzIDMuMDgyNzhMNi4xOTcwMyAxMi4xMjE5QzUuOTYzMjggMTEuNjAxNCA1LjgzMzI1IDExLjAyNDIgNS44MzMyNSAxMC40MTY2VjQuOTk5OThaTTUuMDYwODMgMTMuNDkwNkM0LjUwNDY0IDEyLjU5ODggNC4xODMyOCAxMS41NDUzIDQuMTgzMjggMTAuNDE2OVY5LjE2Njg3SDIuNDgzMjhWMTAuNDE2OUMyLjQ4MzI4IDEyLjA3NTYgMy4wMjA1OCAxMy42MDg5IDMuOTMwNjQgMTQuODUyMUw1LjA2MDgzIDEzLjQ5MDZaTTcuMDcyMTIgMTcuMzQyTDguMjIxOTcgMTUuOTU2OEM4Ljc4MjM5IDE2LjEzNjUgOS4zNzk4NCAxNi4yMzM1IDkuOTk5OTQgMTYuMjMzNUMxMy4yMTI0IDE2LjIzMzUgMTUuODE2NiAxMy42MjkzIDE1LjgxNjYgMTAuNDE2OVY5LjE2Njg3SDE3LjUxNjZWMTAuNDE2OUMxNy41MTY2IDE0LjI4NjUgMTQuNTkyNSAxNy40NzMyIDEwLjgzMzMgMTcuODg3OVYyMC4wMDAxSDkuMTY2NjNWMTcuODg3OUM4LjQzMTI5IDE3LjgwNjggNy43Mjc5MSAxNy42MTk2IDcuMDcyMTIgMTcuMzQyWk05LjM5NzkxIDE0LjU0MDFMMTQuMTY2NiA4Ljc5NTM3VjEwLjQxNjZDMTQuMTY2NiAxMi43MTc4IDEyLjMwMTEgMTQuNTgzMyA5Ljk5OTkyIDE0LjU4MzNDOS43OTU0OCAxNC41ODMzIDkuNTk0NDcgMTQuNTY4NiA5LjM5NzkxIDE0LjU0MDFaIiBmaWxsPSIjRDVFMEYyIi8+CjxwYXRoIGQ9Ik01LjA0MTAyIDE2LjY1MzZMMTUuMzI1MyA0LjI3MDAyIiBzdHJva2U9IiNENUUwRjIiIHN0cm9rZS13aWR0aD0iMS43IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K", co = "data:image/svg+xml;base64,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", Pu = "_single_lq9pw_14", xa = {
  "stream-info-container-h5": "_stream-info-container-h5_lq9pw_1",
  single: Pu
};
function Hu(t) {
  const {
    isSpkear: e,
    isMute: n,
    displayName: a,
    showUserName: i = !1,
    showSwitchCamera: r = !1,
    showNetWorkStatus: s = !1
  } = t, { isGroupCall: c } = Q(re), l = x(
    [
      xa["stream-info-container-h5"],
      {
        [xa.group]: c,
        [xa.single]: !c
      }
    ]
  ), u = {
    width: "30px",
    height: "30px",
    background: "#22262e80",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, M = async () => {
    await X.switchCamera();
  }, N = () => /* @__PURE__ */ I.jsxs(Ht, { children: [
    /* @__PURE__ */ I.jsxs(ve, { span: 6, align: "center", justify: "start", children: [
      i && /* @__PURE__ */ I.jsx(Gu, { maxWidth: "100px", truncated: !0, children: a }),
      e && /* @__PURE__ */ I.jsx(ie, { style: { width: "fit-content" }, url: Fu }),
      n && /* @__PURE__ */ I.jsx(ie, { style: { width: "fit-content" }, url: Zu })
    ] }),
    /* @__PURE__ */ I.jsxs(ve, { span: 6, align: "center", justify: "end", children: [
      s && /* @__PURE__ */ I.jsx(ie, { style: { width: "24px", height: "24px", marginRight: "12px" }, url: co }),
      r && /* @__PURE__ */ I.jsx(
        Pe,
        {
          showText: !1,
          icon: /* @__PURE__ */ I.jsx(ie, { url: no }),
          style: u,
          iconSize: "15px",
          isStopPropagation: !0,
          onClick: M
        }
      )
    ] })
  ] }), g = () => /* @__PURE__ */ I.jsx(Ht, { children: /* @__PURE__ */ I.jsx(ve, { span: 12, justify: "start", children: n && /* @__PURE__ */ I.jsx(ie, { style: { width: "fit-content" }, url: Wu }) }) });
  return /* @__PURE__ */ I.jsx("div", { className: l, children: c ? N() : g() });
}
const Ju = "_nick_1wp66_23", va = {
  "stream-info-container-pc": "_stream-info-container-pc_1wp66_1",
  "stream-info-content": "_stream-info-content_1wp66_14",
  nick: Ju,
  "stream-info-netWork": "_stream-info-netWork_1wp66_27"
};
function Xu(t) {
  const {
    isMute: e,
    displayName: n,
    volume: a,
    isMe: i,
    showNetWorkStatus: r = !1
  } = t;
  return /* @__PURE__ */ I.jsxs("div", { className: va["stream-info-container-pc"], children: [
    /* @__PURE__ */ I.jsxs("div", { className: va["stream-info-content"], children: [
      /* @__PURE__ */ I.jsx(so, { volume: a, close: e }),
      /* @__PURE__ */ I.jsx("div", { className: va.nick, children: n }),
      i && /* @__PURE__ */ I.jsx("div", { children: k("you") })
    ] }),
    /* @__PURE__ */ I.jsx("div", { className: "stream-info-netWork", children: r && /* @__PURE__ */ I.jsx(ie, { style: { width: "20px", height: "20px" }, url: co }) })
  ] });
}
function uo(t) {
  return z.isPC ? /* @__PURE__ */ I.jsx(Xu, { ...t }) : /* @__PURE__ */ I.jsx(Hu, { ...t });
}
var Ku = typeof global == "object" && global && global.Object === Object && global;
const Mo = Ku;
var $u = typeof self == "object" && self && self.Object === Object && self, qu = Mo || $u || Function("return this")();
const Dt = qu;
var eM = Dt.Symbol;
const Nn = eM;
var Io = Object.prototype, tM = Io.hasOwnProperty, nM = Io.toString, Sn = Nn ? Nn.toStringTag : void 0;
function aM(t) {
  var e = tM.call(t, Sn), n = t[Sn];
  try {
    t[Sn] = void 0;
    var a = !0;
  } catch {
  }
  var i = nM.call(t);
  return a && (e ? t[Sn] = n : delete t[Sn]), i;
}
var iM = Object.prototype, rM = iM.toString;
function oM(t) {
  return rM.call(t);
}
var sM = "[object Null]", lM = "[object Undefined]", er = Nn ? Nn.toStringTag : void 0;
function Wn(t) {
  return t == null ? t === void 0 ? lM : sM : er && er in Object(t) ? aM(t) : oM(t);
}
function _n(t) {
  return t != null && typeof t == "object";
}
var cM = Array.isArray;
const Ma = cM;
function Ao(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var uM = "[object AsyncFunction]", MM = "[object Function]", IM = "[object GeneratorFunction]", AM = "[object Proxy]";
function No(t) {
  if (!Ao(t))
    return !1;
  var e = Wn(t);
  return e == MM || e == IM || e == uM || e == AM;
}
var dM = Dt["__core-js_shared__"];
const Ra = dM;
var tr = function() {
  var t = /[^.]+$/.exec(Ra && Ra.keys && Ra.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function NM(t) {
  return !!tr && tr in t;
}
var gM = Function.prototype, DM = gM.toString;
function Kt(t) {
  if (t != null) {
    try {
      return DM.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var TM = /[\\^$.*+?()[\]{}|]/g, EM = /^\[object .+?Constructor\]$/, fM = Function.prototype, pM = Object.prototype, jM = fM.toString, hM = pM.hasOwnProperty, CM = RegExp(
  "^" + jM.call(hM).replace(TM, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function LM(t) {
  if (!Ao(t) || NM(t))
    return !1;
  var e = No(t) ? CM : EM;
  return e.test(Kt(t));
}
function yM(t, e) {
  return t == null ? void 0 : t[e];
}
function gn(t, e) {
  var n = yM(t, e);
  return LM(n) ? n : void 0;
}
var mM = gn(Dt, "WeakMap");
const Ka = mM;
var SM = 9007199254740991, OM = /^(?:0|[1-9]\d*)$/;
function wM(t, e) {
  var n = typeof t;
  return e = e ?? SM, !!e && (n == "number" || n != "symbol" && OM.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function go(t, e) {
  return t === e || t !== t && e !== e;
}
var UM = 9007199254740991;
function Do(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= UM;
}
function zM(t) {
  return t != null && Do(t.length) && !No(t);
}
var xM = Object.prototype;
function vM(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || xM;
  return t === n;
}
function RM(t, e) {
  for (var n = -1, a = Array(t); ++n < t; )
    a[n] = e(n);
  return a;
}
var bM = "[object Arguments]";
function nr(t) {
  return _n(t) && Wn(t) == bM;
}
var To = Object.prototype, _M = To.hasOwnProperty, kM = To.propertyIsEnumerable, VM = nr(function() {
  return arguments;
}()) ? nr : function(t) {
  return _n(t) && _M.call(t, "callee") && !kM.call(t, "callee");
};
const QM = VM;
function BM() {
  return !1;
}
var Eo = typeof exports == "object" && exports && !exports.nodeType && exports, ar = Eo && typeof module == "object" && module && !module.nodeType && module, YM = ar && ar.exports === Eo, ir = YM ? Dt.Buffer : void 0, GM = ir ? ir.isBuffer : void 0, FM = GM || BM;
const $a = FM;
var ZM = "[object Arguments]", WM = "[object Array]", PM = "[object Boolean]", HM = "[object Date]", JM = "[object Error]", XM = "[object Function]", KM = "[object Map]", $M = "[object Number]", qM = "[object Object]", eI = "[object RegExp]", tI = "[object Set]", nI = "[object String]", aI = "[object WeakMap]", iI = "[object ArrayBuffer]", rI = "[object DataView]", oI = "[object Float32Array]", sI = "[object Float64Array]", lI = "[object Int8Array]", cI = "[object Int16Array]", uI = "[object Int32Array]", MI = "[object Uint8Array]", II = "[object Uint8ClampedArray]", AI = "[object Uint16Array]", dI = "[object Uint32Array]", ae = {};
ae[oI] = ae[sI] = ae[lI] = ae[cI] = ae[uI] = ae[MI] = ae[II] = ae[AI] = ae[dI] = !0;
ae[ZM] = ae[WM] = ae[iI] = ae[PM] = ae[rI] = ae[HM] = ae[JM] = ae[XM] = ae[KM] = ae[$M] = ae[qM] = ae[eI] = ae[tI] = ae[nI] = ae[aI] = !1;
function NI(t) {
  return _n(t) && Do(t.length) && !!ae[Wn(t)];
}
function gI(t) {
  return function(e) {
    return t(e);
  };
}
var fo = typeof exports == "object" && exports && !exports.nodeType && exports, xn = fo && typeof module == "object" && module && !module.nodeType && module, DI = xn && xn.exports === fo, ba = DI && Mo.process, TI = function() {
  try {
    var t = xn && xn.require && xn.require("util").types;
    return t || ba && ba.binding && ba.binding("util");
  } catch {
  }
}();
const rr = TI;
var or = rr && rr.isTypedArray, EI = or ? gI(or) : NI;
const po = EI;
var fI = Object.prototype, pI = fI.hasOwnProperty;
function jI(t, e) {
  var n = Ma(t), a = !n && QM(t), i = !n && !a && $a(t), r = !n && !a && !i && po(t), s = n || a || i || r, c = s ? RM(t.length, String) : [], l = c.length;
  for (var u in t)
    (e || pI.call(t, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    wM(u, l))) && c.push(u);
  return c;
}
function hI(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var CI = hI(Object.keys, Object);
const LI = CI;
var yI = Object.prototype, mI = yI.hasOwnProperty;
function SI(t) {
  if (!vM(t))
    return LI(t);
  var e = [];
  for (var n in Object(t))
    mI.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
function OI(t) {
  return zM(t) ? jI(t) : SI(t);
}
var wI = gn(Object, "create");
const kn = wI;
function UI() {
  this.__data__ = kn ? kn(null) : {}, this.size = 0;
}
function zI(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var xI = "__lodash_hash_undefined__", vI = Object.prototype, RI = vI.hasOwnProperty;
function bI(t) {
  var e = this.__data__;
  if (kn) {
    var n = e[t];
    return n === xI ? void 0 : n;
  }
  return RI.call(e, t) ? e[t] : void 0;
}
var _I = Object.prototype, kI = _I.hasOwnProperty;
function VI(t) {
  var e = this.__data__;
  return kn ? e[t] !== void 0 : kI.call(e, t);
}
var QI = "__lodash_hash_undefined__";
function BI(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = kn && e === void 0 ? QI : e, this;
}
function Xt(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
Xt.prototype.clear = UI;
Xt.prototype.delete = zI;
Xt.prototype.get = bI;
Xt.prototype.has = VI;
Xt.prototype.set = BI;
function YI() {
  this.__data__ = [], this.size = 0;
}
function Ta(t, e) {
  for (var n = t.length; n--; )
    if (go(t[n][0], e))
      return n;
  return -1;
}
var GI = Array.prototype, FI = GI.splice;
function ZI(t) {
  var e = this.__data__, n = Ta(e, t);
  if (n < 0)
    return !1;
  var a = e.length - 1;
  return n == a ? e.pop() : FI.call(e, n, 1), --this.size, !0;
}
function WI(t) {
  var e = this.__data__, n = Ta(e, t);
  return n < 0 ? void 0 : e[n][1];
}
function PI(t) {
  return Ta(this.__data__, t) > -1;
}
function HI(t, e) {
  var n = this.__data__, a = Ta(n, t);
  return a < 0 ? (++this.size, n.push([t, e])) : n[a][1] = e, this;
}
function Tt(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
Tt.prototype.clear = YI;
Tt.prototype.delete = ZI;
Tt.prototype.get = WI;
Tt.prototype.has = PI;
Tt.prototype.set = HI;
var JI = gn(Dt, "Map");
const Vn = JI;
function XI() {
  this.size = 0, this.__data__ = {
    hash: new Xt(),
    map: new (Vn || Tt)(),
    string: new Xt()
  };
}
function KI(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function Ea(t, e) {
  var n = t.__data__;
  return KI(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
function $I(t) {
  var e = Ea(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function qI(t) {
  return Ea(this, t).get(t);
}
function eA(t) {
  return Ea(this, t).has(t);
}
function tA(t, e) {
  var n = Ea(this, t), a = n.size;
  return n.set(t, e), this.size += n.size == a ? 0 : 1, this;
}
function $t(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var a = t[e];
    this.set(a[0], a[1]);
  }
}
$t.prototype.clear = XI;
$t.prototype.delete = $I;
$t.prototype.get = qI;
$t.prototype.has = eA;
$t.prototype.set = tA;
function nA(t, e) {
  for (var n = -1, a = e.length, i = t.length; ++n < a; )
    t[i + n] = e[n];
  return t;
}
function aA() {
  this.__data__ = new Tt(), this.size = 0;
}
function iA(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
function rA(t) {
  return this.__data__.get(t);
}
function oA(t) {
  return this.__data__.has(t);
}
var sA = 200;
function lA(t, e) {
  var n = this.__data__;
  if (n instanceof Tt) {
    var a = n.__data__;
    if (!Vn || a.length < sA - 1)
      return a.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new $t(a);
  }
  return n.set(t, e), this.size = n.size, this;
}
function wt(t) {
  var e = this.__data__ = new Tt(t);
  this.size = e.size;
}
wt.prototype.clear = aA;
wt.prototype.delete = iA;
wt.prototype.get = rA;
wt.prototype.has = oA;
wt.prototype.set = lA;
function cA(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length, i = 0, r = []; ++n < a; ) {
    var s = t[n];
    e(s, n, t) && (r[i++] = s);
  }
  return r;
}
function uA() {
  return [];
}
var MA = Object.prototype, IA = MA.propertyIsEnumerable, sr = Object.getOwnPropertySymbols, AA = sr ? function(t) {
  return t == null ? [] : (t = Object(t), cA(sr(t), function(e) {
    return IA.call(t, e);
  }));
} : uA;
const dA = AA;
function NA(t, e, n) {
  var a = e(t);
  return Ma(t) ? a : nA(a, n(t));
}
function lr(t) {
  return NA(t, OI, dA);
}
var gA = gn(Dt, "DataView");
const qa = gA;
var DA = gn(Dt, "Promise");
const ei = DA;
var TA = gn(Dt, "Set");
const ti = TA;
var cr = "[object Map]", EA = "[object Object]", ur = "[object Promise]", Mr = "[object Set]", Ir = "[object WeakMap]", Ar = "[object DataView]", fA = Kt(qa), pA = Kt(Vn), jA = Kt(ei), hA = Kt(ti), CA = Kt(Ka), Yt = Wn;
(qa && Yt(new qa(new ArrayBuffer(1))) != Ar || Vn && Yt(new Vn()) != cr || ei && Yt(ei.resolve()) != ur || ti && Yt(new ti()) != Mr || Ka && Yt(new Ka()) != Ir) && (Yt = function(t) {
  var e = Wn(t), n = e == EA ? t.constructor : void 0, a = n ? Kt(n) : "";
  if (a)
    switch (a) {
      case fA:
        return Ar;
      case pA:
        return cr;
      case jA:
        return ur;
      case hA:
        return Mr;
      case CA:
        return Ir;
    }
  return e;
});
const dr = Yt;
var LA = Dt.Uint8Array;
const Nr = LA;
var yA = "__lodash_hash_undefined__";
function mA(t) {
  return this.__data__.set(t, yA), this;
}
function SA(t) {
  return this.__data__.has(t);
}
function Ia(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new $t(); ++e < n; )
    this.add(t[e]);
}
Ia.prototype.add = Ia.prototype.push = mA;
Ia.prototype.has = SA;
function OA(t, e) {
  for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
function wA(t, e) {
  return t.has(e);
}
var UA = 1, zA = 2;
function jo(t, e, n, a, i, r) {
  var s = n & UA, c = t.length, l = e.length;
  if (c != l && !(s && l > c))
    return !1;
  var u = r.get(t), M = r.get(e);
  if (u && M)
    return u == e && M == t;
  var N = -1, g = !0, D = n & zA ? new Ia() : void 0;
  for (r.set(t, e), r.set(e, t); ++N < c; ) {
    var T = t[N], E = e[N];
    if (a)
      var j = s ? a(E, T, N, e, t, r) : a(T, E, N, t, e, r);
    if (j !== void 0) {
      if (j)
        continue;
      g = !1;
      break;
    }
    if (D) {
      if (!OA(e, function(p, C) {
        if (!wA(D, C) && (T === p || i(T, p, n, a, r)))
          return D.push(C);
      })) {
        g = !1;
        break;
      }
    } else if (!(T === E || i(T, E, n, a, r))) {
      g = !1;
      break;
    }
  }
  return r.delete(t), r.delete(e), g;
}
function xA(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(a, i) {
    n[++e] = [i, a];
  }), n;
}
function vA(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(a) {
    n[++e] = a;
  }), n;
}
var RA = 1, bA = 2, _A = "[object Boolean]", kA = "[object Date]", VA = "[object Error]", QA = "[object Map]", BA = "[object Number]", YA = "[object RegExp]", GA = "[object Set]", FA = "[object String]", ZA = "[object Symbol]", WA = "[object ArrayBuffer]", PA = "[object DataView]", gr = Nn ? Nn.prototype : void 0, _a = gr ? gr.valueOf : void 0;
function HA(t, e, n, a, i, r, s) {
  switch (n) {
    case PA:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case WA:
      return !(t.byteLength != e.byteLength || !r(new Nr(t), new Nr(e)));
    case _A:
    case kA:
    case BA:
      return go(+t, +e);
    case VA:
      return t.name == e.name && t.message == e.message;
    case YA:
    case FA:
      return t == e + "";
    case QA:
      var c = xA;
    case GA:
      var l = a & RA;
      if (c || (c = vA), t.size != e.size && !l)
        return !1;
      var u = s.get(t);
      if (u)
        return u == e;
      a |= bA, s.set(t, e);
      var M = jo(c(t), c(e), a, i, r, s);
      return s.delete(t), M;
    case ZA:
      if (_a)
        return _a.call(t) == _a.call(e);
  }
  return !1;
}
var JA = 1, XA = Object.prototype, KA = XA.hasOwnProperty;
function $A(t, e, n, a, i, r) {
  var s = n & JA, c = lr(t), l = c.length, u = lr(e), M = u.length;
  if (l != M && !s)
    return !1;
  for (var N = l; N--; ) {
    var g = c[N];
    if (!(s ? g in e : KA.call(e, g)))
      return !1;
  }
  var D = r.get(t), T = r.get(e);
  if (D && T)
    return D == e && T == t;
  var E = !0;
  r.set(t, e), r.set(e, t);
  for (var j = s; ++N < l; ) {
    g = c[N];
    var p = t[g], C = e[g];
    if (a)
      var m = s ? a(C, p, g, e, t, r) : a(p, C, g, t, e, r);
    if (!(m === void 0 ? p === C || i(p, C, n, a, r) : m)) {
      E = !1;
      break;
    }
    j || (j = g == "constructor");
  }
  if (E && !j) {
    var L = t.constructor, S = e.constructor;
    L != S && "constructor" in t && "constructor" in e && !(typeof L == "function" && L instanceof L && typeof S == "function" && S instanceof S) && (E = !1);
  }
  return r.delete(t), r.delete(e), E;
}
var qA = 1, Dr = "[object Arguments]", Tr = "[object Array]", qn = "[object Object]", ed = Object.prototype, Er = ed.hasOwnProperty;
function td(t, e, n, a, i, r) {
  var s = Ma(t), c = Ma(e), l = s ? Tr : dr(t), u = c ? Tr : dr(e);
  l = l == Dr ? qn : l, u = u == Dr ? qn : u;
  var M = l == qn, N = u == qn, g = l == u;
  if (g && $a(t)) {
    if (!$a(e))
      return !1;
    s = !0, M = !1;
  }
  if (g && !M)
    return r || (r = new wt()), s || po(t) ? jo(t, e, n, a, i, r) : HA(t, e, l, n, a, i, r);
  if (!(n & qA)) {
    var D = M && Er.call(t, "__wrapped__"), T = N && Er.call(e, "__wrapped__");
    if (D || T) {
      var E = D ? t.value() : t, j = T ? e.value() : e;
      return r || (r = new wt()), i(E, j, n, a, r);
    }
  }
  return g ? (r || (r = new wt()), $A(t, e, n, a, i, r)) : !1;
}
function ho(t, e, n, a, i) {
  return t === e ? !0 : t == null || e == null || !_n(t) && !_n(e) ? t !== t && e !== e : td(t, e, n, a, ho, i);
}
function Co(t, e) {
  return ho(t, e);
}
function Lo() {
  const [
    t,
    e
  ] = U(f.getData(d.CALL, o.LOCAL_USER_INFO)), [
    n,
    a
  ] = U(f.getData(d.CALL, o.REMOTE_USER_INFO_LIST)), [i, r] = U({}), s = (u) => {
    t.volume !== u.volume && e(u);
  }, c = (u) => {
    if (u.length !== n.length) {
      a(u);
      return;
    }
    Co(u, n) || a(u);
  }, l = {
    [o.LOCAL_USER_INFO]: s,
    [o.REMOTE_USER_INFO_LIST]: c
  };
  return H(() => (f.watch(
    d.CALL,
    l,
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), () => {
    f.unwatch(
      d.CALL,
      l
    );
  }), [l]), H(() => {
    const u = {};
    [t, ...n].forEach((M) => {
      M.isAudioAvailable && (u[M.domId] = M.volume);
    }), Object.keys(u).length !== 0 && r(u);
  }, [t, n]), i;
}
const nd = {
  "player-container": "_player-container_dbx2c_1"
};
function yo(t) {
  const e = Lo(), { isGroupCall: n } = Q(re), {
    streamInfo: a = {},
    showStreamInfo: i = !0,
    isSpkear: r,
    style: s,
    renderAudioStream: c,
    className: l,
    loading: u,
    renderLoading: M,
    isLargeView: N = !1
  } = t, {
    domId: g,
    isAudioAvailable: D,
    displayUserInfo: T
  } = a, E = x([
    l,
    nd["player-container"]
  ]), j = Ie(() => n ? z.isPC ? !0 : !!N : !1, [N, n]);
  return /* @__PURE__ */ I.jsxs("div", { id: g, style: s, className: E, children: [
    !u && (c == null ? void 0 : c({
      volume: e[g],
      isMute: !D
    })),
    u && (M == null ? void 0 : M()),
    i && /* @__PURE__ */ I.jsx(
      uo,
      {
        volume: e[g],
        isSpkear: r,
        isMute: !D,
        displayName: T,
        showUserName: j
      }
    )
  ] });
}
function ad() {
  const [
    t,
    e
  ] = U(f.getData(d.CALL, o.NETWORK_STATUS)), n = (i) => {
    e(i);
  }, a = {
    [o.NETWORK_STATUS]: n
  };
  return H(() => (f.watch(
    d.CALL,
    a,
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), () => {
    f.unwatch(
      d.CALL,
      a
    );
  }), []), t;
}
const id = {
  "pusher-container": "_pusher-container_di26f_1"
}, mo = Le.memo((t) => {
  var y, w;
  const {
    loading: e = !0,
    renderLoading: n,
    renderAudioStream: a,
    isSpkear: i,
    className: r,
    showStreamInfo: s = !0,
    isLargeView: c = !1
  } = t, {
    localUserInfo: {
      domId: l,
      nick: u,
      userId: M,
      isAudioAvailable: N,
      isVideoAvailable: g
    }
  } = Q(ke), D = Q(Bn), { isGroupCall: T } = Q(re), E = ad(), j = Ie(() => {
    if (!E)
      return;
    const b = E.find((B) => B.userId === M);
    return !!(b && b.quality >= 4);
  }, [E]), p = u || M, C = Lo(), m = x([
    r,
    id["pusher-container"]
  ]), L = Ie(() => T ? z.isPC ? !0 : !!c : !1, [c, T]), S = !z.isPC && g && T && c && ((w = (y = D == null ? void 0 : D.button) == null ? void 0 : y.switchCamera) == null ? void 0 : w.show) !== !1;
  return /* @__PURE__ */ I.jsxs("div", { id: l, className: m, children: [
    !e && (a == null ? void 0 : a()),
    e && (n == null ? void 0 : n()),
    s && /* @__PURE__ */ I.jsx(
      uo,
      {
        volume: C[l],
        isSpkear: i,
        isMute: !N,
        displayName: p,
        isMe: !0,
        showUserName: L,
        showSwitchCamera: S,
        showNetWorkStatus: j
      }
    )
  ] }, l);
});
function rd(t) {
  const {
    avatar: e,
    username: n,
    isSmall: a,
    isVideoAvailable: i,
    userId: r,
    classnames: s,
    ...c
  } = t, [l, u] = U("hidden"), M = Zn(), { callType: N, isFloat: g } = Q(re), D = Ie(() => N === $.AUDIO, [N]), [T, E] = U(!M[r]), [j, p] = U(M[r] ? "fill" : "cover"), [C, m] = U(M[r] || e), [L, S] = U(!1), y = x([
    s
  ]);
  H(() => {
    u(D && !a || !D && !i ? "" : "hidden"), L || (E((D || !i) && !M[r]), p(M[r] ? "fill" : "cover"), m(M[r] || e || ye));
  }, [g, a, D, i, M]);
  const w = () => {
    S(!0), p("cover");
  };
  return /* @__PURE__ */ I.jsx(
    dn,
    {
      className: y,
      showLoading: !1,
      avatar: e || ye,
      showAvatar: !z.isPC,
      username: n,
      showVolumn: z.isPC && N === $.AUDIO,
      isMobile: !z.isPC,
      isSmall: a,
      background: C,
      showOverlayer: T,
      fit: j,
      style: { visibility: l, zIndex: 1 },
      ...c,
      onError: w
    }
  );
}
function od() {
  const { layoutMode: t } = Q(Bn), { remoteList: e } = Q(ke), { callStatus: n } = Q(re), [a, i] = U(Mt.LOCAL);
  return H(() => {
    var s;
    if (n === _.CALLING)
      return;
    if ([ra.RemoteInLargeView, ra.LocalInLargeView].includes(t)) {
      i(t);
      return;
    }
    (s = e == null ? void 0 : e[0]) != null && s.isEnter && i(Mt.REMOTE);
  }, [e, t, n]), [a, i];
}
const sd = "_pc_1bung_7", ld = "_float_1bung_16", Vt = {
  "single-stream-container": "_single-stream-container_1bung_1",
  pc: sd,
  "single-call-audio-stream": "_single-call-audio-stream_1bung_12",
  float: ld
};
function cd() {
  const { remoteList: t, localUserInfo: e } = Q(ke), { callType: n, callStatus: a, isFloat: i } = Q(re), [r, s] = od(), c = Ie(() => n === $.AUDIO, [n]), [l, u] = U(!1);
  H(() => {
    var T;
    (T = t == null ? void 0 : t[0]) != null && T.isEnter && u(!c);
  }, [t, c]);
  function M(T) {
    return /* @__PURE__ */ I.jsx(rd, { ...T });
  }
  const N = Ie(() => i ? "#float" : "#single-container", [i]), g = z.isPC && a === _.CONNECTED && !c && !i, D = x([
    Vt["single-stream-container"],
    {
      [Vt.mobile]: !z.isPC,
      [Vt.pc]: z.isPC,
      [Vt.float]: i
    }
  ]);
  return /* @__PURE__ */ I.jsx("div", { id: "single-container", className: D, children: /* @__PURE__ */ I.jsx(Fn, { attach: N, style: { width: "100%", height: "100%", position: "relative" }, children: /* @__PURE__ */ I.jsxs(
    Yu,
    {
      isMobile: !z.isPC,
      bigWindow: r,
      showSmallWindow: l,
      onToggle: s,
      children: [
        /* @__PURE__ */ I.jsx(Xa, { value: Mt.LOCAL, children: /* @__PURE__ */ I.jsx(
          mo,
          {
            loading: a === _.CALLING && (n === $.VIDEO ? !(e != null && e.isVideoAvailable) : !0),
            renderAudioStream: () => {
              var T, E, j;
              return M({
                isVideoAvailable: e.isVideoAvailable,
                avatar: c ? (T = t == null ? void 0 : t[0]) == null ? void 0 : T.avatar : e.avatar,
                username: c ? (E = t == null ? void 0 : t[0]) == null ? void 0 : E.displayUserInfo : e.nick || e.userId,
                isSmall: r !== Mt.LOCAL,
                userId: c ? (j = t == null ? void 0 : t[0]) == null ? void 0 : j.userId : e.userId,
                classnames: Vt["single-call-audio-stream"]
              });
            },
            showStreamInfo: g
          }
        ) }, Mt.LOCAL),
        /* @__PURE__ */ I.jsx(
          Xa,
          {
            value: Mt.REMOTE,
            className: Vt.remote,
            children: t.length !== 0 && a === _.CONNECTED && /* @__PURE__ */ I.jsx(
              yo,
              {
                renderAudioStream: (T) => M({
                  isVideoAvailable: t[0].isVideoAvailable,
                  avatar: t[0].avatar,
                  username: t[0].displayUserInfo,
                  isSmall: r !== Mt.REMOTE,
                  userId: t[0].userId,
                  classnames: Vt["single-call-audio-stream"],
                  ...T
                }),
                showStreamInfo: z.isPC && !c && !i,
                streamInfo: t[0]
              }
            )
          },
          Mt.REMOTE
        )
      ]
    }
  ) }) });
}
const ud = "_mobile_1l7n2_12", Md = "_pulldown_1l7n2_1", ka = {
  "single-container": "_single-container_1l7n2_1",
  "singlecall-tip": "_singlecall-tip_1l7n2_5",
  mobile: ud,
  pulldown: Md
}, Id = Le.memo(() => {
  const { remoteList: t } = Q(ke), { callRole: e, callStatus: n, isFloat: a } = Q(re), i = x([
    ka["single-container"],
    { [ka.mobile]: !z.isPC }
  ]), r = () => {
    if (!a)
      return /* @__PURE__ */ I.jsx(Zr, {});
  }, s = () => {
    var l, u, M;
    if (n === _.CALLING && !a)
      return /* @__PURE__ */ I.jsx(
        Qu,
        {
          avatar: (l = t == null ? void 0 : t[0]) == null ? void 0 : l.avatar,
          username: (u = t == null ? void 0 : t[0]) == null ? void 0 : u.displayUserInfo,
          callRole: e,
          userId: (M = t == null ? void 0 : t[0]) == null ? void 0 : M.userId
        }
      );
  }, c = () => {
    if (!a)
      return /* @__PURE__ */ I.jsx(ro, {});
  };
  return /* @__PURE__ */ I.jsxs("div", { className: i, children: [
    r(),
    s(),
    /* @__PURE__ */ I.jsx(cd, {}),
    /* @__PURE__ */ I.jsx(Br, { className: ka["singlecall-tip"] }),
    c()
  ] });
}), Ad = "_tip_10pm9_5", Qt = {
  "groupcall-waiting-container": "_groupcall-waiting-container_10pm9_1",
  "waiting-mobile": "_waiting-mobile_10pm9_5",
  tip: Ad,
  "groupcall-info": "_groupcall-info_10pm9_9",
  "avatar-group": "_avatar-group_10pm9_21",
  "avatar-item": "_avatar-item_10pm9_29"
};
function dd(t) {
  const e = Zn(), { remoteList: n } = t, a = Q(Yr), { avatar: i, userId: r, displayUserInfo: s } = a || {}, [c, l] = U(!e[r]), [u, M] = U(e[r] ? "fill" : "cover"), [N, g] = U(e[r] || i);
  H(() => {
    l(!e[r]), M(e[r] ? "fill" : "cover"), g(e[r] || i || ye);
  }, [e, r]);
  function D() {
    return /* @__PURE__ */ I.jsx(
      dn,
      {
        className: x([
          Qt["groupcall-waiting-container"],
          Qt["waiting-mobile"]
        ]),
        showLoading: !1,
        showAvatar: !0,
        blur: !0,
        tip: k("Invited group call"),
        showUsername: !0,
        username: s,
        avatar: i || ye,
        theme: z.isPC ? "circle" : "dot",
        isMobile: !z.isPC,
        background: N,
        showOverlayer: c,
        fit: u,
        children: /* @__PURE__ */ I.jsxs("div", { className: Qt["groupcall-info"], children: [
          /* @__PURE__ */ I.jsxs("div", { className: Qt.tip, children: [
            n.length,
            k("people in the call"),
            ":"
          ] }),
          /* @__PURE__ */ I.jsx("div", { className: Qt["avatar-group"], children: n == null ? void 0 : n.map((E) => /* @__PURE__ */ I.jsx(oo, { className: Qt["avatar-item"], image: E.avatar }, E.userId)) })
        ] })
      }
    );
  }
  function T() {
    return /* @__PURE__ */ I.jsx(
      dn,
      {
        className: Qt["groupcall-waiting-container"],
        showLoading: !1,
        avatar: i || ye,
        username: s,
        showAvatar: !z.isPC,
        isMobile: !z.isPC,
        tip: k("Invited group call"),
        background: N,
        showOverlayer: c,
        fit: u
      }
    );
  }
  return z.isPC ? /* @__PURE__ */ I.jsx(T, {}) : /* @__PURE__ */ I.jsx(D, {});
}
function Nd(t) {
  const { isFloat: e } = Q(re), n = 100;
  let {
    // eslint-disable-next-line prefer-const
    rowHeight: a,
    unit: i = "%",
    className: r,
    isMobile: s,
    onHandleFocusChange: c,
    enableFocus: l = !1,
    children: u
  } = t;
  const [M, N] = U(null), g = Ie(() => {
    const p = u.length;
    if (p <= 3)
      return [{
        x: 0,
        y: 0,
        w: 6,
        h: 6
      }, {
        x: 6,
        y: 0,
        w: 6,
        h: 6
      }, {
        x: 3,
        y: 6,
        w: 6,
        h: 6
      }];
    if (p === 4)
      return [{
        x: 0,
        y: 0,
        w: 6,
        h: 6
      }, {
        x: 6,
        y: 0,
        w: 6,
        h: 6
      }, {
        x: 0,
        y: 6,
        w: 6,
        h: 6
      }, {
        x: 6,
        y: 6,
        w: 6,
        h: 6
      }];
    const C = [{
      x: 0,
      y: 0,
      w: 4,
      h: 4
    }];
    for (let m = 1; m < p; m++) {
      const L = C[m - 1].x + 4 === 12;
      C[m] = {
        x: C[m - 1].x + 4 === 12 ? 0 : C[m - 1].x + 4,
        y: C[m - 1].y + (L ? 4 : 0),
        w: 4,
        h: 4
      };
    }
    return s || (p % 3 === 1 && (C[p - 1].x += 2), p % 3 === 2 && (C[p - 1].x += 2, C[p - 2].x += 2)), C;
  }, [u, s]);
  function D(p) {
    p === M ? (N(null), c == null || c(null)) : (N(p), c == null || c(p));
  }
  const T = n / 12;
  a = T;
  const E = Object.keys(Array.from({ length: g.length })), j = Ie(() => {
    const p = JSON.parse(JSON.stringify(g));
    let C, m;
    if (M != null) {
      if (E.length < 5) {
        const L = E.concat();
        L.splice(M, 1), L.unshift(M);
      } else
        m = M % 3, C = Math.floor(M / 3);
      if (E.length < 5) {
        for (let S = 0; S < p.length; S++) {
          const y = p[S];
          S === 0 ? (y.w += 6, y.h += 6) : (y.x = (S - 1) * 4, y.y = 12, y.w = 4, y.h = 4);
        }
        const L = p.shift();
        p.splice(M, 0, L);
      } else {
        let L;
        m === 0 ? (p[M + 1] && (p[M + 1].x += 4), p[M + 2] && (p[M + 2].y += 4), L = {
          x: 0,
          y: C * 4,
          w: 8,
          h: 8
        }) : m === 2 ? (L = {
          x: 4,
          y: C * 4,
          w: 8,
          h: 8
        }, p[M - 1].x = 0, p[M - 1].y += 4) : m === 1 && (L = {
          x: 4,
          y: C * 4,
          w: 8,
          h: 8
        }, p[M + 1] && (p[M + 1].x = 0, p[M + 1].y += 4));
        const S = 3 - m;
        for (let y = M + S; y < p.length; y++) {
          const w = p[y];
          w.y += 4;
        }
        p[M] = L;
      }
      return p;
    }
    return p;
  }, [M, g]);
  return /* @__PURE__ */ I.jsx("div", { className: r, children: u == null ? void 0 : u.map((p, C) => {
    const {
      x: m,
      y: L,
      w: S,
      h: y
    } = j[C];
    let w = {
      width: S * T + i,
      height: y * a + i,
      left: m * T + i,
      top: L * a + i,
      position: "absolute"
    };
    return e && (w = {
      width: "100%",
      height: "100%",
      left: "0px",
      top: "0px",
      position: "absolute"
    }), Le.cloneElement(
      p,
      { style: w, updateFocusItem: () => l && D(C) }
    );
  }) });
}
function ni(t) {
  const {
    index: e,
    children: n,
    className: a,
    style: i,
    updateFocusItem: r
  } = t, s = x([
    `${P}-gridplus-item-container`,
    a
  ]);
  return /* @__PURE__ */ I.jsx(
    "div",
    {
      className: s,
      onClick: () => r == null ? void 0 : r(e),
      style: { gridArea: `gridplus-item-${e}`, ...i },
      children: n
    }
  );
}
ni.displayname = "GridPlusItem";
function gd(t) {
  const e = Zn(), {
    avatar: n,
    username: a,
    visible: i,
    userId: r
  } = t || {}, [s, c] = U(e[r] || n);
  return H(() => {
    c(e[r] || n || ye);
  }, [e, r]), /* @__PURE__ */ I.jsx(
    dn,
    {
      showLoading: !1,
      showAvatar: !1,
      avatar: n || ye,
      username: a,
      showUsername: z.isPC,
      isMobile: !z.isPC,
      showOverlayer: !1,
      blur: !1,
      background: s,
      style: { visibility: i ? "" : "hidden", zIndex: 1 }
    }
  );
}
const Dd = 10;
function So() {
  const [
    t,
    e
  ] = U(f.getData(d.CALL, o.LOCAL_USER_INFO)), [
    n,
    a
  ] = U(f.getData(d.CALL, o.REMOTE_USER_INFO_LIST)), [i, r] = U([]), s = (u) => {
    t.volume !== u.volume && e(u);
  }, c = (u) => {
    if (u.length !== n.length) {
      a(u);
      return;
    }
    Co(u, n) || a(u);
  }, l = {
    [o.LOCAL_USER_INFO]: s,
    [o.REMOTE_USER_INFO_LIST]: c
  };
  return H(() => (f.watch(
    d.CALL,
    l,
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), () => {
    f.unwatch(
      d.CALL,
      l
    );
  }), []), H(() => {
    const u = [];
    [t, ...n].forEach((M) => {
      M.isAudioAvailable && M.volume >= Dd && u.push(M.domId);
    }), !(u.length === 0 && i.length === 0) && r(u);
  }, [t, n]), i;
}
function Td(t) {
  const { avatar: e, userId: n } = t || {}, a = Zn(), [i, r] = U(!a[n]), [s, c] = U({ objectFit: "cover" }), [
    l,
    u
  ] = U(a[n] || e || ye), M = { width: "100%", height: "100%" };
  H(() => {
    a[n] && (c({ objectFit: "fill" }), r(!1), u(a[n] || e || ye));
  }, [a, n]);
  const N = () => {
    c({ objectFit: "cover" }), r(!1), u(ye);
  };
  return /* @__PURE__ */ I.jsx(oi, { showOverlayer: i, theme: "dot", style: { zIndex: 1, position: "absolute", top: 0 }, children: /* @__PURE__ */ I.jsx(
    "img",
    {
      alt: "Failed to load the background image in loading",
      style: { ...M, ...s },
      src: l,
      onError: N
    }
  ) });
}
const Ed = "_mobile_14fkp_7", fd = "_pc_14fkp_10", pd = "_float_14fkp_14", jd = "_center_14fkp_23", hd = "_hidden_14fkp_45", Cd = "_userinfo_14fkp_48", Ke = {
  "stream-container": "_stream-container_14fkp_1",
  mobile: Ed,
  pc: fd,
  float: pd,
  "groupcall-gridplus-container": "_groupcall-gridplus-container_14fkp_19",
  center: jd,
  "two-layout": "_two-layout_14fkp_26",
  hidden: hd,
  userinfo: Cd
};
function Ld() {
  const { localUserInfo: t, remoteList: e } = Q(ke), { callStatus: n, callType: a } = Q(re), { focusItem: i, setFocusItem: r } = Q(si), { isFloat: s } = Q(re), c = So(), l = Ie(() => n === _.CALLING && (a === $.AUDIO && !t.isAudioAvailable || a === $.VIDEO && !t.isVideoAvailable), [t, n, a]);
  function u(D) {
    return /* @__PURE__ */ I.jsx(Td, { ...D });
  }
  function M(D) {
    return /* @__PURE__ */ I.jsx(gd, { ...D });
  }
  const N = Qn(() => e.map((D, T) => /* @__PURE__ */ I.jsx(ni, { index: T + 1, children: /* @__PURE__ */ I.jsx(
    yo,
    {
      className: x({
        [Ke.hidden]: s && !c.includes(D.domId)
      }),
      renderLoading: () => u({
        avatar: D.avatar,
        username: D.displayUserInfo,
        userId: D.userId
      }),
      renderAudioStream: () => M({
        avatar: D.avatar,
        username: D.displayUserInfo,
        visible: !D.isVideoAvailable,
        userId: D.userId
      }),
      loading: !D.isEnter,
      streamInfo: D,
      showStreamInfo: !s,
      isSpkear: c.includes(D.domId),
      isLargeView: i === T + 1
    }
  ) }, D.userId)), [e, c, i]), g = x([
    Ke["groupcall-gridplus-container"],
    {
      [Ke.pc]: z.isPC,
      [Ke.mobile]: !z.isPC,
      [Ke.float]: s,
      [Ke["two-layout"]]: e.length === 1 && i === null && !s
    }
  ]);
  return /* @__PURE__ */ I.jsx(
    "div",
    {
      id: "group-container",
      className: x([
        Ke["stream-container"],
        {
          [Ke.mobile]: !z.isPC,
          [Ke.pc]: z.isPC,
          [Ke.float]: s
        }
      ]),
      children: /* @__PURE__ */ I.jsx(Fn, { attach: s ? "#float" : "#group-container", style: { width: "100%", height: "100%", position: "relative" }, children: /* @__PURE__ */ I.jsxs(
        Nd,
        {
          className: g,
          isMobile: !z.isPC,
          enableFocus: !z.isPC && !s,
          unit: z.isPC ? "%" : "vw",
          onHandleFocusChange: r,
          children: [
            /* @__PURE__ */ I.jsx(ni, { index: 0, children: /* @__PURE__ */ I.jsx(
              mo,
              {
                className: x({
                  [Ke.hidden]: s && !c.includes(t.domId)
                }),
                loading: l,
                showStreamInfo: !s,
                renderLoading: () => u({
                  avatar: t.avatar,
                  username: t.nick || t.userId,
                  userId: t.userId
                }),
                renderAudioStream: () => M({
                  avatar: t.avatar,
                  username: t.nick || t.userId,
                  visible: !t.isVideoAvailable,
                  userId: t.userId
                }),
                isSpkear: c.includes(t.domId),
                isLargeView: i === 0
              }
            ) }, t.userId),
            ...N()
          ]
        }
      ) })
    }
  );
}
const yd = "_mobile_bky89_5", md = "_pulldown_bky89_1", fr = {
  "group-container": "_group-container_bky89_1",
  mobile: yd,
  pulldown: md
};
function Sd() {
  const { remoteList: t, localUserInfo: e } = Q(ke), { callRole: n, callStatus: a, isFloat: i } = Q(re), [r, s] = U(null), c = Ie(() => ({
    focusItem: r,
    setFocusItem: s
  }), [r, s]), l = () => i ? null : /* @__PURE__ */ I.jsx(Zr, {}), u = () => i ? null : /* @__PURE__ */ I.jsx(ro, {}), M = () => a === _.CALLING && n !== De.CALLER && !i ? /* @__PURE__ */ I.jsx(dd, { remoteList: t, callRole: n }) : null, N = () => !i && (n !== De.CALLER && a === _.CONNECTED || n === De.CALLER) ? /* @__PURE__ */ I.jsx(
    dn,
    {
      blur: !0,
      showAvatar: !1,
      showLoading: !1,
      avatar: e.avatar || ye,
      isMobile: !z.isPC
    }
  ) : null, g = x([
    fr["group-container"],
    { [fr.mobile]: !z.isPC }
  ]);
  return /* @__PURE__ */ I.jsx(si.Provider, { value: c, children: /* @__PURE__ */ I.jsxs("div", { className: g, children: [
    l(),
    M(),
    (n === De.CALLER || a === _.CONNECTED) && /* @__PURE__ */ I.jsx(Ld, {}),
    u(),
    N()
  ] }) });
}
let Va = 0;
const ia = [];
function Od(t) {
  const {
    children: e,
    zIndex: n,
    id: a,
    renderCallback: i
  } = t, r = {
    zIndex: n,
    top: "32px",
    width: "100%",
    position: "absolute",
    left: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  };
  return H(() => {
    i == null || i();
  }, []), /* @__PURE__ */ I.jsx("div", { style: r, id: a, children: e });
}
function wd() {
  return new Promise((t) => {
    const e = document.body, n = "tdesign-message-container--top", a = Array.from(e.querySelectorAll(`#${n}`));
    if (a.length < 1) {
      const i = document.createElement("div");
      jr(
        /* @__PURE__ */ I.jsx(
          Od,
          {
            id: n,
            zIndex: 1,
            renderCallback: () => {
              e.appendChild(i);
              const r = Array.from(e.querySelectorAll(`#${n}`));
              t(r[0]);
            }
          }
        ),
        i
      );
    } else
      t(a[0]);
  });
}
async function fa(t, e) {
  const n = await wd(), { content: a, offset: i, onClose: r = ys } = e, s = document.createElement("div");
  Va += 1;
  const c = {
    close: () => {
      ns(s), s.remove(), c.closed = !0;
    },
    key: Va,
    closed: !1
  };
  let l = { ...e.style };
  if (Array.isArray(i) && i.length === 2) {
    const [u, M] = i;
    l = {
      left: u,
      top: M,
      ...l,
      position: "relative"
    };
  }
  return new Promise((u) => {
    jr(
      /* @__PURE__ */ I.jsx(
        Qr,
        {
          ...e,
          theme: t,
          style: l,
          onClose: (M) => {
            r(M), c.close();
          },
          children: a
        },
        Va
      ),
      s
    ), n.appendChild(s), ia.push(c), u(c);
  });
}
function Ud(t) {
  fa("info", t);
}
function zd(t) {
  fa("warn", t);
}
function xd(t) {
  fa("success", t);
}
function vd(t) {
  fa("error", t);
}
function Rd() {
  ia == null || ia.forEach((t) => t.close());
}
const bd = {
  info: Ud,
  warn: zd,
  success: xd,
  error: vd,
  closeAll: Rd
}, Oo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNzYwOTYxIDkuMzMxNTRDMC4wMDEyMzUwNyA3LjEzMzcxIDAuOTYyOTY4IDQuNzczMjMgMi44MzM0NSAzLjM5MDk3QzQuMjUxNTIgMi4zNDMwNCA1LjY3NjAzIDEuMjg0NyA2LjQ4ODg5IDAuNjgwMTI0QzYuODc1MTUgMC4zOTI4MzcgNy40MTY2MSAwLjQ1NTY4IDcuNzI4NDEgMC44MjIzOTdMMTIuMTU4IDYuMDMyMTRDMTIuNDQ3NiA2LjM3Mjc1IDEyLjQ0NzcgNi44NzI5NSAxMi4xNTgzIDcuMjEzNzNMOS40NDIyIDEwLjQxMTlDOS4xOTQ5NiAxMC43MDMxIDkuMTUzNzggMTEuMTE4MyA5LjM0OTI1IDExLjQ0NjVDMTAuMjI5MyAxMi45MjM4IDExLjE5NSAxNC4xODkxIDEyLjUgMTUuNDkzOEMxMy44MTI3IDE2LjgwNiAxNS4wNzc4IDE3Ljc1MjkgMTYuNTYzNSAxOC42MzA4QzE2Ljg5MTkgMTguODI0OCAxNy4zMDY1IDE4Ljc4MzYgMTcuNTk3NCAxOC41MzY4TDIwLjc4MjYgMTUuODM1MUMyMS4xMjM0IDE1LjU0NTkgMjEuNjIzNyAxNS41NDYxIDIxLjk2NDMgMTUuODM1NkwyNy4xNzgzIDIwLjI2NjJDMjcuNTQ0MSAyMC41NzcgMjcuNjA2NiAyMS4xMTc5IDI3LjMyMTMgMjEuNTAzOEwyNC41OTM3IDI1LjE5MzZDMjMuMjIyNSAyNy4wNDg2IDIwLjg4MDQgMjcuOTkxOSAxOC42OTg3IDI3LjI0MTNDMTQuNjY1OCAyNS44NTM4IDEwLjg3ODEgMjMuNTUxMSA3LjY1OTIyIDIwLjMzMzFDNC40NDk1NyAxNy4xMjQ0IDIuMTUwMTUgMTMuMzUwMyAwLjc2MDk2MSA5LjMzMTU0WiIgZmlsbD0iIzEyQjk2OSIvPgo8L3N2Zz4K", _d = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi42NzE2IDYuMTE2OTJDMTIuNDY4NyA2LjIxODY5IDEyLjM0MDYgNi40MjYyNSAxMi4zNDA2IDYuNjUzMjRWOS4zNDY0OEMxMi4zNDA2IDkuNTczNDggMTIuNDY4NyA5Ljc4MTA1IDEyLjY3MTYgOS44ODI4MUwxNS40NzQ0IDExLjI4ODRDMTUuNjA3NCAxMS4zNTUxIDE1Ljc2NCAxMS4yNTg0IDE1Ljc2NCAxMS4xMDk2TDE1Ljc2NCA0Ljg4OTk2QzE1Ljc2NCA0Ljc0MTE3IDE1LjYwNzQgNC42NDQ0OCAxNS40NzQ0IDQuNzExMThMMTIuNjcxNiA2LjExNjkyWiIgZmlsbD0iIzEyQjk2OSIvPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9iXzE5NzdfMTE2MzApIj4KPHJlY3QgeD0iMC42NjY3NDgiIHk9IjIuODkzNTUiIHdpZHRoPSIxMC42NjY3IiBoZWlnaHQ9IjEwLjIxMjgiIHJ4PSIxLjUiIGZpbGw9IiMxMkI5NjkiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9iXzE5NzdfMTE2MzAiIHg9Ii03LjMzMzI1IiB5PSItNS4xMDY0NSIgd2lkdGg9IjI2LjY2NjYiIGhlaWdodD0iMjYuMjEyNiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVHYXVzc2lhbkJsdXIgaW49IkJhY2tncm91bmRJbWFnZUZpeCIgc3RkRGV2aWF0aW9uPSI0Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0iaW4iIHJlc3VsdD0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl8xOTc3XzExNjMwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl8xOTc3XzExNjMwIiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8L2RlZnM+Cjwvc3ZnPgo=", kd = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjkxNjUgNy41NjkzN1Y2LjgzODg3SDMuNDE2NVY3LjU2OTM3QzMuNDE2NSAxMC4xMDA3IDUuNDY4NTMgMTIuMTUyNyA3Ljk5OTg0IDEyLjE1MjdDMTAuNTMxMSAxMi4xNTI3IDEyLjU4MzIgMTAuMTAwNyAxMi41ODMyIDcuNTY5MzZWNi44Mzg4N0gxNC4wODMyVjcuNTY5MzZDMTQuMDgzMiAxMC42NzUxIDExLjc1NTcgMTMuMjM3MyA4Ljc0OTg4IDEzLjYwNjlWMTQuOTA4OUg3LjI0OTg4VjEzLjYwNjlDNC4yNDM5OCAxMy4yMzc0IDEuOTE2NSAxMC42NzUyIDEuOTE2NSA3LjU2OTM3WiIgZmlsbD0iIzEyQjk2OSIvPgo8cmVjdCB4PSI0LjY2Njc1IiB5PSIxLjA5MDgyIiB3aWR0aD0iNi42NjY2NyIgaGVpZ2h0PSI5Ljg5NjkiIHJ4PSIzLjMzMzMzIiBmaWxsPSIjMTJCOTY5Ii8+Cjwvc3ZnPgo=", Vd = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi42NzE2IDUuNzc2NTlDMTIuNDY4NyA1Ljg3ODM1IDEyLjM0MDYgNi4wODU5MSAxMi4zNDA2IDYuMzEyOTFWOS4wMDYxNEMxMi4zNDA2IDkuMjMzMTUgMTIuNDY4NyA5LjQ0MDcyIDEyLjY3MTYgOS41NDI0OEwxNS40NzQ0IDEwLjk0OEMxNS42MDc0IDExLjAxNDcgMTUuNzY0IDEwLjkxOCAxNS43NjQgMTAuNzY5M0wxNS43NjQgNC41NDk2MkMxNS43NjQgNC40MDA4NCAxNS42MDc0IDQuMzA0MTUgMTUuNDc0NCA0LjM3MDg1TDEyLjY3MTYgNS43NzY1OVoiIGZpbGw9IiNBREFEQUQiLz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYl8xMzFfMTQ0OSkiPgo8cmVjdCB4PSIwLjY2Njc0OCIgeT0iMi41NTMyMiIgd2lkdGg9IjEwLjY2NjciIGhlaWdodD0iMTAuMjEyOCIgcng9IjEuNSIgZmlsbD0iI0FEQURBRCIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2JfMTMxXzE0NDkiIHg9Ii03LjMzMzI1IiB5PSItNS40NDY3OCIgd2lkdGg9IjI2LjY2NjciIGhlaWdodD0iMjYuMjEyNiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVHYXVzc2lhbkJsdXIgaW49IkJhY2tncm91bmRJbWFnZUZpeCIgc3RkRGV2aWF0aW9uPSI0Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0iaW4iIHJlc3VsdD0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl8xMzFfMTQ0OSIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXJfMTMxXzE0NDkiIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==", Qd = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjkxNjUgNy41NjkzN1Y2LjgzODg3SDMuNDE2NVY3LjU2OTM3QzMuNDE2NSAxMC4xMDA3IDUuNDY4NTMgMTIuMTUyNyA3Ljk5OTg0IDEyLjE1MjdDMTAuNTMxMSAxMi4xNTI3IDEyLjU4MzIgMTAuMTAwNyAxMi41ODMyIDcuNTY5MzZWNi44Mzg4N0gxNC4wODMyVjcuNTY5MzZDMTQuMDgzMiAxMC42NzUxIDExLjc1NTcgMTMuMjM3MyA4Ljc0OTg4IDEzLjYwNjlWMTQuOTA4OUg3LjI0OTg4VjEzLjYwNjlDNC4yNDM5OCAxMy4yMzc0IDEuOTE2NSAxMC42NzUyIDEuOTE2NSA3LjU2OTM3WiIgZmlsbD0iI0FEQURBRCIvPgo8cmVjdCB4PSI0LjY2Njc1IiB5PSIxLjA5MDgyIiB3aWR0aD0iNi42NjY2NyIgaGVpZ2h0PSI5Ljg5NjkiIHJ4PSIzLjMzMzMzIiBmaWxsPSIjQURBREFEIi8+Cjwvc3ZnPgo=", Bd = "_hidden_1es4b_1", Yd = "_video_1es4b_1", Gd = "_earphone_1es4b_1", Fd = "_info_1es4b_1", Zd = "_icon_1es4b_1", Wd = "_camera_1es4b_1", Pd = "_micphone_1es4b_1", he = {
  "floating-window-pc-groupcall-container": "_floating-window-pc-groupcall-container_1es4b_1",
  "click-overlay": "_click-overlay_1es4b_1",
  "call-status": "_call-status_1es4b_1",
  "video-stream": "_video-stream_1es4b_1",
  hidden: Bd,
  "audio-stream": "_audio-stream_1es4b_1",
  video: Yd,
  earphone: Gd,
  info: Fd,
  "device-status": "_device-status_1es4b_1",
  icon: Zd,
  camera: Wd,
  micphone: Pd,
  "floating-window-h5-groupcall-container": "_floating-window-h5-groupcall-container_1es4b_1"
};
function Hd(t) {
  const { hasVideo: e, clickable: n } = t, { isGroupCall: a, callStatus: i } = Q(re), { isFloat: r } = Q(re), { localUserInfo: { isAudioAvailable: s, isVideoAvailable: c } } = Q(ke), l = li(), u = c ? _d : Vd, M = s ? kd : Qd, N = () => {
    const D = x([
      he["video-stream"]
    ]);
    return /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
      /* @__PURE__ */ I.jsx(
        "div",
        {
          className: D,
          id: "float"
        }
      ),
      !e && /* @__PURE__ */ I.jsxs("div", { className: he["audio-stream"], children: [
        /* @__PURE__ */ I.jsx("div", { className: he.earphone, children: /* @__PURE__ */ I.jsx(ie, { url: Oo }) }),
        /* @__PURE__ */ I.jsx("div", { className: he.info, children: i === _.CONNECTED ? l : k("wait to be called") })
      ] })
    ] });
  }, g = x([
    {
      [he["floating-window-h5-groupcall-container"]]: !z.isPC,
      [he["floating-window-pc-groupcall-container"]]: z.isPC
    }
  ]);
  return /* @__PURE__ */ I.jsxs(
    "div",
    {
      onClick: () => n && X.toggleMinimize(),
      className: g,
      children: [
        /* @__PURE__ */ I.jsx("div", { className: he["click-overlay"] }),
        /* @__PURE__ */ I.jsx(
          "div",
          {
            className: x([
              he["call-status"],
              {
                [he.float]: r,
                [he.video]: e
              }
            ]),
            children: N()
          }
        ),
        a && r && /* @__PURE__ */ I.jsxs("div", { className: he["device-status"], children: [
          /* @__PURE__ */ I.jsx(
            "div",
            {
              className: x([
                he.icon,
                he.camera
              ]),
              children: /* @__PURE__ */ I.jsx(ie, { url: u })
            }
          ),
          /* @__PURE__ */ I.jsx(
            "div",
            {
              className: x([
                he.icon,
                he.micphone
              ]),
              children: /* @__PURE__ */ I.jsx(ie, { url: M })
            }
          )
        ] })
      ]
    }
  );
}
const Jd = "_video_1wchz_1", Xd = "_info_1wchz_1", Kd = "_hidden_1wchz_1", $d = "_earphone_1wchz_1", qd = "_icon_1wchz_1", eN = "_camera_1wchz_1", tN = "_micphone_1wchz_1", nN = "_tip_1wchz_1", xe = {
  "floating-window-h5-singlecall-container": "_floating-window-h5-singlecall-container_1wchz_1",
  "audio-call": "_audio-call_1wchz_1",
  "click-overlay": "_click-overlay_1wchz_1",
  "call-status": "_call-status_1wchz_1",
  video: Jd,
  info: Xd,
  "video-stream": "_video-stream_1wchz_1",
  hidden: Kd,
  "audio-stream": "_audio-stream_1wchz_1",
  earphone: $d,
  "device-status": "_device-status_1wchz_1",
  icon: qd,
  camera: eN,
  micphone: tN,
  tip: nN,
  "floating-window-pc-singlecall-container": "_floating-window-pc-singlecall-container_1wchz_1"
};
function aN(t) {
  const { hasVideo: e, clickable: n } = t, { callStatus: a, callType: i } = Q(re), { isFloat: r } = Q(re), s = li(), c = () => {
    const u = x([
      xe["video-stream"],
      {
        [xe.hidden]: !e
      }
    ]);
    return /* @__PURE__ */ I.jsxs(I.Fragment, { children: [
      /* @__PURE__ */ I.jsx("div", { className: u, id: "float" }),
      e ? /* @__PURE__ */ I.jsx("div", { className: xe.info, children: a === _.CONNECTED ? "" : k("wait to be called") }) : /* @__PURE__ */ I.jsxs("div", { className: xe["audio-stream"], children: [
        /* @__PURE__ */ I.jsx("div", { className: xe.earphone, children: /* @__PURE__ */ I.jsx(ie, { url: Oo }) }),
        /* @__PURE__ */ I.jsx("div", { className: xe.info, children: a === _.CONNECTED ? s : k("wait to be called") })
      ] })
    ] });
  }, l = x([
    {
      [xe["floating-window-h5-singlecall-container"]]: !z.isPC,
      [xe["floating-window-pc-singlecall-container"]]: z.isPC,
      [xe["audio-call"]]: i === $.AUDIO
    }
  ]);
  return /* @__PURE__ */ I.jsxs("div", { onClick: () => {
    n && X.toggleMinimize();
  }, className: l, children: [
    /* @__PURE__ */ I.jsx("div", { className: xe["click-overlay"] }),
    /* @__PURE__ */ I.jsx(
      "div",
      {
        className: x([
          [xe["call-status"]],
          {
            [xe.float]: r,
            [xe.video]: e
          }
        ]),
        children: c()
      }
    )
  ] });
}
const iN = {
  touch: {
    start: "onTouchStart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "onMouseDown",
    move: "mousemove",
    stop: "mouseup"
  }
}, Bt = iN[z.isH5 ? "touch" : "mouse"];
function pr(t) {
  return z.isH5 && (t = t.touches[0]), { clientX: t.clientX, clientY: t.clientY };
}
function rN(t) {
  var S;
  const {
    nodeRef: e,
    children: n,
    onMoveStart: a,
    onMoveEnd: i,
    onPositionChange: r,
    initialPosition: s = { left: "0px", top: "0px" }
  } = t, c = at(!1), l = at({}), u = at({ left: 0, top: 0 }), [M, N] = U(s), [g, D] = U();
  H(() => () => {
    e.current && (e.current.ownerDocument.removeEventListener(Bt.move, C), e.current.ownerDocument.removeEventListener(Bt.stop, m));
  }, [e.current]);
  const T = (y) => {
    var ge, se;
    const { clientX: w, clientY: b } = pr(y), B = w - ((ge = e.current) == null ? void 0 : ge.getBoundingClientRect().left), F = b - ((se = e.current) == null ? void 0 : se.getBoundingClientRect().top), oe = document.documentElement.clientWidth, Ae = document.documentElement.clientHeight, K = e.current.offsetWidth, ue = e.current.offsetHeight;
    return { oW: B, oH: F, htmlWidth: oe, htmlHeight: Ae, bWidth: K, bHeight: ue };
  }, E = (y) => {
    const { clientX: w, clientY: b } = pr(y), B = w - l.current.oW, F = b - l.current.oH;
    return { left: B, top: F };
  }, j = (y) => {
    c.current = !0, l.current = T(y), u.current = E(y), N({ left: "0px", top: "0px" }), e.current.ownerDocument.addEventListener(Bt.move, C), e.current.ownerDocument.addEventListener(Bt.stop, m);
  }, p = (y) => {
    a == null || a();
    let { left: w, top: b } = E(y);
    w < 0 ? w = 0 : w > l.current.htmlWidth - l.current.bWidth && (w = l.current.htmlWidth - l.current.bWidth), b < 0 ? b = 0 : b > l.current.htmlHeight - l.current.bHeight && (b = l.current.htmlHeight - l.current.bHeight), u.current = { left: w, top: b }, r == null || r({ left: w, top: b }), D({ left: w, top: b });
  }, C = (y) => {
    c.current && p(y);
  }, m = (y) => {
    c.current = !1;
    let w = u.current.left;
    w < (l.current.htmlWidth - l.current.bWidth) / 2 ? w = 0 : w = l.current.htmlWidth - l.current.bWidth, u.current = z.isH5 ? { left: w, top: u.current.top } : { left: u.current.left, top: u.current.top }, setTimeout(() => {
      i == null || i();
    }, 0), e.current.ownerDocument.removeEventListener(Bt.move, C), e.current.ownerDocument.removeEventListener(Bt.stop, m);
  }, L = Ie(
    () => `translate(${u.current.left}px, ${u.current.top}px)`,
    [u.current]
  );
  return /* @__PURE__ */ I.jsx(I.Fragment, { children: Le.cloneElement(n, {
    style: {
      ...((S = n == null ? void 0 : n.props) == null ? void 0 : S.style) || {},
      position: "absolute",
      zIndex: 999,
      touchAction: "none",
      ...M,
      transform: L,
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    [Bt.start]: j
  }) });
}
function oN(t) {
  const { isGroupCall: e } = Q(re), n = at(), [a, i] = U(!0), r = t.show ? "" : "hidden";
  return /* @__PURE__ */ I.jsx(
    rN,
    {
      nodeRef: n,
      initialPosition: { right: "0px", top: "100px" },
      onMoveStart: () => i(!1),
      onMoveEnd: () => i(!0),
      children: /* @__PURE__ */ I.jsx("div", { ref: n, style: { visibility: r }, children: e ? /* @__PURE__ */ I.jsx(Hd, { clickable: a, ...t }) : /* @__PURE__ */ I.jsx(aN, { clickable: a, ...t }) })
    }
  );
}
const sN = "_float_pyzih_86", lN = "_mobile_pyzih_90", Qa = {
  "tuicallkit-container": "_tuicallkit-container_pyzih_79",
  float: sN,
  mobile: lN
};
function pa(t) {
  const {
    style: e,
    className: n,
    allowedMinimized: a = !0,
    allowedFullScreen: i = !0,
    videoDisplayMode: r = sn.COVER,
    videoResolution: s = ln.RESOLUTION_1080P,
    beforeCalling: c,
    afterCalling: l,
    onMinimized: u
  } = t, [M, N] = U(f.getData(d.CALL, o.CALL_STATUS)), [g, D] = U(f.getData(d.CALL, o.IS_GROUP)), [
    T,
    E
  ] = U(f.getData(d.CALL, o.CALLER_USER_INFO)), [
    j,
    p
  ] = U(f.getData(d.CALL, o.LOCAL_USER_INFO)), [
    C,
    m
  ] = U(f.getData(d.CALL, o.REMOTE_USER_INFO_LIST)), [L, S] = U(f.getData(d.CALL, o.CALL_MEDIA_TYPE)), [y, w] = U(f.getData(d.CALL, o.CALL_ROLE)), [b, B] = U(f.getData(d.CALL, o.IS_EAR_PHONE)), [F, oe] = U(!1), [
    Ae,
    K
  ] = U(f.getData(d.CALL, o.ENABLE_VIRTUAL_BACKGROUND)), [
    ue,
    ge
  ] = U(f.getData(d.CALL, o.IS_SHOW_ENABLE_VIRTUAL_BACKGROUND)), [
    se,
    Te
  ] = U(f.getData(d.CALL, o.IS_MUTE_SPEAKER)), ot = So(), Ve = Ie(() => ({
    callStatus: M,
    callRole: y,
    callType: L,
    isEarPhone: b,
    isGroupCall: g,
    isFloat: F,
    allowedMinimized: a,
    allowedFullScreen: i,
    enableVirtualBackground: Ae,
    isShowEnableVirtualBackground: ue,
    isMuteSpeaker: se
  }), [
    M,
    y,
    L,
    b,
    g,
    F,
    i,
    Ae,
    ue,
    se
  ]), st = Ie(() => ({
    localUserInfo: j,
    remoteList: C
  }), [j, C]), [
    Et,
    $e
  ] = U(f.getData(d.CALL, o.CUSTOM_UI_CONFIG)), lt = x([
    n,
    Qa["tuicallkit-container"],
    {
      [Qa.mobile]: !z.isPC,
      [Qa.float]: F
    }
  ]), qe = (G) => {
    N(G);
  }, Qe = (G) => {
    D(G);
  }, He = (G) => {
    E(G);
  }, et = (G) => {
    p(G);
  }, me = (G) => {
    m(G);
  }, ct = (G) => {
    S(G);
  }, ft = (G) => {
    w(G);
  }, xt = (G) => {
    B(G);
  }, qt = (G) => {
    G.text && bd[G.type || "info"]({ content: G.text });
  }, vt = (G) => {
    oe(G);
  }, Dn = (G) => {
    K(G);
  }, pt = (G) => {
    ge(G);
  }, tt = (G) => {
    $e(G);
  }, Rt = (G) => {
    Te(G);
  }, bt = {
    [o.CALL_STATUS]: qe,
    [o.IS_GROUP]: Qe,
    [o.CALLER_USER_INFO]: He,
    [o.LOCAL_USER_INFO_EXCLUDE_VOLUMN]: et,
    [o.REMOTE_USER_INFO_EXCLUDE_VOLUMN_LIST]: me,
    [o.CALL_MEDIA_TYPE]: ct,
    [o.CALL_ROLE]: ft,
    [o.IS_EAR_PHONE]: xt,
    [o.TOAST_INFO]: qt,
    [o.CUSTOM_UI_CONFIG]: tt,
    [o.ENABLE_VIRTUAL_BACKGROUND]: Dn,
    [o.IS_SHOW_ENABLE_VIRTUAL_BACKGROUND]: pt,
    [o.IS_MUTE_SPEAKER]: Rt
  };
  return qo(() => {
    var Be;
    const G = (Be = document.documentElement.dataset) == null ? void 0 : Be.uikitTheme;
    ["light", "dark"].indexOf(G) === -1 && (document.documentElement.dataset.uikitTheme = "light");
  }, []), H(() => (f.watch(
    d.CALL,
    bt,
    {
      notifyRangeWhenWatch: o.MYSELF
    }
  ), f.watch(d.CALL, {
    [o.IS_MINIMIZED]: vt
  }), () => {
    f.unwatch(
      d.CALL,
      { ...bt, [o.IS_MINIMIZED]: vt }
    );
  }), []), H(() => {
    X.enableFloatWindow(a), X.setVideoDisplayMode(r), X.setVideoResolution(s), X.setCallback({
      beforeCalling: c,
      afterCalling: l,
      onMinimized: u
    });
  }, [
    c,
    l,
    X,
    r,
    s,
    a,
    u
  ]), M !== _.IDLE && /* @__PURE__ */ I.jsx(ke.Provider, { value: st, children: /* @__PURE__ */ I.jsx(Yr.Provider, { value: T, children: /* @__PURE__ */ I.jsx(re.Provider, { value: Ve, children: /* @__PURE__ */ I.jsxs(Bn.Provider, { value: Et, children: [
    /* @__PURE__ */ I.jsxs("div", { style: { ...e }, className: lt, id: "tuicallkit-id", children: [
      !g && /* @__PURE__ */ I.jsx(Id, {}),
      g && /* @__PURE__ */ I.jsx(Sd, {})
    ] }),
    /* @__PURE__ */ I.jsx(Fn, { attach: "body", children: /* @__PURE__ */ I.jsx(
      oN,
      {
        show: F,
        hasVideo: g ? ot.length !== 0 : L === $.VIDEO,
        isAudioAvailable: j.isAudioAvailable
      }
    ) })
  ] }) }) }) });
}
const cN = (t) => (t.component("TUICallKit", { server: X }), X.bindTUICore(t), pa), uN = (t) => {
  t.component("TUICallKit", pa), console.log("TUICallKit&mini installed", t);
};
pa.plugin = cN;
pa.install = uN;
const TN = {
  AUDIO_CALL: 1,
  VIDEO_CALL: 2
}, EN = "3.3.8";
export {
  $ as CallMediaType,
  DN as CallMessage,
  De as CallRole,
  Wt as FeatureButton,
  ra as LayoutMode,
  o as NAME,
  fe as STATUS,
  d as StoreName,
  pa as TUICallKit,
  X as TUICallKitServer,
  TN as TUICallType,
  z as TUIGlobal,
  f as TUIStore,
  EN as Version,
  sn as VideoDisplayMode,
  ln as VideoResolution,
  uN as install,
  cN as plugin,
  k as t,
  Ct as uiDesign
};
